// sui-quiz.js
// Basit durum yönetimi: geçmiş (history)
const quizState = {
    history: [],
    answers: {},
    marketingConsent: false,
    customerSyncTriggered: false,
};
const CUSTOMER_SYNC_ENDPOINT =
    (typeof window !== 'undefined' && typeof window.__QUIZ_CUSTOMER_ENDPOINT__ === 'string')
        ? window.__QUIZ_CUSTOMER_ENDPOINT__
        : null;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ADULT_MATTRESS_BASE_TAG = 'quiz-adult-mattress';
const ADULT_HEAVY_OK_TAG = 'quiz-heavy-ok';
const ADULT_HEAVY_WEIGHT_THRESHOLD = 100;
const ADULT_EXTREME_SOFTNESS_TAG = 'quiz-softness-extreme-ok';
const ADULT_ACCESSORY_ALWAYS_TAG = 'quiz-adult-always';
const ADULT_ACCESSORY_FALLBACK = 'yorgan';
const CHILD_MATTRESS_TAG = 'quiz-child-mattress';
const CHILD_ACCESSORY_MOONIE_TAG = 'quiz-child-accessory-moonie';
const CHILD_ACCESSORY_COSY_JR_QUILT_TAG = 'quiz-child-accessory-cosy-jr-quilt';
const CHILD_ACCESSORY_RAIN_PROTECTOR_TAG = 'quiz-child-accessory-rain-protector';
const CHILD_FURNITURE_CRIB_TAG = 'quiz-furniture-crib';
const CHILD_FURNITURE_MONTESSORI_TAG = 'quiz-furniture-montessori';
const CHILD_FURNITURE_NEXT_TO_ME_TAG = 'quiz-furniture-next-to-me';
const CHILD_PILLOW_BABYKID_HANDLE = 'babykid-yastik';
const CHILD_PILLOW_ORIGINAL_HANDLE = 'original-yastik';
const CHILD_PILLOW_BUBBLE_HANDLE = 'bubble-yastik';
const CHILD_PILLOW_WAVE_HANDLE = 'wave-yastik';
const MATERNITY_PILLOW_MOM_HANDLE = 'mom-yastik';
const CHILD_MATTRESS_HANDLES = {
    newborn: 'newborn',
    twist: 'twist',
    doaJr: 'doa-jr',
    uniqJr: 'uniq-jr',
};
const SOFTNESS_LABEL_TO_TAG = {
    'Yumuşak': 'quiz-softness-soft',
    'Orta': 'quiz-softness-medium',
    'Sert': 'quiz-softness-firm',
};
const SOFTNESS_QUERY_TAGS = Object.values(SOFTNESS_LABEL_TO_TAG);
const PILLOW_PROFILE_TO_TAG = {
    'Yuksek': 'pillow-high-profile',
    'Orta': 'pillow-medium-profile',
    'Alcak': 'pillow-low-profile',
};
const PILLOW_FIRMNESS_TO_TAG = {
    'Sert': 'pillow-firm',
    'Orta': 'pillow-medium',
    'Yumuşak': 'pillow-soft',
};
const PILLOW_PREF_TO_TAG = {
    'Yuksek': PILLOW_PROFILE_TO_TAG['Yuksek'],
    'Orta': PILLOW_PROFILE_TO_TAG['Orta'],
    'Alcak': PILLOW_PROFILE_TO_TAG['Alcak'],
    'Sert': PILLOW_FIRMNESS_TO_TAG['Sert'],
    'Yumuşak': PILLOW_FIRMNESS_TO_TAG['Yumuşak'],
};
const PILLOW_BASE_TAG = 'quiz-pillow-product';
const PILLOW_ORIGINAL_TAG = 'quiz-pillow-original';
const PILLOW_WAVE_TAG = 'quiz-pillow-wave';
const PILLOW_COSY_TAG = 'quiz-pillow-cosy';
function ensureSessionId() {
    if (!quizState.sessionId) {
        const rand = Math.random().toString(16).slice(2, 10);
        quizState.sessionId = `sui-${Date.now()}-${rand}`;
        if (window.SuiQuizLogger && typeof window.SuiQuizLogger.initSession === 'function') {
            try { window.SuiQuizLogger.initSession(quizState.sessionId); } catch (e) { }
        }
    } else if (window.SuiQuizLogger && typeof window.SuiQuizLogger.initSession === 'function') {
        try { window.SuiQuizLogger.initSession(quizState.sessionId); } catch (e) { }
    }
    return quizState.sessionId;
}
function cloneForLog(value) {
    try {
        return JSON.parse(JSON.stringify(value));
    } catch (e) {
        return value;
    }
}
function buildAnswerLog() {
    if (!quizState.answers) return [];
    return Object.entries(quizState.answers).map(([questionId, answerValue]) => ({
        question_id: questionId,
        answer_value: cloneForLog(answerValue),
    }));
}
function buildRecommendedLog(products) {
    if (!Array.isArray(products)) return [];
    return products.map((p) => {
        const handle = typeof p.handle === 'string' ? p.handle : ((p.url || '').match(/\/products\/([^\/?#]+)/) || [])[1] || null;
        return {
            handle: cloneForLog(handle),
            title: cloneForLog(p.title || ''),
            type: cloneForLog(p.productType || p.type || null),
            url: cloneForLog(p.url || null),
            price: cloneForLog(p.price || null),
            currency: cloneForLog(p.currency || null),
        };
    });
}
function getQuizEmail() {
    const email =
        quizState.answers && typeof quizState.answers.email === 'string'
            ? quizState.answers.email.trim()
            : '';
    return EMAIL_PATTERN.test(email) ? email : '';
}
function shouldSyncCustomer() {
    return !!(CUSTOMER_SYNC_ENDPOINT && !quizState.customerSyncTriggered && getQuizEmail());
}
async function syncShopifyCustomer() {
    if (!shouldSyncCustomer()) return false;

    const email = getQuizEmail();
    if (!email) return false;

    quizState.customerSyncTriggered = true;

    try {
        const response = await fetch(CUSTOMER_SYNC_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                session_id: ensureSessionId(),
                email,
                marketing_consent: !!quizState.marketingConsent,
                answers: cloneForLog(quizState.answers || {}),
            }),
        });

        if (!response.ok) {
            const detail = await response.text().catch(() => '');
            console.warn('[Quiz] Shopify customer sync failed:', response.status, detail);
            return false;
        }

        return true;
    } catch (error) {
        console.warn('[Quiz] Shopify customer sync request failed:', error);
        return false;
    }
}
function emitQuizCompletionLog() {
    if (!('recommendedLog' in quizState)) return;
    if (quizState.aiResponse === undefined) return;
    if (quizState.completionLogged) return;
    const payload = {
        session_id: ensureSessionId(),
        flow: (quizState.answers && quizState.answers.audience) || null,
        answers: buildAnswerLog(),
        recommended: cloneForLog(quizState.recommendedLog),
        ai_response: quizState.aiResponse,
    };
    try {
    } catch (e) { }
    const supaLogger = window.SuiQuizLogger;
    if (supaLogger && typeof supaLogger.markCompleted === 'function') {
        try { supaLogger.markCompleted({ recommended: payload.recommended, aiResponse: payload.ai_response }); } catch (e) { }
    }
    quizState.completionLogged = true;
}
function goTo(nextId, currentId) {
    if (currentId) {
        quizState.history.push(currentId);
    }
    const logger = window.SuiQuizLogger;
    if (logger && typeof logger.syncProgress === 'function') {
        try { logger.syncProgress({ answers: quizState.answers, history: quizState.history }); } catch (e) { }
    }
    renderQuestion(nextId);
}
function goBack() {
    const prev = quizState.history.pop();
    const logger = window.SuiQuizLogger;
    if (logger && typeof logger.syncProgress === 'function') {
        try { logger.syncProgress({ answers: quizState.answers, history: quizState.history }); } catch (e) { }
    }
    if (prev) {
        renderQuestion(prev);
    } else {
        renderQuestion('email');
    }
}
function restartQuiz() {
    quizState.history = [];
    quizState.answers = {};
    delete quizState.self;
    delete quizState.partner;
    delete quizState.bedSide;
    delete quizState.sessionId;
    delete quizState.recommendedLog;
    delete quizState.aiResponse;
    delete quizState[MATTRESS_DECISION_STATE_KEY];
    quizState.marketingConsent = false;
    quizState.customerSyncTriggered = false;
    quizState.completionLogged = false;
    const logger = window.SuiQuizLogger;
    if (logger && typeof logger.syncProgress === 'function') {
        try { logger.syncProgress({ answers: quizState.answers, history: quizState.history }); } catch (e) { }
    }
    ensureSessionId();
    renderQuestion('email');
}
function scrollQuizToTop() {
    const quizWrapper = document.querySelector('.sui-quiz');
    if (!quizWrapper) return;
    const rect = quizWrapper.getBoundingClientRect();
    const absoluteTop = rect.top + window.pageYOffset;
    const targetTop = Math.max(absoluteTop - 12, 0);
    try {
        window.scrollTo({ top: targetTop, left: 0, behavior: 'auto' });
    } catch (e) {
        window.scrollTo(0, targetTop);
    }
}
function normalizeContinueButtons(scopeEl) {
    if (!scopeEl) return;
    const buttons = scopeEl.querySelectorAll('button.quiz-next');
    buttons.forEach((btn) => {
        const txt = (btn.textContent || '').trim().toLowerCase();
        if (!txt.includes('devam')) return;
        btn.textContent = '';
        const label = document.createElement('span');
        label.className = 'continue-label';
        label.textContent = 'DEVAM ET';
        const icon = document.createElement('span');
        icon.className = 'continue-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        btn.appendChild(label);
        btn.appendChild(icon);
    });
}
function hoistContinueButtons(containerEl) {
    if (!containerEl) return;
    const buttons = containerEl.querySelectorAll('.quiz-split .quiz-next');
    buttons.forEach((btn) => {
        if (btn.parentElement !== containerEl) {
            containerEl.appendChild(btn);
        }
    });
}
function getRandomInt(min, max) {
    const lower = Math.ceil(min);
    const upper = Math.floor(max);
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
}
function pickRandom(items) {
    if (!Array.isArray(items) || !items.length) return null;
    return items[getRandomInt(0, items.length - 1)];
}
function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
}
function buildRandomAdultCoupleAnswers() {
    const personas = [
        {
            self: { name: 'Deniz', age: [29, 38], height: [160, 176], weight: [54, 76] },
            partner: { name: 'Mert', age: [31, 42], height: [172, 188], weight: [72, 96] },
            painSelf: ['Boyun / omuzlar hassasiyet oluyor.'],
            painPartner: ['Bel / kalça bölgesinde sıkışıklık hissediyorum.'],
            allergySelf: 'Hayır, bilinen bir alerjim yok',
            allergyPartner: 'Toz / ev tozu akarına hassasiyeti var',
            sleepEnvSelf: ['Aradığım yastığı bir türlü bulamadım, her sabah boyun ağrısı ile uyanıyorum.'],
            sleepEnvPartner: ['Partnerinin hareketlerini çok hissediyor. Her hareketine uyanıyor.'],
            softnessSelf: [2, 3],
            softnessPartner: [3, 4],
            bedResponseSelf: 'Dengeli ve Sessiz: Ne gömüleyim ne de çok zıplayayım, stabil olsun.',
            bedResponsePartner: 'Dengeli ve Sessiz: Ne gömüleyim ne de çok zıplayayım, stabil olsun.',
            sleepPositionSelf: 'Yan',
            sleepPositionPartner: 'Sırt üstü',
            pillowHeightSelf: 'Orta',
            pillowFirmnessSelf: 'Yumuşak',
            pillowHeightPartner: 'Orta',
            pillowFirmnessPartner: 'Orta',
            bedLookPref: 'Yüksek olmasını istiyoruz. +28cm',
            mattressSize: '160x200',
        },
        {
            self: { name: 'Selin', age: [34, 45], height: [158, 172], weight: [60, 82] },
            partner: { name: 'Can', age: [35, 47], height: [175, 192], weight: [84, 108] },
            painSelf: ['Genel bir sertlik, vücudumun açılması zaman alıyor.'],
            painPartner: ['Bel / kalça bölgesinde sıkışıklık hissediyorum.'],
            allergySelf: 'Alerjik bünyem var (genel)',
            allergyPartner: 'Hayır, bilinen bir alerjisi yok',
            sleepEnvSelf: ['Bir türlü derin uykuya dalamıyorum. genel olarak rahat değilim.'],
            sleepEnvPartner: ['Yatağı çok sert, belli bölgelerde sıkışma ve batma hissediyor.'],
            softnessSelf: [3, 4],
            softnessPartner: [2, 3],
            bedResponseSelf: 'Tok ve Doğal: Yay mekaniği istemiyorum, yatak beni saf bir materyal gibi sarsın.',
            bedResponsePartner: 'Esnek ve Aktif: Vücuduna dinamik bir destek versin, yaylandığını hissetsin.',
            sleepPositionSelf: 'Sırt üstü',
            sleepPositionPartner: 'Yan',
            pillowHeightSelf: 'Orta',
            pillowFirmnessSelf: 'Orta',
            pillowHeightPartner: 'Yuksek',
            pillowFirmnessPartner: 'Sert',
            bedLookPref: 'Hiç farketmez.',
            mattressSize: '180x200',
        },
        {
            self: { name: 'Ece', age: [27, 36], height: [162, 178], weight: [58, 80] },
            partner: { name: 'Kerem', age: [28, 39], height: [178, 194], weight: [78, 102] },
            painSelf: ['Hiçbir şey, gayet iyiyim'],
            painPartner: ['Sırtın üst bölgesi tutuk oluyor.'],
            allergySelf: 'Hayır, bilinen bir alerjim yok',
            allergyPartner: 'Hayır, bilinen bir alerjisi yok',
            sleepEnvSelf: ['Çok terliyorum, dolayısıyla çok sık uyanıyorum.'],
            sleepEnvPartner: ['Partnerinin hareketlerini çok hissediyor. Her hareketine uyanıyor.'],
            softnessSelf: [2, 3],
            softnessPartner: [3, 4],
            bedResponseSelf: 'Esnek ve Aktif: Vücuduma dinamik bir destek versin, yaylandığımı hissedeyim.',
            bedResponsePartner: 'Dengeli ve Sessiz: Ne gömüleyim ne de çok zıplayayım, stabil olsun.',
            sleepPositionSelf: 'Yan',
            sleepPositionPartner: 'Yan',
            pillowHeightSelf: 'Alcak',
            pillowFirmnessSelf: 'Yumuşak',
            pillowHeightPartner: 'Orta',
            pillowFirmnessPartner: 'Sert',
            bedLookPref: 'Alçak / ince olmasını istiyoruz. 18-20cm',
            mattressSize: '160x200',
        },
    ];
    const persona = pickRandom(personas) || personas[0];
    const buildPerson = (config) => {
        const age = getRandomInt(config.age[0], config.age[1]);
        const height = getRandomInt(config.height[0], config.height[1]);
        const baseWeight = getRandomInt(config.weight[0], config.weight[1]);
        const adjustedWeight = clampNumber(baseWeight + Math.round((height - 170) * 0.15), config.weight[0], config.weight[1]);
        return {
            name: config.name,
            age: String(age),
            weight: String(adjustedWeight),
            height: String(height),
        };
    };
    const self = buildPerson(persona.self);
    const partner = buildPerson(persona.partner);
    const softnessSelf = String(getRandomInt(persona.softnessSelf[0], persona.softnessSelf[1]));
    const softnessPartner = String(getRandomInt(persona.softnessPartner[0], persona.softnessPartner[1]));
    const softnessLabelSelf = numericSoftnessToLabel(softnessSelf);
    const softnessLabelPartner = numericSoftnessToLabel(softnessPartner);

    return {
        email: null,
        marketing_consent: false,
        audience: 'adult',
        who_for: 'Kendim için',
        partner: partner,
        self: self,
        bed_side: pickRandom(['Sol', 'Sağ']) || 'Sol',
        pain: persona.painSelf,
        pain_self: persona.painSelf,
        pain_partner: persona.painPartner,
        allergy_sensitivity: persona.allergySelf,
        allergy_sensitivity_self: persona.allergySelf,
        allergy_sensitivity_partner: persona.allergyPartner,
        sleep_env_issues: persona.sleepEnvSelf,
        sleep_env_issues_self: persona.sleepEnvSelf,
        sleep_env_issues_partner: persona.sleepEnvPartner,
        softness: softnessSelf,
        softness_label: softnessLabelSelf,
        softness_self: softnessSelf,
        softness_label_self: softnessLabelSelf,
        softness_partner: softnessPartner,
        softness_label_partner: softnessLabelPartner,
        sleep_position: persona.sleepPositionSelf,
        sleep_position_self: persona.sleepPositionSelf,
        sleep_position_partner: persona.sleepPositionPartner,
        pillow_pref: persona.pillowHeightSelf,
        pillow_height: persona.pillowHeightSelf,
        pillow_firmness: persona.pillowFirmnessSelf,
        pillow_pref_partner: persona.pillowHeightPartner,
        pillow_height_partner: persona.pillowHeightPartner,
        pillow_firmness_partner: persona.pillowFirmnessPartner,
        bed_look_pref: persona.bedLookPref,
        mattress_size: persona.mattressSize,
    };
}
function startRandomAdultCoupleQuiz() {
    const answers = buildRandomAdultCoupleAnswers();
    quizState.history = [];
    quizState.answers = answers;
    quizState.audience = 'adult';
    quizState.self = answers.self;
    quizState.partner = answers.partner;
    quizState.bedSide = answers.bed_side;
    delete quizState.recommendedLog;
    delete quizState.aiResponse;
    delete quizState[MATTRESS_DECISION_STATE_KEY];
    delete quizState.sessionId;
    quizState.marketingConsent = false;
    quizState.customerSyncTriggered = false;
    quizState.completionLogged = false;
    ensureSessionId();
    const logger = window.SuiQuizLogger;
    if (logger && typeof logger.syncProgress === 'function') {
        try { logger.syncProgress({ answers: quizState.answers, history: quizState.history }); } catch (e) { }
    }
    renderQuestion('end');
}
function createInfoField(config) {
    const {
        type = 'text',
        placeholder = '',
        subject,
        field,
        min = 0,
        max = 0,
        step = 1,
        unit = '',
        autocomplete,
    } = config || {};
    const wrapper = document.createElement('label');
    wrapper.className = 'info-field';
    const sr = document.createElement('span');
    sr.className = 'sr-only';
    sr.textContent = placeholder || field || '';
    wrapper.appendChild(sr);
    let input;
    let setValue = () => { };
    if (type === 'select') {
        input = document.createElement('select');
        input.className = 'info-input info-select';
        const ph = document.createElement('option');
        ph.value = '';
        ph.textContent = placeholder || '';
        input.appendChild(ph);
        if (typeof min === 'number' && typeof max === 'number' && step) {
            for (let v = min; v <= max; v += step) {
                const opt = document.createElement('option');
                opt.value = String(v);
                opt.textContent = unit ? `${v} ${unit}` : `${v}`;
                input.appendChild(opt);
            }
        }
        const syncPlaceholderState = () => {
            if (input.value) {
                input.classList.add('has-value');
            } else {
                input.classList.remove('has-value');
            }
        };
        input.addEventListener('change', syncPlaceholderState);
        syncPlaceholderState();
        setValue = (value) => {
            const val = value === undefined || value === null ? '' : String(value);
            input.value = val;
            if (input.value !== val) {
                input.value = val.replace(/[^0-9]/g, '');
            }
            syncPlaceholderState();
        };
    } else {
        input = document.createElement('input');
        input.type = type;
        input.placeholder = placeholder || '';
        input.className = 'info-input';
        if (autocomplete) input.autocomplete = autocomplete;
        setValue = (value) => {
            input.value = value === undefined || value === null ? '' : String(value);
        };
    }
    input.dataset.subject = subject || '';
    input.dataset.field = field || '';
    wrapper.appendChild(input);
    return { field: wrapper, input, setValue };
}
// Cevap kaydetme yardımcıları
function setAnswer(key, value) {
    quizState.answers[key] = value;
    if (key === 'marketing_consent') {
        quizState.marketingConsent = !!value;
    }
    const logger = window.SuiQuizLogger;
    if (logger && typeof logger.syncProgress === 'function') {
        try { logger.syncProgress({ answers: quizState.answers, history: quizState.history }); } catch (e) { }
    }
}
// Ortak statik medya (seçenek ikonları)
const CHOICE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/kidgaranti_1.svg?v=1676480407';
const BED_SIDE_LEFT_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/soltaraf.jpg?v=1778660842';
const BED_SIDE_RIGHT_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/sagtaraf.jpg?v=1778660842';
const WHO_FOR_SELF_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/kendim.png?v=1778651265';
const WHO_FOR_CHILD_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/bebegim.png?v=1778651265';
const PARTNER_SOLO_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/Group_1597882863.png?v=1759929870';
const PARTNER_WITH_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/Group_1597882864.png?v=1759929869';
const SLEEP_POS_FACE_DOWN_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/yuzustu1.png?v=1778739811';
const SLEEP_POS_SIDE_NEW_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/yan1.png?v=1778739811';
const SLEEP_POS_BACK_NEW_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/sirtustu1.png?v=1778739811';
const SLEEP_POS_VARIABLE_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/degisken1.png?v=1778739811';
const DEFAULT_QUIZ_DESC = 'Uyku pozisyonuna göre vücudun baskı noktaları değişiyor.';
const RESULTS_BADGE_SELF_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/sen.png?v=1761046217';
const RESULTS_BADGE_PARTNER_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/partner.png?v=1761046217';
const RESULTS_BADGE_BOTH_ICON_URL = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/both.png?v=1761046217';
const TURKISH_SIMPLIFY_MAP = {
    '\u011f': 'g',
    '\u00fc': 'u',
    '\u015f': 's',
    '\u0131': 'i',
    '\u00f6': 'o',
    '\u00e7': 'c',
};
function simplifyTurkishText(value) {
    return (value || '')
        .toLowerCase()
        .replace(/[\u011f\u00fc\u015f\u0131\u00f6\u00e7]/g, ch => TURKISH_SIMPLIFY_MAP[ch] || ch);
}
function toTitleCaseTr(value) {
    return (value || '')
        .trim()
        .toLocaleLowerCase('tr-TR')
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toLocaleUpperCase('tr-TR') + part.slice(1))
        .join(' ');
}
function getSleepPositionIcon(label) {
    const simplified = simplifyTurkishText(label);
    if (simplified.includes('degis')) {
        return SLEEP_POS_VARIABLE_ICON_URL;
    }
    if (simplified.includes('sirt')) {
        return SLEEP_POS_BACK_NEW_ICON_URL;
    }
    if (simplified.includes('yuz')) {
        return SLEEP_POS_FACE_DOWN_ICON_URL;
    }
    if (simplified.includes('yan')) {
        return SLEEP_POS_SIDE_NEW_ICON_URL;
    }
    return CHOICE_ICON_URL;
}
function getChildFurnitureIcon(label) {
    const simplified = simplifyTurkishText(label);
    if (simplified.includes('anne yani') || simplified.includes('park yatak')) {
        return 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/rere.png?v=1778746758';
    }
    if (simplified.includes('montessori') || simplified.includes('yer yatagi')) {
        return 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/rerere.png?v=1778746758';
    }
    if (simplified.includes('besik')) {
        return 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/dede.png?v=1778746759';
    }
    if (simplified.includes('karyola') || simplified.includes('baza')) {
        return 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/fefef.png?v=1778746758';
    }
    if (simplified.includes('karar vermedim')) {
        return 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/wew.png?v=1778746758';
    }
    return CHOICE_ICON_URL;
}
function getPartnerDirectedLabel(questionId, label) {
    const allergyMap = {
        'Toz / ev tozu akarına hassasiyetim var': 'Toz / ev tozu akarına hassasiyeti var',
        'Alerjik bünyem var (genel)': 'Alerjik bir bünyesi var (genel)',
        'Astım / nefes hassasiyeti yaşıyorum': 'Astım / nefes hassasiyeti yaşıyor',
        'Hayır, bilinen bir alerjim yok': 'Hayır, bilinen bir alerjisi yok',
    };
    if (questionId === 'allergy_sensitivity' && allergyMap[label]) {
        return allergyMap[label];
    }
    return label;
}
// Shopify Storefront API (opsiyonel)
const SHOPIFY_STOREFRONT = {
    domain: (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : window.location.hostname,
    // Kullanıcı sağladı: varsayılan token. İsterseniz temada window.__STOREFRONT_TOKEN__ ile override edin.
    token: window.__STOREFRONT_TOKEN__ || '5cdfe2f020305538f17350f150e93788',
};
const SHOPIFY_ROUTES_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const PRODUCT_MODAL_STYLE_ID = 'sui-test-modal-styles';
const PRODUCT_MODAL_OVERLAY_ID = 'sui-test-modal';
const FORBIDDEN_BRAND_PATTERNS = [
    /\bhibboux\b/gi,
];
function enforceSuiBrandOnlyText(value) {
    if (value === null || value === undefined) return '';
    let output = String(value);
    FORBIDDEN_BRAND_PATTERNS.forEach((pattern) => {
        output = output.replace(pattern, 'Sui Sleep');
    });
    return output;
}
const PRODUCT_MODAL_STYLES = `
.results-modal { position: fixed; inset: 0; background: rgba(17, 24, 39, 0.55); display: flex; align-items: center; justify-content: center; padding: 24px; z-index: 9999; transition: opacity 0.2s ease, visibility 0.2s ease; }
.results-modal.is-hidden { opacity: 0; visibility: hidden; pointer-events: none; }
.results-modal-dialog { width: 100%; max-width: 1120px; max-height: 92vh; background: #ffffff; border-radius: 16px; position: relative; padding: 32px 36px 28px; display: flex; flex-direction: column; box-shadow: 0 24px 60px rgba(15, 23, 42, 0.25); }
.results-modal-close { position: absolute; top: 16px; right: 16px; width: 32px; height: 32px; border-radius: 50%; background: rgba(59, 110, 100, 0.08); border: none; color: #1f2937; font-size: 22px; line-height: 1; cursor: pointer; transition: background-color 0.2s ease, color 0.2s ease; }
.results-modal-close:hover { background: #3b6e64; color: #ffffff; }
.results-modal-title { margin: 0 32px 12px 0; font-size: 22px; font-weight: 700; color: #1e1e1e; }
.results-modal-body { flex: 1; overflow-y: auto; padding-right: 12px; }
.results-modal-body::-webkit-scrollbar { width: 6px; }
.results-modal-body::-webkit-scrollbar-thumb { background: rgba(59, 110, 100, 0.35); border-radius: 999px; }
.results-modal-body-inner { min-height: 100%; }
.results-modal-content { display: grid; grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr); gap: 32px; align-items: flex-start; margin-top: 8px; }
.results-modal-gallery { display: grid; grid-template-rows: minmax(0, auto) auto; gap: 14px; position: relative; }
.results-modal-main-image { position: relative; width: 100%; padding-bottom: 120%; border-radius: 16px; overflow: hidden; background: #f4f5f7; box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.05); }
.results-modal-main-image.is-empty { padding-bottom: 0; min-height: 320px; display: flex; align-items: center; justify-content: center; color: #6b7280; font-size: 14px; text-align: center; }
.results-modal-main-image img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
.results-modal-thumbs { display: grid; grid-auto-flow: column; grid-auto-columns: 88px; gap: 12px; overflow-x: auto; padding-bottom: 4px; }
.results-modal-thumb { border: 2px solid transparent; border-radius: 12px; padding: 0; background: none; cursor: pointer; overflow: hidden; transition: border-color 0.2s ease, transform 0.2s ease; }
.results-modal-thumb:hover { border-color: rgba(59, 110, 100, 0.5); transform: translateY(-2px); }
.results-modal-thumb img { width: 86px; height: 86px; object-fit: cover; display: block; pointer-events: none; }
.results-modal-thumb.is-active { border-color: #3b6e64; }
.results-modal-info { display: flex; flex-direction: column; gap: 18px; color: #1f2937; background: #f8f9fb; border-radius: 16px; padding: 24px 24px 28px; box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04); }
.results-modal-price { display: flex; align-items: baseline; gap: 14px; }
.results-modal-price-current { font-size: 20px; font-weight: 700; color: #3b6e64; }
.results-modal-price-compare { font-size: 16px; color: #9ca3af; text-decoration: line-through; }
.results-modal-subtitle { margin: 0; font-size: 16px; font-weight: 600; color: #3b6e64; }
.results-modal-variant-label { display: flex; flex-direction: column; gap: 8px; font-size: 13px; color: #4b5563; max-width: 420px; }
.results-modal-variant-pills { display: flex; flex-wrap: wrap; gap: 10px; }
.results-modal-variant-pill { padding: 10px 16px; border: 1px solid #d1d5db; border-radius: 999px; background: #ffffff; font-size: 14px; font-weight: 600; color: #1f2937; cursor: pointer; transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease; }
.results-modal-variant-pill:hover { border-color: #3b6e64; color: #3b6e64; }
.results-modal-variant-pill.is-active { border-color: #3b6e64; background: #3b6e64; color: #ffffff; box-shadow: 0 6px 16px rgba(59, 110, 100, 0.18); }
.results-modal-variants { display: flex; flex-direction: column; gap: 16px; }
.results-modal-actions { display: flex; flex-direction: column; gap: 10px; max-width: 320px; }
.results-modal-add-to-cart { display: inline-flex; align-items: center; justify-content: center; padding: 12px 20px; border-radius: 999px; background: #3b6e64; color: #ffffff; font-size: 14px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; border: none; cursor: pointer; transition: background-color 0.2s ease, transform 0.15s ease; }
.results-modal-add-to-cart:hover:not(:disabled) { background: #2f5b54; transform: translateY(-1px); }
.results-modal-add-to-cart:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.results-modal-variant-status { font-size: 13px; color: #1f2937; margin: 0; }
.results-modal-variant-status[data-state="error"] { color: #b91c1c; }
.results-modal-variant-status[data-state="success"] { color: #065f46; }
.results-modal-description { font-size: 14px; line-height: 1.7; color: #374151; }
.results-modal-options { margin: 0; font-size: 14px; color: #4b5563; }
.results-modal-loading { padding: 40px 0; text-align: center; color: #4b5563; font-size: 14px; }
.results-modal-body-inner .ai-loading { margin: 48px auto; justify-content: center; }
.results-modal-footer { display: flex; justify-content: flex-end; margin-top: 20px; }
.results-modal-link { display: inline-flex; align-items: center; justify-content: center; padding: 10px 22px; border-radius: 999px; background: #3b6e64; color: #ffffff; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; transition: background-color 0.2s ease, color 0.2s ease; }
.results-modal-link:hover { background: #2f5b54; color: #ffffff; }
.results-modal-error { color: #1f2937; line-height: 1.6; }
.results-modal-error a { color: #3b6e64; font-weight: 600; }
body.results-modal-open { overflow: hidden; }
@media (max-width: 640px) {
  .results-modal-dialog { padding: 24px 20px 20px; max-height: 95vh; }
  .results-modal-content { grid-template-columns: minmax(0, 1fr); gap: 20px; }
  .results-modal-gallery { grid-template-rows: minmax(0, auto) auto; }
  .results-modal-thumb img { width: 64px; height: 64px; }
  .results-modal-title { font-size: 18px; }
}
`;
function getProgressStepsForFlow() {
    const flow = (quizState && quizState.audience) || ((quizState && quizState.answers && quizState.answers.audience) || 'adult');
    if (flow === 'child') {
        return ['who_for', 'child_name', 'child_age', 'child_bed_furniture', 'child_furniture_type', 'child_allergy', 'child_bed_size'];
    }
    const hasPartner = !!(quizState && quizState.partner);
    if (hasPartner) {
        return [
            'who_for',
            'partner',
            'sleep_env_issues',
            'partner_both',
            'bed_side',
            'softness',
            'spring_preference',
            'sleep_position',
            'sleep_position_partner',
            'sleep_hot',
            'pain',
            'allergy_sensitivity',
            'pillow_pref',
            'partner_pillow_pref',
            'bed_look_pref',
            'mattress_size',
        ];
    }
    return [
        'who_for',
        'partner',
        'sleep_env_issues',
        'self_form',
        'softness',
        'spring_preference',
        'sleep_position',
        'sleep_hot',
        'pain',
        'allergy_sensitivity',
        'pillow_pref',
        'bed_look_pref',
        'mattress_size',
    ];
}

// Ortak: sağ kolona üst çubuk (geri + yüzde) ve progress bar ekler
function renderTopbarProgress(containerEl, questionId) {
    const flowSteps = getProgressStepsForFlow();
    const fallbackSteps = questions.filter(q => q.type !== 'end' && q.id !== 'email').map(q => q.id);
    const steps = flowSteps && flowSteps.length ? flowSteps : fallbackSteps;
    const idx = steps.findIndex((id) => id === questionId);
    const resolvedIdx = idx >= 0 ? idx : Math.max(0, fallbackSteps.indexOf(questionId));
    const percent = Math.max(0, Math.min(100, Math.round(((resolvedIdx + 1) / Math.max(steps.length, 1)) * 100)));
    const topbar = document.createElement('div');
    topbar.className = 'quiz-topbar';
    containerEl.appendChild(topbar);

    let progressMountedInTopSlot = false;
    const quizContainer = containerEl.closest('.quiz-container');
    if (quizContainer) {
        const topSlot = quizContainer.querySelector('.quiz-top-slot');
        if (topSlot) {
            topSlot.innerHTML = '';
            const meter = document.createElement('div');
            meter.className = 'quiz-top-slot-meter';
            meter.style.setProperty('--progress', percent + '%');
            const meterText = document.createElement('span');
            meterText.className = 'quiz-top-slot-meter-text';
            meterText.textContent = `% ${percent}`;
            meter.appendChild(meterText);
            topSlot.appendChild(meter);

            const progWrapTop = document.createElement('div');
            progWrapTop.className = 'quiz-progress quiz-progress-top-slot';
            const trackTop = document.createElement('div');
            trackTop.className = 'quiz-progress-track';
            trackTop.style.setProperty('--progress', percent + '%');
            const fillTop = document.createElement('div');
            fillTop.className = 'quiz-progress-fill';
            fillTop.style.width = percent + '%';
            trackTop.appendChild(fillTop);
            progWrapTop.appendChild(trackTop);
            topSlot.appendChild(progWrapTop);
            progressMountedInTopSlot = true;
        }
    }
    if (!progressMountedInTopSlot) {
        const progWrap = document.createElement('div');
        progWrap.className = 'quiz-progress';
        const track = document.createElement('div');
        track.className = 'quiz-progress-track';
        track.style.setProperty('--progress', percent + '%');
        const fill = document.createElement('div');
        fill.className = 'quiz-progress-fill';
        fill.style.width = percent + '%';
        track.appendChild(fill);
        progWrap.appendChild(track);
        containerEl.appendChild(progWrap);
    }
    return percent;
}
// Ortak: split yapısını ve sol/sağ kolonları oluşturup container'a ekler
function createSplit(container, question) {
    const split = document.createElement('div');
    split.className = 'quiz-split';
    const leftCol = document.createElement('div');
    leftCol.className = 'split-left';
    const rightCol = document.createElement('div');
    rightCol.className = 'split-right';
    split.appendChild(leftCol);
    split.appendChild(rightCol);
    container.appendChild(split);
    return { split, leftCol, rightCol };
}
// Ortak: sol kolona başlık ve açıklamayı ekler
function resolveQuestionTitle(question) {
    const introName = (quizState.answers && typeof quizState.answers.name === 'string') ? quizState.answers.name.trim() : '';
    const profileName = (quizState.self && typeof quizState.self.name === 'string') ? quizState.self.name.trim() : '';
    const selfName = introName || profileName;
    let resolvedTitle = question.text || '';
    if ((question.id === 'partner' || question.id === 'sleep_env_issues') && selfName) {
        resolvedTitle = `${selfName}, bu yatağı kaç kişi kullanacak?`;
    }
    if (question.id === 'sleep_env_issues' && selfName) {
        resolvedTitle = `${selfName}, neden yeni bir yatağa ihtiyaç duyuyorsunuz?`;
    }
    if (question.id === 'bed_side' && selfName) {
        resolvedTitle = `${selfName}, yatağın hangi tarafında uyuyorsun?`;
    }
    if (question.id === 'softness' && selfName) {
        resolvedTitle = `${selfName}, bir yatağa uzandığınızda nasıl bir his arıyorsunuz?`;
    }
    if (question.id === 'sleep_position') {
        resolvedTitle = selfName
            ? `${selfName}, gece kendini en çok hangi pozisyonda buluyorsun?`
            : 'Gece kendini en çok hangi pozisyonda buluyorsun?';
    }
    if (question.id === 'sleep_hot') {
        resolvedTitle = selfName
            ? `${selfName}, geceleri kendinizi nasıl hissedersiniz?`
            : 'Geceleri kendiniz nasıl hissedersiniz?';
    }
    if (question.id === 'child_age') {
        const childName = (quizState.answers && typeof quizState.answers.child_name === 'string')
            ? quizState.answers.child_name.trim()
            : '';
        const childUnknown = !!(quizState.answers && quizState.answers.child_name_unknown);
        if (childName) {
            resolvedTitle = `${childName}'ın doğum tarihi nedir?`;
        } else if (childUnknown) {
            resolvedTitle = 'Çocuğunun doğum tarihi nedir?';
        } else {
            resolvedTitle = 'Çocuğunun doğum tarihi nedir?';
        }
    }
    if (question.id === 'child_bed_furniture') {
        const childName = (quizState.answers && typeof quizState.answers.child_name === 'string')
            ? quizState.answers.child_name.trim()
            : '';
        if (childName) {
            resolvedTitle = `${childName}'ın yatağı için bir mobilyanız var mı?`;
        } else {
            resolvedTitle = 'Çocuğunuzun yatağı için bir mobilyanız var mı?';
        }
    }
    if (question.id === 'child_furniture_type') {
        const childName = (quizState.answers && typeof quizState.answers.child_name === 'string')
            ? quizState.answers.child_name.trim()
            : '';
        const hasFurniture = (quizState.answers && quizState.answers.child_bed_furniture) === 'Evet';
        if (hasFurniture) {
            resolvedTitle = 'Hangi tip mobilyanız var?';
        } else {
            resolvedTitle = childName
                ? `${childName}'ın yatağı için nasıl bir mobilya düşünüyorsunuz?`
                : 'Çocuğunuzun yatağı için nasıl bir mobilya düşünüyorsunuz?';
        }
    }
    if (question.id === 'child_allergy') {
        const childName = (quizState.answers && typeof quizState.answers.child_name === 'string')
            ? quizState.answers.child_name.trim()
            : '';
        resolvedTitle = childName
            ? `${childName}'da özel bir hassasiyet ya da durum var mı?`
            : 'Çocuğunuzda özel bir hassasiyet ya da durum var mı?';
    }
    if (question.id === 'child_bed_size') {
        const childName = (quizState.answers && typeof quizState.answers.child_name === 'string')
            ? quizState.answers.child_name.trim()
            : '';
        resolvedTitle = childName
            ? `${childName}'ın yatağının ölçüsünü biliyor musunuz?`
            : 'Çocuğunuzun yatağının ölçüsünü biliyor musunuz?';
    }
    if (question.id === 'pain' && selfName) {
        resolvedTitle = `${selfName}, sabah kalktığınızda bedeniniz size ne söylüyor?`;
    }
    if ((question.id === 'self_form' || question.id === 'partner_both') && selfName) {
        resolvedTitle = `${selfName}, size en doğru yatağı önerebilmemiz için birkaç bilginize ihtiyacımız var.`;
    }
    return resolvedTitle;
}
function resolveQuestionDescription(question) {
    if (question.id === 'self_form' || question.id === 'partner_both') {
        return 'Fiziksel yapınız ile birlikte uyku alışkanlıklarınızı da göz önünde bulundurarak size en doğru önerilerde bulunacağız.';
    }
    if (question.id === 'pain') {
        return 'Birden fazla yanıt seçebilirsiniz.';
    }
    if (question.id === 'child_furniture_type') {
        return '';
    }
    return question.description || DEFAULT_QUIZ_DESC;
}
function createMobileQuestionHeader(question, outer) {
    const wrap = document.createElement('div');
    wrap.className = 'quiz-mobile-question';
    if (quizState && quizState.audience === 'child') {
        wrap.classList.add('is-child-flow');
    }
    const title = document.createElement('h2');
    title.textContent = resolveQuestionTitle(question);
    const desc = document.createElement('p');
    desc.className = 'quiz-description';
    desc.textContent = resolveQuestionDescription(question);
    wrap.appendChild(title);
    wrap.appendChild(desc);
    outer.appendChild(wrap);
}
function moveMobileBackButtonToTopSlot(container) {
    if (typeof window === 'undefined' || !window.matchMedia || !window.matchMedia('(max-width: 899px)').matches) {
        return;
    }
    if (!container) return;
    const topSlot = container.querySelector('.quiz-top-slot');
    const backButton = container.querySelector('.quiz-back-top-left');
    if (!topSlot || !backButton) return;
    backButton.classList.remove('quiz-back-top-left');
    backButton.classList.add('quiz-back-top-slot-mobile');
    topSlot.appendChild(backButton);
}
function renderLeft(question, leftCol) {
    const backTop = document.createElement('button');
    backTop.type = 'button';
    backTop.className = 'quiz-back-top quiz-back-top-left';
    const backIcon = document.createElement('span');
    backIcon.className = 'quiz-back-icon';
    backIcon.textContent = '<';
    const backLabel = document.createElement('span');
    backLabel.className = 'quiz-back-label';
    backLabel.textContent = 'GERİ DÖN';
    backTop.appendChild(backIcon);
    backTop.appendChild(backLabel);
    backTop.onclick = goBack;
    leftCol.appendChild(backTop);
    const title = document.createElement('h2');
    title.textContent = resolveQuestionTitle(question);
    leftCol.appendChild(title);
    const pdesc = document.createElement('p');
    pdesc.className = 'quiz-description';
    pdesc.textContent = resolveQuestionDescription(question);
    leftCol.appendChild(pdesc);
}
// Ortak: sayısal sertliği etikete dönüştür
function numericSoftnessToLabel(n) {
    const num = parseInt(n, 10);
    if (isNaN(num)) return 'Orta';
    return num <= 2 ? 'Yumuşak' : (num === 3 ? 'Orta' : 'Sert');
}
const SOFTNESS_EXPECTATION_TEXT = {
    1: 'Çok yumuşak bir his istiyorum.',
    2: 'Yumuşak ve saran bir his istiyorum; aynı zamanda belimi de iyi desteklesin.',
    3: 'Ne çok sert ne çok yumuşak; dengeli bir destek arıyorum.',
    4: 'Sert hissi seviyorum ama basınç rahatsızlığı istemiyorum.',
    5: 'Belirgin şekilde sert bir yatak istiyorum.',
};
function getSoftnessExpectationText(value) {
    const num = parseInt(value, 10);
    if (Number.isNaN(num)) return SOFTNESS_EXPECTATION_TEXT[3];
    return SOFTNESS_EXPECTATION_TEXT[num] || SOFTNESS_EXPECTATION_TEXT[3];
}
// Sabit: ağrı sorusunda "iyiyim" etiketi
const NONE_PAIN_LABEL = 'Hiçbir şey, gayet iyiyim';
// Ortak: ağrı sorusu için checkbox grubunu oluşturur (4'lü grid + none exclusivity)
function createPainCheckboxes(options, noneLabel = NONE_PAIN_LABEL) {
    const wrapper = document.createElement('div');
    wrapper.className = 'choices multi pain-single-list';
    const checkboxes = [];
    (options || []).forEach((opt) => {
        const label = document.createElement('label');
        label.className = 'choice-checkbox pain-option';
        const cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.value = opt.label;
        cb.dataset.next = opt.next || '';
        const span = document.createElement('span');
        span.textContent = opt.label;
        label.appendChild(span);
        label.appendChild(cb);
        if (opt.label === noneLabel) {
            label.classList.add('none-option');
        }
        cb.onchange = () => {
            const isNone = (cb.value === noneLabel);
            label.classList.toggle('checked', cb.checked);
            if (cb.checked) {
                if (isNone) {
                    // None seçildiyse diğer seçimleri temizle
                    checkboxes.forEach(x => {
                        if (x !== cb) {
                            x.checked = false;
                            const lbl = x.parentElement;
                            if (lbl && lbl.classList) lbl.classList.remove('checked');
                        }
                    });
                } else {
                    // Diğer bir seçenek seçildiyse None'ı kaldır
                    const noneBox = checkboxes.find(x => x.value === noneLabel);
                    if (noneBox) {
                        noneBox.checked = false;
                        const lblNone = noneBox.parentElement;
                        if (lblNone && lblNone.classList) lblNone.classList.remove('checked');
                    }
                }
            }
        };
        checkboxes.push(cb);
        wrapper.appendChild(label);
    });
    return { wrapper, checkboxes };
}
async function fetchProductsByPredictiveSearch(query, limit = 6) {
    try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=${limit}`;
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Predictive search HTTP ' + res.status);
        const data = await res.json();
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        try {
            const t1 = performance.now();
        } catch (e) { }
        return products.map(p => ({
            title: p.title,
            url: p.url,
            image: (p.image && p.image) || null,
            price: p.price,
        }));
    } catch (e) {
        console.warn('Predictive search error:', e);
        return [];
    }
}
async function fetchProductsByStorefront(query, limit = 6) {
    if (!SHOPIFY_STOREFRONT.token) return [];
    const endpoint = `https://${SHOPIFY_STOREFRONT.domain}/api/2023-07/graphql.json`;
    // Keep fields minimal for broad Storefront API compatibility
    const gql = `query Products($q: String, $first: Int!) {\n  products(first: $first, query: $q) { edges { node { id title handle tags onlineStoreUrl featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } } } }\n}`;
    try {
        try {
            const masked = (SHOPIFY_STOREFRONT.token || '').slice(0, 4) + '...' + (SHOPIFY_STOREFRONT.token || '').slice(-4);
        } catch (e) { }
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT.token,
            },
            body: JSON.stringify({ query: gql, variables: { q: query, first: limit } }),
        });
        if (!res.ok) {
            console.warn('[Quiz] Storefront HTTP status:', res.status, res.statusText);
            throw new Error('Storefront API HTTP ' + res.status);
        }
        const data = await res.json();
        if (data && data.errors) { console.warn('Storefront GraphQL errors:', data.errors); }
        const edges = (data && data.data && data.data.products && data.data.products.edges) || [];
        try {
            const t1 = performance.now();
        } catch (e) { }
        return edges.map(({ node }) => ({
            title: node.title,
            url: node.onlineStoreUrl || (`/products/${node.handle}`),
            image: node.featuredImage ? node.featuredImage.url : null,
            price: (node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.amount) || null,
            currency: (node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.currencyCode) || null,
            handle: node.handle,
            tags: Array.isArray(node.tags) ? node.tags : [],
        }));
    } catch (e) {
        console.warn('Storefront API error:', e);
        return [];
    }
}
// Predictive sonuçları zenginleştir: handle ile ayrıntıları çek
async function enrichPredictiveProducts(products) {
    try {
        const handles = products.map(p => {
            const m = (p.url || '').match(/\/products\/([^\/?#]+)/);
            return m ? m[1] : null;
        }).filter(Boolean).slice(0, 5);
        if (!handles.length) return products;
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        const enriched = await fetchProductsByHandles(handles);
        try {
            const t1 = performance.now();
        } catch (e) { }
        const mapByHandle = new Map(enriched.map(p => [p.handle, p]));
        return products.map(p => {
            const h = (p.url || '').match(/\/products\/([^\/?#]+)/);
            const handle = h ? h[1] : null;
            const full = handle ? mapByHandle.get(handle) : null;
            return full ? {
                ...full, // keep enriched
                // preserve original url/image/price if missing in enriched
                url: full.url || p.url,
                image: full.image || p.image,
                price: full.price || p.price,
            } : p;
        });
    } catch (e) {
        console.warn('[Quiz] enrichPredictiveProducts error:', e);
        return products;
    }
}
async function fetchProductsByHandles(handles) {
    if (!SHOPIFY_STOREFRONT.token || !handles.length) return [];
    const endpoint = `https://${SHOPIFY_STOREFRONT.domain}/api/2023-07/graphql.json`;
    // Minimal fields for compatibility
    const aliasFields = (alias, idx) => `${alias}${idx}: productByHandle(handle: $h${idx}) { id title handle tags onlineStoreUrl featuredImage { url altText } priceRange { minVariantPrice { amount currencyCode } } }`;
    const vars = {};
    let varsDefs = '';
    let bodyFields = '';
    handles.forEach((h, i) => {
        const idx = i + 1;
        vars[`h${idx}`] = h;
        varsDefs += `$h${idx}: String!\n`;
        bodyFields += aliasFields('p', idx) + '\n';
    });
    const gql = `query ByHandles(\n${varsDefs}) {\n${bodyFields}}`;
    try {
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT.token,
            },
            body: JSON.stringify({ query: gql, variables: vars }),
        });
        if (!res.ok) throw new Error('Storefront byHandles HTTP ' + res.status);
        const data = await res.json();
        try {
            const t1 = performance.now();
        } catch (e) { }
        const out = [];
        Object.keys(data.data || {}).forEach(k => {
            const node = data.data[k];
            if (!node) return;
            out.push({
                title: node.title,
                url: node.onlineStoreUrl || (`/products/${node.handle}`),
                image: node.featuredImage ? node.featuredImage.url : null,
                price: (node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.amount) || null,
                currency: (node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.currencyCode) || null,
                handle: node.handle,
                tags: Array.isArray(node.tags) ? node.tags : [],
            });
        });
        return out;
    } catch (e) {
        console.warn('[Quiz] fetchProductsByHandles error:', e);
        return [];
    }
}
// Tek ürün için zengin alanlar (description, productType, tags, variants, metafields)
async function fetchProductRichByHandle(handle) {
    if (!SHOPIFY_STOREFRONT.token || !handle) return null;
    const endpoint = `https://${SHOPIFY_STOREFRONT.domain}/api/2023-07/graphql.json`;
    const gql = `query ProductRich($h: String!) {\n      productByHandle(handle: $h) {\n        title\n        handle\n        productType\n        tags\n        description\n        featuredImage { url altText }\n        variants(first: 50) { edges { node { selectedOptions { name value } } } }\n        aiDefinition: metafield(namespace: \"custom\", key: \"ai_definition\") { value }\n      }\n    }`;
    try {
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        const res = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT.token,
            },
            body: JSON.stringify({ query: gql, variables: { h: handle } }),
        });
        if (!res.ok) throw new Error('ProductRich HTTP ' + res.status);
        const data = await res.json();
        const n = data && data.data && data.data.productByHandle;
        if (data && data.errors) { console.warn('[Quiz] ProductRich GraphQL errors:', data.errors); }
        if (!n) return null;
        return {
            title: n.title,
            handle: n.handle,
            productType: n.productType,
            tags: n.tags || [],
            description: n.description || '',
            image: n.featuredImage ? n.featuredImage.url : null,
            options: (n.variants && n.variants.edges || []).map(e => ({ selectedOptions: e.node.selectedOptions })),
            aiDefinition: (n.aiDefinition && n.aiDefinition.value) || '',
        };
    } catch (e) {
        console.warn('[Quiz] fetchProductRichByHandle error:', e);
        return null;
    }
}
async function enrichProductsForAI(products) {
    const out = [...products];
    let t0 = 0;
    try { t0 = performance.now(); } catch (e) { }
    const tasks = out.map(async (p, idx) => {
        try {
            const handle = p.handle || ((p.url || '').match(/\/products\/([^\/?#]+)/) || [])[1];
            if (!handle) return;
            const rich = await fetchProductRichByHandle(handle);
            if (rich) {
                out[idx] = { ...p, ...rich, handle };
            }
        } catch (e) {
            console.warn('[Quiz] enrichProductsForAI item error:', e);
        }
    });
    await Promise.all(tasks);
    try {
        const t1 = performance.now();
    } catch (e) { }
    try {
        const debug = out.map(p => ({
            title: p.title,
            handle: p.handle,
            hasAiDef: !!p.aiDefinition,
            aiDefPreview: p.aiDefinition ? String(p.aiDefinition).slice(0, 180) + (String(p.aiDefinition).length > 180 ? '…' : '') : null,
            descPreview: p.description ? String(p.description).slice(0, 180) + (String(p.description).length > 180 ? '…' : '') : null,
            tags: p.tags,
            options: p.options,
        }));
    } catch (e) { }
    return out;
}
// Cevaplardan tag/ürün tipi çıkarımı
function hasHeavyAdultSelection(a) {
    if (!a || a.audience !== 'adult') return false;
    const values = [];
    if (a.weight) values.push(a.weight);
    if (a.partner_weight) values.push(a.partner_weight);
    if (a.self && a.self.weight) values.push(a.self.weight);
    if (a.partner && a.partner.weight) values.push(a.partner.weight);
    return values.some((value) => {
        const num = parseFloat(value);
        return !Number.isNaN(num) && num > ADULT_HEAVY_WEIGHT_THRESHOLD;
    });
}
function hasExtremeSoftnessSelection(a) {
    if (!a) return false;
    const values = [];
    ['softness', 'softness_self', 'softness_partner'].forEach((key) => {
        const val = a[key];
        if (val !== undefined && val !== null && val !== '') values.push(val);
    });
    return values.some((value) => {
        const num = parseInt(value, 10);
        return !Number.isNaN(num) && (num === 1 || num === 5);
    });
}
const MATTRESS_CATALOG = {
    uniq: {
        id: 'uniq',
        label: 'Uniq',
        handles: ['uniq'],
        kind: 'hybrid',
        profile: 'high',
        splitCapable: true,
        customFirmness: true,
        supportsOver100kg: false,
    },
    flow: {
        id: 'flow',
        label: 'Flow',
        handles: ['flow'],
        kind: 'foam_latex',
        profile: 'low_mid',
        splitCapable: false,
        customFirmness: false,
        supportsOver100kg: true,
    },
    doa: {
        id: 'doa',
        label: 'Doa',
        handles: ['doa'],
        kind: 'block_latex',
        profile: 'low',
        splitCapable: true,
        customFirmness: false,
        supportsOver100kg: true,
    },
};
const MATTRESS_DECISION_STATE_KEY = 'adultMattressDecision';
const DOA_HEAVY_FIRMNESS_THRESHOLD = 90;
function detectMattressModel(product) {
    const source = `${(product && product.handle) || ''} ${(product && product.title) || ''}`;
    const normalized = simplifyTurkishText(source);
    if (normalized.includes('uniq')) return 'uniq';
    if (normalized.includes('flow')) return 'flow';
    if (normalized.includes('doa')) return 'doa';
    return null;
}
function getSoftnessValueForOwner(answers, owner) {
    if (!answers) return null;
    const key = owner === 'partner' ? 'softness_partner' : 'softness_self';
    const fallbackKey = owner === 'partner' ? null : 'softness';
    const raw = key ? answers[key] : null;
    const fallback = fallbackKey ? answers[fallbackKey] : null;
    const num = parseInt(raw || fallback, 10);
    return Number.isNaN(num) ? null : num;
}
function getSoftnessGap(answers) {
    const self = getSoftnessValueForOwner(answers, 'self');
    const partner = getSoftnessValueForOwner(answers, 'partner');
    if (self === null || partner === null) return 0;
    return Math.abs(self - partner);
}
function getWeightValueForOwner(answers, owner) {
    if (!answers) return null;
    if (owner === 'partner') {
        const raw = (answers.partner && answers.partner.weight) || answers.partner_weight;
        const num = parseFloat(raw);
        return Number.isNaN(num) ? null : num;
    }
    const raw = (answers.self && answers.self.weight) || answers.weight;
    const num = parseFloat(raw);
    return Number.isNaN(num) ? null : num;
}
function getSleepPositionForOwner(answers, owner) {
    if (!answers) return '';
    if (owner === 'partner') return answers.sleep_position_partner || '';
    return answers.sleep_position_self || answers.sleep_position || '';
}
function chooseDoaFirmnessForOwner(answers, owner) {
    const softness = getSoftnessValueForOwner(answers, owner);
    const weight = getWeightValueForOwner(answers, owner);
    const sleepPosition = simplifyTurkishText(getSleepPositionForOwner(answers, owner));
    const isStomachSleeper = sleepPosition.includes('yuz');
    if (weight !== null && weight >= DOA_HEAVY_FIRMNESS_THRESHOLD) {
        return 'Sert';
    }
    if (softness !== null && softness >= 4) {
        return 'Sert';
    }
    if (isStomachSleeper && weight !== null && weight > 75) {
        return 'Sert';
    }
    return 'Orta Sert';
}
function buildDoaFirmnessRecommendation(answers) {
    const hasPartner = !!(answers && answers.partner);
    const selfFirmness = chooseDoaFirmnessForOwner(answers, 'self');
    if (!hasPartner) {
        return {
            summary: selfFirmness,
            byOwner: { self: selfFirmness },
        };
    }
    const partnerFirmness = chooseDoaFirmnessForOwner(answers, 'partner');
    if (selfFirmness === partnerFirmness) {
        return {
            summary: selfFirmness,
            byOwner: { self: selfFirmness, partner: partnerFirmness },
        };
    }
    return {
        summary: `Siz: ${selfFirmness}, Partner: ${partnerFirmness}`,
        byOwner: { self: selfFirmness, partner: partnerFirmness },
    };
}
function normalizeBedLookPref(value) {
    const normalized = simplifyTurkishText(value);
    if (normalized.includes('yuksek')) return 'high_profile';
    if (normalized.includes('alcak') || normalized.includes('ince')) return 'low_profile';
    return 'any_profile';
}
function collectSleepEnvIssues(answers) {
    const values = [];
    const pushValues = (input) => {
        if (Array.isArray(input)) {
            input.filter(Boolean).forEach((item) => values.push(item));
        } else if (input) {
            values.push(input);
        }
    };
    pushValues(answers && answers.sleep_env_issues);
    pushValues(answers && answers.sleep_env_issues_partner);
    pushValues(answers && answers.sleep_env_issues_self);
    return values;
}
function hasMotionSensitivity(answers) {
    return collectSleepEnvIssues(answers).some((item) => simplifyTurkishText(item).includes('partnerimin hareket') || simplifyTurkishText(item).includes('partnerinin hareket'));
}
function collectSleepEnvIssuesForOwner(answers, owner) {
    const source = owner === 'partner'
        ? ((answers && answers.sleep_env_issues_partner) || [])
        : ((answers && (answers.sleep_env_issues_self || answers.sleep_env_issues)) || []);
    if (Array.isArray(source)) return source.filter(Boolean);
    return source ? [source] : [];
}
function deriveFeelModeForOwner(answers, owner) {
    const bedLookPref = normalizeBedLookPref(answers && answers.bed_look_pref);
    const softness = getSoftnessValueForOwner(answers, owner);
    const issues = collectSleepEnvIssuesForOwner(answers, owner);
    let nonSpringSignal = 0;
    let springForwardSignal = 0;
    if (bedLookPref === 'low_profile') {
        nonSpringSignal += 3;
    }
    if (issues.some((item) => {
        const normalized = simplifyTurkishText(item);
        return normalized.includes('partnerimin hareket') || normalized.includes('partnerinin hareket');
    })) {
        nonSpringSignal += 2;
    }
    if (softness !== null && softness >= 4) {
        nonSpringSignal += 1;
    }
    if (softness !== null && softness <= 2 && bedLookPref === 'any_profile') {
        springForwardSignal += 1;
    }
    if (nonSpringSignal >= 3 || nonSpringSignal > springForwardSignal) {
        return 'non_spring';
    }
    if (springForwardSignal > nonSpringSignal) {
        return 'spring_forward';
    }
    return 'neutral';
}
function collectDerivedFeelModes(answers) {
    if (!answers) return [];
    const modes = [deriveFeelModeForOwner(answers, 'self')];
    if (answers.partner) modes.push(deriveFeelModeForOwner(answers, 'partner'));
    if (modes.includes('non_spring')) return ['non_spring'];
    if (modes.includes('spring_forward')) return ['spring_forward'];
    return ['neutral'];
}
function extractProductSizeValues(product) {
    const sizes = new Set();
    const maybeAdd = (value) => {
        const cleaned = typeof value === 'string' ? value.trim() : '';
        if (cleaned) sizes.add(cleaned);
    };
    const options = Array.isArray(product && product.options) ? product.options : [];
    options.forEach((option) => {
        if (!option) return;
        if (Array.isArray(option.values) && typeof option.name === 'string' && simplifyTurkishText(option.name).includes('size')) {
            option.values.forEach(maybeAdd);
            return;
        }
        if (Array.isArray(option.selectedOptions)) {
            option.selectedOptions.forEach((selected) => {
                if (!selected || typeof selected.name !== 'string') return;
                const key = simplifyTurkishText(selected.name);
                if (key.includes('size') || key.includes('olcu')) maybeAdd(selected.value);
            });
        }
    });
    return Array.from(sizes);
}
function hasRequestedStandardSize(product, answers) {
    const selectedSize = answers && answers.mattress_size;
    if (!selectedSize || selectedSize === 'Özel ölçü') return true;
    const sizes = extractProductSizeValues(product);
    if (!sizes.length) return true;
    return sizes.includes(selectedSize);
}
function normalizeAdultMattressInputs(answers) {
    const bedResponseModes = collectDerivedFeelModes(answers);
    return {
        isAdult: !!(answers && answers.audience === 'adult'),
        hasPartner: !!(answers && answers.partner),
        over100kg: hasHeavyAdultSelection(answers),
        selfSoftness: getSoftnessValueForOwner(answers, 'self'),
        partnerSoftness: getSoftnessValueForOwner(answers, 'partner'),
        maxSoftness: Math.max(getSoftnessValueForOwner(answers, 'self') || 0, getSoftnessValueForOwner(answers, 'partner') || 0, parseInt((answers && answers.softness) || 0, 10) || 0),
        softnessGap: getSoftnessGap(answers),
        bedResponseModes,
        prefersSpringForward: bedResponseModes.includes('spring_forward'),
        prefersNonSpring: bedResponseModes.includes('non_spring'),
        derivedFeelMode: bedResponseModes[0] || 'neutral',
        bedLookPref: normalizeBedLookPref(answers && answers.bed_look_pref),
        motionSensitive: hasMotionSensitivity(answers),
        mattressSize: (answers && answers.mattress_size) || '',
        wantsSpecialSize: !!(answers && answers.mattress_size === 'Özel ölçü'),
    };
}
function evaluateAdultMattress(answers, product, options = {}) {
    const normalized = normalizeAdultMattressInputs(answers);
    const modelId = detectMattressModel(product);
    if (!normalized.isAdult || !modelId) return null;
    const model = MATTRESS_CATALOG[modelId];
    if (!model) return null;
    const ignoreFeelPreference = !!options.ignoreFeelPreference;
    const ignoreProfilePreference = !!options.ignoreProfilePreference;
    const hardBlockReasons = [];
    const penaltyReasons = [];
    const positiveReasons = [];
    let score = 100;
    const addPenalty = (points, reason) => {
        score -= points;
        penaltyReasons.push(reason);
    };
    const addPositive = (points, reason) => {
        score += points;
        positiveReasons.push(reason);
    };
    if (modelId === 'uniq' && normalized.over100kg) {
        hardBlockReasons.push('100 kg üzeri kullanımda Uniq önerilmiyor.');
    }
    if (modelId === 'flow') {
        const softnessValues = [normalized.selfSoftness, normalized.partnerSoftness].filter((value) => value !== null);
        if (softnessValues.some((value) => value === 1 || value === 5)) {
            hardBlockReasons.push('Flow, en yumuşak ve en sert beklentilerde önerilmiyor.');
        }
        if (normalized.hasPartner && normalized.softnessGap >= 3) {
            hardBlockReasons.push('Partnerler arası sertlik farkı Flow için fazla yüksek.');
        }
        if (!hasRequestedStandardSize(product, answers)) {
            hardBlockReasons.push(`Seçilen ölçü ${((answers && answers.mattress_size) || '').trim()} Flow varyantlarında yok.`);
        }
    }
    if (modelId === 'doa' && !hasRequestedStandardSize(product, answers)) {
        hardBlockReasons.push(`Seçilen ölçü ${((answers && answers.mattress_size) || '').trim()} Doa varyantlarında yok.`);
    }
    if (modelId === 'uniq' && !hasRequestedStandardSize(product, answers)) {
        hardBlockReasons.push(`Seçilen ölçü ${((answers && answers.mattress_size) || '').trim()} Uniq varyantlarında yok.`);
    }
    if (hardBlockReasons.length) {
        return {
            modelId,
            modelLabel: model.label,
            product,
            eligible: false,
            score: Number.NEGATIVE_INFINITY,
            hardBlockReasons,
            penaltyReasons,
            positiveReasons,
            chosenFirmness: null,
            chosenVariant: null,
            fallbackUsed: !!(ignoreFeelPreference || ignoreProfilePreference),
        };
    }
    if (modelId === 'uniq') {
        if (!ignoreFeelPreference && normalized.prefersNonSpring) addPenalty(35, 'Yaylı/aktif his istememe tercihi Uniq ile zayıf eşleşiyor.');
        if (!ignoreProfilePreference && normalized.bedLookPref === 'low_profile') addPenalty(30, 'Alçak yatak beklentisi Uniq yüksek profiline ters.');
        if (normalized.motionSensitive) addPenalty(25, 'Partner hareket hassasiyetinde Uniq daha zayıf kalıyor.');
        if (normalized.hasPartner && normalized.softnessGap >= 2) addPositive(25, 'İki tarafın sertlik ihtiyacı ayrıştığı için Uniq avantajlı.');
        if (normalized.hasPartner && normalized.softnessGap >= 1) addPositive(15, 'Çift taraf farklı üretim ihtiyacına cevap verebilir.');
        if (normalized.wantsSpecialSize) addPositive(10, 'Özel ölçü talebinde kişiye özel üretim avantajı var.');
    }
    if (modelId === 'flow') {
        if (!ignoreFeelPreference && normalized.prefersSpringForward) addPenalty(30, 'Belirgin yaylı/aktif his beklentisi Flow ile tam örtüşmüyor.');
        if (!ignoreFeelPreference && normalized.prefersNonSpring) addPositive(10, 'Tok ve yaysız his beklentisi Flow ile uyumlu.');
        if (!ignoreProfilePreference && normalized.bedLookPref === 'high_profile') addPenalty(35, 'Yüksek yatak beklentisi Flow yüksekliğiyle uyumsuz.');
        if (!ignoreProfilePreference && normalized.bedLookPref === 'low_profile') addPositive(10, 'Alçak yatak beklentisine uygun.');
        if (!normalized.hasPartner) addPositive(5, 'Tek kullanıcıda tek hissiyatlı yapı avantajlı.');
        if (normalized.hasPartner && normalized.softnessGap === 2) addPenalty(20, 'Partnerler arasında hissiyat farkı belirgin.');
        if (normalized.hasPartner && normalized.softnessGap <= 1) addPositive(10, 'Partner beklentileri birbirine yakın olduğu için Flow uygun.');
    }
    if (modelId === 'doa') {
        if (!ignoreFeelPreference && normalized.prefersSpringForward) addPenalty(30, 'Yaylı/aktif his beklentisi Doa ile zayıf eşleşiyor.');
        if (!ignoreFeelPreference && normalized.prefersNonSpring) addPositive(15, 'Tok ve doğal his beklentisi Doa ile güçlü eşleşiyor.');
        if (!ignoreProfilePreference && normalized.bedLookPref === 'high_profile') addPenalty(35, 'Yüksek yatak beklentisi Doa yüksekliğiyle uyumsuz.');
        if (!ignoreProfilePreference && normalized.bedLookPref === 'low_profile') addPositive(15, 'Alçak profil isteğine doğrudan uyuyor.');
        if (normalized.maxSoftness >= 4) addPositive(20, 'Sert ya da orta-sert beklentide Doa öne çıkıyor.');
        else if (normalized.maxSoftness === 3) addPositive(10, 'Dengeli sertlik beklentisinde Doa uygun bir aday.');
        else if (normalized.maxSoftness >= 1) addPenalty(20, 'Daha yumuşak beklentilerde Doa geride kalıyor.');
        if (normalized.hasPartner && normalized.softnessGap >= 2) addPositive(15, 'Partnerli kullanımda iki tarafı ayrı düşünmeye daha uygun.');
    }
    let chosenFirmness = null;
    let chosenFirmnessByOwner = null;
    if (modelId === 'doa') {
        const doaFirmness = buildDoaFirmnessRecommendation(answers);
        chosenFirmness = doaFirmness.summary;
        chosenFirmnessByOwner = doaFirmness.byOwner;
        positiveReasons.push(`Önerilen Doa varyantı: ${chosenFirmness}.`);
        if (normalized.hasPartner && doaFirmness.byOwner && doaFirmness.byOwner.self !== doaFirmness.byOwner.partner) {
            positiveReasons.push(`Doa iki taraf için farklı kurgulanabilir: siz ${doaFirmness.byOwner.self}, partneriniz ${doaFirmness.byOwner.partner}.`);
        }
    }
    if (modelId === 'uniq' && normalized.hasPartner && normalized.softnessGap >= 2) {
        positiveReasons.push('İki taraf farklı üretim opsiyonu burada anlamlı.');
    }
    if (modelId === 'flow' && normalized.hasPartner && normalized.softnessGap >= 1) {
        penaltyReasons.push('Flow tek hissiyatlı yapıda olduğu için split ihtiyaçları sınırlı karşılar.');
    }
    return {
        modelId,
        modelLabel: model.label,
        product,
        eligible: true,
        score,
        hardBlockReasons,
        penaltyReasons,
        positiveReasons,
        chosenFirmness,
        chosenFirmnessByOwner,
        chosenVariant: (answers && answers.mattress_size) || null,
        fallbackUsed: !!(ignoreFeelPreference || ignoreProfilePreference),
    };
}
function sortMattressDecisions(decisions) {
    return [...decisions].sort((a, b) => {
        const scoreGap = Math.abs((b.score || 0) - (a.score || 0));
        if (scoreGap <= 5 && a.modelId !== b.modelId) {
            if (a.modelId === 'doa') return -1;
            if (b.modelId === 'doa') return 1;
        }
        if (b.score !== a.score) return b.score - a.score;
        return a.modelLabel.localeCompare(b.modelLabel, 'tr');
    });
}
function annotateMattressRecommendationRoles(selected) {
    return (selected || []).map((item, index) => ({
        ...item,
        recommendationRole: index === 0 ? 'primary' : 'alternative',
    }));
}
function ensureHighProfileAlternative(selected, eligible, answers) {
    const bedLookPref = normalizeBedLookPref(answers && answers.bed_look_pref);
    if (bedLookPref !== 'high_profile') return selected;
    if (!Array.isArray(selected) || !selected.length) return selected;
    const hasUniqSelected = selected.some((item) => item && item.modelId === 'uniq');
    if (hasUniqSelected) return selected;
    const uniqCandidate = (eligible || []).find((item) => item && item.modelId === 'uniq');
    if (!uniqCandidate) return selected;
    const primary = selected[0];
    if (!primary) return [uniqCandidate];
    return [primary, uniqCandidate];
}
function rankAdultMattresses(answers, products) {
    const candidates = (products || []).map((product) => evaluateAdultMattress(answers, product)).filter(Boolean);
    let eligible = sortMattressDecisions(candidates.filter((item) => item.eligible));
    let fallbackUsed = false;
    if (!eligible.length) {
        const fallbackCandidates = (products || []).map((product) => evaluateAdultMattress(answers, product, {
            ignoreFeelPreference: true,
            ignoreProfilePreference: true,
        })).filter(Boolean);
        eligible = sortMattressDecisions(fallbackCandidates.filter((item) => item.eligible));
        fallbackUsed = eligible.length > 0;
    }
    const selected = [];
    if (eligible[0]) selected.push(eligible[0]);
    if (eligible[1]) {
        selected.push(eligible[1]);
    }
    const adjustedSelected = ensureHighProfileAlternative(selected, eligible, answers);
    const selectedWithRoles = annotateMattressRecommendationRoles(adjustedSelected);
    const selectedKeys = new Set(selectedWithRoles.map((item) => getProductIdentity(item.product)));
    const eliminated = candidates.filter((item) => !selectedKeys.has(getProductIdentity(item.product)));
    return {
        fallbackUsed,
        selected: selectedWithRoles,
        eliminated,
        products: selectedWithRoles.map((item) => {
            const output = Object.assign({}, item.product);
            output.decision = {
                modelId: item.modelId,
                modelLabel: item.modelLabel,
                score: item.score,
                hardBlockReasons: item.hardBlockReasons.slice(),
                penaltyReasons: item.penaltyReasons.slice(),
                positiveReasons: item.positiveReasons.slice(),
                chosenFirmness: item.chosenFirmness,
                chosenFirmnessByOwner: item.chosenFirmnessByOwner ? Object.assign({}, item.chosenFirmnessByOwner) : null,
                chosenVariant: item.chosenVariant,
                fallbackUsed: item.fallbackUsed,
                recommendationRole: item.recommendationRole,
            };
            return output;
        }),
    };
}
function detectChildMattressModel(product) {
    const handle = (product && typeof product.handle === 'string')
        ? product.handle
        : (((product && product.url) || '').match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    const normalized = String(handle || '').toLowerCase();
    if (normalized === CHILD_MATTRESS_HANDLES.newborn) return 'newborn';
    if (normalized === CHILD_MATTRESS_HANDLES.twist) return 'twist';
    if (normalized === CHILD_MATTRESS_HANDLES.doaJr) return 'doaJr';
    if (normalized === CHILD_MATTRESS_HANDLES.uniqJr) return 'uniqJr';
    return null;
}
function getChildBedDimension(answers, key) {
    const raw = answers && answers[key];
    if (raw === undefined || raw === null) return null;
    const n = parseInt(String(raw).replace(/[^0-9]/g, ''), 10);
    return Number.isNaN(n) ? null : n;
}
function getChildFurniturePreference(answers) {
    const selected = answers && answers.child_furniture_type ? simplifyTurkishText(answers.child_furniture_type) : '';
    if (selected.includes('anne yani') || selected.includes('park yatak')) return 'nextToMe';
    if (selected.includes('besik')) return 'crib';
    if (selected.includes('montessori') || selected.includes('yer yatagi')) return 'montessori';
    if (selected.includes('karyola') || selected.includes('baza')) return 'bedBase';
    if (selected.includes('karar vermedim')) return 'unknown';
    return '';
}
function getChildMattressAllowedModelsByFurniture(answers) {
    const pref = getChildFurniturePreference(answers);
    if (pref === 'nextToMe' || pref === 'crib') return ['newborn', 'twist'];
    if (pref === 'montessori') return ['twist', 'doaJr'];
    if (pref === 'bedBase') return ['twist', 'doaJr', 'uniqJr'];
    if (pref === 'unknown') {
        const ageMonths = getChildAgeMonths(answers);
        return ageMonths !== null && ageMonths < 12
            ? ['newborn', 'twist', 'doaJr', 'uniqJr']
            : ['twist', 'doaJr', 'uniqJr'];
    }
    return ['newborn', 'twist', 'doaJr', 'uniqJr'];
}
function hasChildSensitivityDoaSignal(answers) {
    const value = simplifyTurkishText((answers && answers.child_allergy) || '');
    return value.includes('alerji') || value.includes('astim') || value.includes('dogal');
}
function evaluateChildMattress(answers, product) {
    const modelId = detectChildMattressModel(product);
    if (!modelId || !answers || answers.audience !== 'child') return null;
    const labels = {
        newborn: 'Newborn',
        twist: 'Twist',
        doaJr: 'Doa Jr',
        uniqJr: 'Uniq Jr',
    };
    const hardBlockReasons = [];
    const penaltyReasons = [];
    const positiveReasons = [];
    let score = 100;
    const ageMonths = getChildAgeMonths(answers);
    const width = getChildBedDimension(answers, 'child_bed_width');
    const length = getChildBedDimension(answers, 'child_bed_length');
    const allowedByFurniture = getChildMattressAllowedModelsByFurniture(answers);
    const furniturePref = getChildFurniturePreference(answers);
    const hasDoaSignal = hasChildSensitivityDoaSignal(answers);
    const addPositive = (points, reason) => {
        score += points;
        positiveReasons.push(reason);
    };
    const addPenalty = (points, reason) => {
        score -= points;
        penaltyReasons.push(reason);
    };
    if (ageMonths !== null) {
        if (modelId === 'newborn' && ageMonths > 12) hardBlockReasons.push('Newborn 0-1 yaş aralığı için önerilir.');
        if ((modelId === 'doaJr' || modelId === 'uniqJr') && ageMonths < 12) hardBlockReasons.push(`${labels[modelId]} 1 yaş ve üzeri için önerilir.`);
        if ((modelId === 'twist' && ageMonths > 144) || ((modelId === 'doaJr' || modelId === 'uniqJr') && ageMonths > 216)) {
            hardBlockReasons.push(`${labels[modelId]} bu yaş aralığı için uygun değil.`);
        }
    }
    if (modelId === 'newborn') {
        if (width !== null && width > 80) hardBlockReasons.push('Seçilen genişlik Newborn için 80 cm üstünde.');
        if (length !== null && length > 120) hardBlockReasons.push('Seçilen boy Newborn için 120 cm üstünde.');
    } else if ((width !== null && width < 60) || (length !== null && length < 120)) {
        hardBlockReasons.push(`${labels[modelId]} için seçilen ölçü çok küçük.`);
    }
    if (!allowedByFurniture.includes(modelId)) {
        hardBlockReasons.push(`${labels[modelId]} seçilen mobilya tipiyle öncelikli aday değil.`);
    }
    if (hardBlockReasons.length) {
        return {
            modelId,
            modelLabel: labels[modelId],
            product,
            eligible: false,
            score: Number.NEGATIVE_INFINITY,
            hardBlockReasons,
            penaltyReasons,
            positiveReasons,
            chosenVariant: answers.child_bed_size || null,
        };
    }
    if ((furniturePref === 'nextToMe' || furniturePref === 'crib') && modelId === 'newborn') addPositive(45, 'Anne yanı / beşik kullanımında ilk öneri Newborn.');
    if ((furniturePref === 'nextToMe' || furniturePref === 'crib') && modelId === 'twist') addPositive(20, 'Anne yanı / beşik kullanımında Twist alternatif olarak değerlendirilebilir.');
    if (furniturePref === 'montessori' && modelId === 'twist') addPositive(35, 'Montessori kullanımında Twist güçlü aday.');
    if (furniturePref === 'montessori' && modelId === 'doaJr') addPositive(30, 'Montessori kullanımında Doa Jr uygun aday.');
    if (furniturePref === 'bedBase' && modelId === 'twist') addPositive(30, 'Karyola / baza kullanımında Twist uygun aday.');
    if (furniturePref === 'bedBase' && modelId === 'doaJr') addPositive(30, 'Karyola / baza kullanımında Doa Jr uygun aday.');
    if (furniturePref === 'bedBase' && modelId === 'uniqJr') addPositive(25, 'Karyola / baza kullanımında Uniq Jr uygun aday.');
    if (hasDoaSignal && modelId === 'doaJr') addPositive(45, 'Hassasiyet veya doğal malzeme beklentisinde Doa Jr öne çıkar.');
    if (hasDoaSignal && modelId !== 'doaJr') addPenalty(10, 'Hassasiyet cevabında Doa Jr daha güçlü eşleşir.');
    if (ageMonths !== null && ageMonths < 12 && modelId === 'newborn') addPositive(20, '0-1 yaş aralığında Newborn yaşa doğrudan uygun.');
    if (ageMonths !== null && ageMonths >= 12 && (modelId === 'doaJr' || modelId === 'uniqJr')) addPositive(10, '1 yaş ve üzeri kullanım aralığına uygun.');
    return {
        modelId,
        modelLabel: labels[modelId],
        product,
        eligible: true,
        score,
        hardBlockReasons,
        penaltyReasons,
        positiveReasons,
        chosenVariant: answers.child_bed_size || null,
    };
}
function sortChildMattressDecisions(decisions) {
    return [...decisions].sort((a, b) => {
        if (b.score !== a.score) return b.score - a.score;
        const order = { newborn: 0, twist: 1, doaJr: 2, uniqJr: 3 };
        return (order[a.modelId] || 99) - (order[b.modelId] || 99);
    });
}
function rankChildMattresses(answers, products) {
    const candidates = (products || []).map(product => evaluateChildMattress(answers, product)).filter(Boolean);
    const eligible = sortChildMattressDecisions(candidates.filter(item => item.eligible));
    let fallbackUsed = false;
    let selectedBase = eligible.slice(0, 2);
    if (!selectedBase.length) {
        const twistCandidate = candidates.find((item) => item.modelId === 'twist');
        if (twistCandidate) {
            fallbackUsed = true;
            selectedBase = [{
                ...twistCandidate,
                eligible: true,
                score: 0,
                hardBlockReasons: [],
                penaltyReasons: [
                    ...(twistCandidate.penaltyReasons || []),
                    ...(twistCandidate.hardBlockReasons || []),
                ],
                positiveReasons: [
                    ...(twistCandidate.positiveReasons || []),
                    'Uygun eşleşme bulunamadığı için güvenli varsayılan olarak Twist önerildi.',
                ],
            }];
        }
    }
    const selectedWithRoles = annotateMattressRecommendationRoles(selectedBase);
    const selectedKeys = new Set(selectedWithRoles.map((item) => getProductIdentity(item.product)));
    const eliminated = candidates.filter((item) => !selectedKeys.has(getProductIdentity(item.product)));
    return {
        fallbackUsed,
        selected: selectedWithRoles,
        eliminated,
        products: selectedWithRoles.map((item) => {
            const output = Object.assign({}, item.product);
            output.decision = {
                modelId: item.modelId,
                modelLabel: item.modelLabel,
                score: item.score,
                hardBlockReasons: item.hardBlockReasons.slice(),
                penaltyReasons: item.penaltyReasons.slice(),
                positiveReasons: item.positiveReasons.slice(),
                chosenVariant: item.chosenVariant,
                recommendationRole: item.recommendationRole,
            };
            return output;
        }),
    };
}
function computePillowExclusionTags(a) {
    if (!a) return [];
    const exclusions = new Set();
    const height = a.pillow_height || '';
    const firmness = a.pillow_firmness || '';
    if (height === 'Alcak' || firmness === 'Yumuşak') exclusions.add(PILLOW_ORIGINAL_TAG);
    if (firmness === 'Sert' || height === 'Yuksek') exclusions.add(PILLOW_WAVE_TAG);
    if (firmness === 'Yumuşak' || firmness === 'Orta' || height === 'Yuksek') exclusions.add(PILLOW_COSY_TAG);
    return Array.from(exclusions);
}
function extractPillowAnswersForOwner(answers, owner) {
    if (!answers) return {};
    if (owner === 'partner') {
        return {
            pillow_height: answers.pillow_height_partner,
            pillow_firmness: answers.pillow_firmness_partner,
            pillow_pref: answers.pillow_pref_partner,
        };
    }
    return {
        pillow_height: answers.pillow_height,
        pillow_firmness: answers.pillow_firmness,
        pillow_pref: answers.pillow_pref,
    };
}
function getChildAgeMonths(answers) {
    if (!answers) return null;
    const rawMonths = parseInt(answers.child_age_months, 10);
    if (!Number.isNaN(rawMonths) && rawMonths >= 0) return rawMonths;
    const rawYears = parseInt(answers.child_age, 10);
    if (!Number.isNaN(rawYears) && rawYears >= 0) return rawYears * 12;
    return null;
}
function parseIsoDate(value) {
    if (!value || typeof value !== 'string') return null;
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
    return Number.isNaN(date.getTime()) ? null : date;
}
function isChildBirthDateFuture(answers) {
    const birthDate = parseIsoDate(answers && answers.child_birth_date);
    if (!birthDate) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    birthDate.setHours(0, 0, 0, 0);
    return birthDate > today;
}
function getChildPillowHandles(answers) {
    if (!answers || answers.audience !== 'child') return [];
    if (isChildBirthDateFuture(answers)) {
        return [MATERNITY_PILLOW_MOM_HANDLE];
    }
    const ageMonths = getChildAgeMonths(answers);
    if (ageMonths === null || ageMonths < 12) return [];
    if (ageMonths < 48) return [CHILD_PILLOW_BABYKID_HANDLE];
    if (ageMonths < 96) return [CHILD_PILLOW_BUBBLE_HANDLE];
    return [CHILD_PILLOW_BUBBLE_HANDLE, CHILD_PILLOW_ORIGINAL_HANDLE, CHILD_PILLOW_WAVE_HANDLE];
}
function getChildAccessoryTagsForAge(answers) {
    const ageMonths = getChildAgeMonths(answers);
    const tags = [];
    if (ageMonths === null || ageMonths <= 24) tags.push(CHILD_ACCESSORY_MOONIE_TAG);
    if (ageMonths === null || ageMonths >= 12) tags.push(CHILD_ACCESSORY_COSY_JR_QUILT_TAG);
    if (ageMonths === null || ageMonths <= 72) tags.push(CHILD_ACCESSORY_RAIN_PROTECTOR_TAG);
    return tags;
}
function getChildFurnitureTags(answers) {
    if (!answers || answers.child_bed_furniture === 'Evet') return [];
    const selected = answers.child_furniture_type || '';
    const simplified = simplifyTurkishText(selected);
    if (simplified.includes('anne yani') || simplified.includes('park yatak')) {
        return [CHILD_FURNITURE_NEXT_TO_ME_TAG];
    }
    if (simplified.includes('montessori') || simplified.includes('yer yatagi')) {
        return [CHILD_FURNITURE_MONTESSORI_TAG];
    }
    if (simplified.includes('besik')) {
        return [CHILD_FURNITURE_CRIB_TAG];
    }
    if (simplified.includes('karar vermedim')) {
        return [CHILD_FURNITURE_NEXT_TO_ME_TAG, CHILD_FURNITURE_MONTESSORI_TAG, CHILD_FURNITURE_CRIB_TAG];
    }
    return [];
}
function mapAnswersToTags(a) {
    const answers = a || {};
    const pillowTags = [];
    const partnerPillowTags = [];
    const mattressTags = [];
    const accessoryTags = [];
    const childAccessoryTags = [];
    const childFurnitureTags = [];
    const hasValue = (value) => value !== undefined && value !== null && value !== '';
    const wantsPillow = hasValue(answers.pillow_height) || hasValue(answers.pillow_firmness) || hasValue(answers.pillow_pref);
    const wantsPartnerPillow = hasValue(answers.pillow_height_partner) || hasValue(answers.pillow_firmness_partner) || hasValue(answers.pillow_pref_partner);
    const applyPillowMapping = (target, heightValue, firmnessValue, prefValue) => {
        if (!target) return;
        target.push(PILLOW_BASE_TAG);
        if (typeof prefValue === 'string' && prefValue) {
            const prefTag = PILLOW_PREF_TO_TAG[prefValue];
            if (prefTag) target.push(prefTag);
        }
        if (heightValue) {
            const heightTag = PILLOW_PROFILE_TO_TAG[heightValue];
            if (heightTag) target.push(heightTag);
        }
        if (firmnessValue) {
            const firmnessTag = PILLOW_FIRMNESS_TO_TAG[firmnessValue];
            if (firmnessTag) target.push(firmnessTag);
        }
    };
    if (wantsPillow) {
        applyPillowMapping(pillowTags, answers.pillow_height, answers.pillow_firmness, answers.pillow_pref);
    }
    if (wantsPartnerPillow) {
        applyPillowMapping(partnerPillowTags, answers.pillow_height_partner, answers.pillow_firmness_partner, answers.pillow_pref_partner);
    }
    if (answers.audience === 'child') {
        mattressTags.push(CHILD_MATTRESS_TAG);
        getChildAccessoryTagsForAge(answers).forEach(tag => childAccessoryTags.push(tag));
        getChildFurnitureTags(answers).forEach(tag => childFurnitureTags.push(tag));
    }
    if (answers.audience === 'adult' && hasExtremeSoftnessSelection(answers)) {
        mattressTags.push(ADULT_EXTREME_SOFTNESS_TAG);
    }
    if (answers.audience === 'adult') {
        accessoryTags.push(ADULT_ACCESSORY_ALWAYS_TAG);
        mattressTags.push(ADULT_MATTRESS_BASE_TAG);
        if (hasHeavyAdultSelection(answers)) {
            mattressTags.push(ADULT_HEAVY_OK_TAG);
        }
    }
    const primaryTags = (wantsPillow && pillowTags.length) ? pillowTags : mattressTags;
    const productType = (wantsPillow && pillowTags.length) ? 'Pillow' : 'Mattress';
    return { tags: primaryTags, productType, pillowTags, partnerPillowTags, mattressTags, accessoryTags, childAccessoryTags, childFurnitureTags };
}
function filterAdultMattressProducts(products, answers) {
    if (!Array.isArray(products) || !products.length) return products;
    if (!answers || answers.audience !== 'adult') return products;
    const needsHeavyFilter = hasHeavyAdultSelection(answers);
    const needsExtremeFilter = hasExtremeSoftnessSelection(answers);
    if (!needsHeavyFilter && !needsExtremeFilter) return products;
    const filtered = products.filter((product) => {
        const tagList = Array.isArray(product && product.tags) ? product.tags : [];
        if (needsHeavyFilter && !tagList.includes(ADULT_HEAVY_OK_TAG)) return false;
        if (needsExtremeFilter && !tagList.includes(ADULT_EXTREME_SOFTNESS_TAG)) return false;
        return true;
    });
    if (!filtered.length) {
        try { console.warn('[Quiz] Adult filters yielded no products; falling back to original list.'); } catch (e) { }
        return products;
    }
    return filtered;
}
function filterPillowProducts(products, answers, owner = 'self') {
    if (!Array.isArray(products) || !products.length) return products;
    const scopedAnswers = extractPillowAnswersForOwner(answers, owner);
    const exclusions = computePillowExclusionTags(scopedAnswers);
    if (!exclusions.length) return products;
    const excludeSet = new Set(exclusions);
    const filtered = products.filter((product) => {
        const tagList = Array.isArray(product && product.tags) ? product.tags : [];
        return !tagList.some(tag => excludeSet.has(tag));
    });
    if (!filtered.length) {
        try { console.warn('[Quiz] Pillow filters yielded no products; falling back to original list.'); } catch (e) { }
        return products;
    }
    return filtered;
}
function buildStorefrontQueryFromTags({ tags, productType }) {
    // Tag tekrarlarını kaldır
    const uniq = Array.from(new Set(tags || []));
    const parts = [];
    // İSTEK ÜZERİNE: product_type filtresi şimdilik kaldırıldı
    uniq.forEach(t => parts.push(`tag:'${t}'`));
    const q = parts.join(' ');
    return q;
}
function computeQueryFromAnswers(a) {
    const mapping = mapAnswersToTags(a);
    const contexts = [];
    const pushContext = (productType, tags, defaultFallback, extra = {}) => {
        const uniq = Array.from(new Set(tags || []));
        const fallbackText = defaultFallback || uniq.join(' ') || '';
        const storefrontQuery = uniq.length ? buildStorefrontQueryFromTags({ tags: uniq, productType }) : '';
        contexts.push({ productType, tags: uniq, storefrontQuery, fallbackText, ...extra });
    };
    if (mapping.mattressTags && mapping.mattressTags.length) {
        const mattressTags = (a && a.audience === 'adult') ? [ADULT_MATTRESS_BASE_TAG] : mapping.mattressTags;
        pushContext('Mattress', mattressTags, 'yatak');
    } else {
        pushContext('Mattress', [], 'yatak');
    }
    if (mapping.accessoryTags && mapping.accessoryTags.length) {
        pushContext('Accessory', mapping.accessoryTags, ADULT_ACCESSORY_FALLBACK);
    }
    if (mapping.childAccessoryTags && mapping.childAccessoryTags.length) {
        mapping.childAccessoryTags.forEach((tag) => {
            pushContext('Accessory', [tag], 'çocuk uyku aksesuarı', { childRecommendationType: 'accessory' });
        });
    }
    if (mapping.childFurnitureTags && mapping.childFurnitureTags.length) {
        mapping.childFurnitureTags.forEach((tag) => {
            pushContext('Furniture', [tag], 'çocuk yatağı mobilyası', { childRecommendationType: 'furniture' });
        });
    }
    if (mapping.pillowTags && mapping.pillowTags.length) {
        const ownerName = (a && a.self && a.self.name) ? a.self.name : null;
        pushContext('Pillow', mapping.pillowTags, 'yastik', { owner: 'self', ownerName });
    }
    if (mapping.partnerPillowTags && mapping.partnerPillowTags.length) {
        pushContext('Pillow', mapping.partnerPillowTags, 'yastik', { owner: 'partner', ownerName: 'Partneriniz' });
    }
    if (!contexts.length) {
        pushContext(mapping.productType || 'Mattress', mapping.tags || [], mapping.productType === 'Pillow' ? 'yastik' : 'yatak');
    }
    return { contexts, productType: mapping.productType };
}
function buildQueryVariantsFromTags(tags, productType) {
    const uniq = Array.from(new Set(tags || []));
    if (!uniq.length) return [];
    const toTag = (value) => "tag:'" + value + "'";
    if (productType === 'Pillow') {
        const pillowVariants = [];
        pillowVariants.push(uniq.map(toTag).join(' '));
        uniq.forEach(tag => pillowVariants.push(toTag(tag)));
        return Array.from(new Set(pillowVariants)).filter(Boolean);
    }
    const variants = [];
    const baseTag = uniq.includes(ADULT_MATTRESS_BASE_TAG) ? ADULT_MATTRESS_BASE_TAG : null;
    if (uniq.length) variants.push(uniq.map(toTag).join(' '));
    if (baseTag) {
        const withoutBase = uniq.filter(t => t !== baseTag);
        if (withoutBase.length) {
            variants.push([toTag(baseTag), ...withoutBase.map(toTag)].join(' '));
        }
    }
    const firmness = uniq.find(t => SOFTNESS_QUERY_TAGS.includes(t));
    const cooling = uniq.includes('cooling') ? toTag('cooling') : '';
    if (firmness) {
        const combo = [toTag(firmness)];
        if (cooling) combo.push(cooling);
        if (baseTag) combo.unshift(toTag(baseTag));
        variants.push(combo.join(' '));
    }
    if (firmness) variants.push(toTag(firmness));
    if (baseTag) variants.push(toTag(baseTag));
    if (uniq.length) variants.push(toTag(uniq[0]));
    return Array.from(new Set(variants)).filter(Boolean);
}
function getProductIdentity(product) {
    if (!product || typeof product !== 'object') return null;
    const handle = typeof product.handle === 'string' ? product.handle : null;
    if (handle) return `handle:${handle}`;
    const url = typeof product.url === 'string' ? product.url : null;
    if (url) return `url:${url}`;
    const title = typeof product.title === 'string' ? product.title : null;
    if (title) return `title:${title}`;
    return null;
}
function mergeProductsByKey(lists, limit = 9) {
    const merged = [];
    const seen = new Set();
    (lists || []).forEach((list) => {
        if (!Array.isArray(list)) return;
        list.forEach((product) => {
            if (!product) return;
            const key = getProductIdentity(product);
            if (key && seen.has(key)) return;
            if (key) seen.add(key);
            merged.push(product);
        });
    });
    if (typeof limit === 'number' && limit > 0) {
        return merged.slice(0, limit);
    }
    return merged;
}
function getProductHandle(product) {
    if (product && typeof product.handle === 'string' && product.handle) return product.handle.toLowerCase();
    const match = ((product && product.url) || '').match(/\/products\/([^\/?#]+)/);
    return match ? String(match[1]).toLowerCase() : '';
}
function productHasTag(product, tag) {
    const tags = Array.isArray(product && product.tags) ? product.tags : [];
    return tags.includes(tag);
}
function getProductCategoryMeta(product, entry, answers) {
    const isChildFlow = !!(answers && answers.audience === 'child');
    const handle = getProductHandle(product);
    const sectionSet = (entry && entry.sections) || new Set();
    const isMattress = !!detectChildMattressModel(product) || (product && typeof product.productType === 'string' && simplifyTurkishText(product.productType).includes('mattress'));
    const isFurniture = productHasTag(product, CHILD_FURNITURE_CRIB_TAG) || productHasTag(product, CHILD_FURNITURE_MONTESSORI_TAG) || productHasTag(product, CHILD_FURNITURE_NEXT_TO_ME_TAG);
    const isAlez = productHasTag(product, CHILD_ACCESSORY_RAIN_PROTECTOR_TAG) || handle.includes('rain');
    const isChildPillow = handle === CHILD_PILLOW_BABYKID_HANDLE || handle === CHILD_PILLOW_BUBBLE_HANDLE || handle === CHILD_PILLOW_ORIGINAL_HANDLE || handle === CHILD_PILLOW_WAVE_HANDLE || handle === MATERNITY_PILLOW_MOM_HANDLE || sectionSet.has('child_pillow');
    const isAnyPillow = isChildPillow || sectionSet.has('self_pillow') || sectionSet.has('partner_pillow') || (product && typeof product.productType === 'string' && simplifyTurkishText(product.productType).includes('pillow'));
    const isAccessory = productHasTag(product, CHILD_ACCESSORY_MOONIE_TAG) || productHasTag(product, CHILD_ACCESSORY_COSY_JR_QUILT_TAG) || productHasTag(product, CHILD_ACCESSORY_RAIN_PROTECTOR_TAG);
    if (isChildFlow) {
        if (isMattress) return { rank: 0, label: 'Yatak' };
        if (isAlez) return { rank: 1, label: 'Alez' };
        if (isFurniture) return { rank: 2, label: 'Mobilya' };
        if (isAnyPillow) return { rank: 3, label: 'Yastık' };
        if (isAccessory) return { rank: 4, label: 'Aksesuar' };
        return { rank: 5, label: 'Aksesuar' };
    }
    if (isMattress) return { rank: 0, label: 'Yatak' };
    if (isAnyPillow) return { rank: 1, label: 'Yastık' };
    if (isFurniture) return { rank: 2, label: 'Mobilya' };
    if (isAlez) return { rank: 3, label: 'Alez' };
    if (isAccessory) return { rank: 4, label: 'Aksesuar' };
    return { rank: 5, label: 'Ürün' };
}
async function renderResults(container) {
    const { contexts } = computeQueryFromAnswers(quizState.answers);
    delete quizState[MATTRESS_DECISION_STATE_KEY];
    const userEmail = (quizState.answers && typeof quizState.answers.email === 'string')
        ? quizState.answers.email.trim()
        : '';
    try {
        const ctxDebug = contexts.map(ctx => ({
            type: ctx.productType,
            query: ctx.storefrontQuery,
            fallback: ctx.fallbackText,
        }));
    } catch (e) { }
    const loading = document.createElement('div');
    loading.textContent = 'Ürünler yükleniyor...';
    container.appendChild(loading);
    const contextResults = [];
    const contextBundles = [];
    try {
        let t0 = 0;
        try { t0 = performance.now(); } catch (e) { }
        for (const ctx of contexts) {
            let contextProducts = [];
            const variants = buildQueryVariantsFromTags(ctx.tags, ctx.productType);
            if (SHOPIFY_STOREFRONT.token && variants.length) {
                for (const v of variants) {
                    const list = await fetchProductsByStorefront(v, 9);
                    if (list.length) { contextProducts = list; break; }
                }
            }
            if (!contextProducts.length) {
                const defaultText = ctx.productType === 'Pillow'
                    ? 'yastik'
                    : (ctx.productType === 'Accessory'
                        ? (ctx.childRecommendationType === 'accessory' ? 'çocuk uyku aksesuarı' : ADULT_ACCESSORY_FALLBACK)
                        : (ctx.productType === 'Furniture' ? 'çocuk yatağı mobilyası' : 'yatak'));
                const textQuery = ctx.fallbackText || defaultText;
                const base = await fetchProductsByPredictiveSearch(textQuery, 9);
                contextProducts = await enrichPredictiveProducts(base);
            }
            if (ctx.productType === 'Pillow') {
                contextProducts = filterPillowProducts(contextProducts, quizState.answers, ctx.owner);
            } else if (ctx.productType === 'Mattress' && quizState.answers && quizState.answers.audience !== 'adult') {
                contextProducts = filterAdultMattressProducts(contextProducts, quizState.answers);
            }
            contextResults.push(contextProducts);
            contextBundles.push({ context: ctx, products: contextProducts });
        }
        try {
            const t1 = performance.now();
        } catch (e) { }
    } catch (e) {
        console.warn('[Quiz] renderResults error:', e);
    }
    quizState.aiResponse = undefined;
    quizState.completionLogged = false;
    ensureSessionId();
    loading.remove();
    const mattressCandidates = mergeProductsByKey(contextBundles.filter(item => item.context.productType === 'Mattress').map(item => item.products), 9);
    const accessoryProducts = mergeProductsByKey(contextBundles.filter(item => item.context.productType === 'Accessory').map(item => item.products), 9);
    const furnitureProducts = mergeProductsByKey(contextBundles.filter(item => item.context.productType === 'Furniture').map(item => item.products), 9);
    let generalProducts = mergeProductsByKey(contextBundles.filter(item => item.context.productType !== 'Pillow').map(item => item.products), 9);
    if (quizState.answers && quizState.answers.audience === 'adult' && mattressCandidates.length) {
        const enrichedMattressCandidates = await enrichProductsForAI(mattressCandidates);
        const mattressDecision = rankAdultMattresses(quizState.answers, enrichedMattressCandidates);
        quizState[MATTRESS_DECISION_STATE_KEY] = mattressDecision;
        generalProducts = mergeProductsByKey([mattressDecision.products, accessoryProducts], 9);
    } else if (quizState.answers && quizState.answers.audience === 'child') {
        const childMattressDecision = rankChildMattresses(quizState.answers, mattressCandidates);
        quizState[MATTRESS_DECISION_STATE_KEY] = childMattressDecision;
        generalProducts = mergeProductsByKey([childMattressDecision.products, furnitureProducts, accessoryProducts], 9);
    }
    const selfPillowProducts = mergeProductsByKey(contextBundles.filter(item => item.context.productType === 'Pillow' && item.context.owner === 'self').map(item => item.products), 9);
    const partnerPillowProducts = mergeProductsByKey(contextBundles.filter(item => item.context.productType === 'Pillow' && item.context.owner === 'partner').map(item => item.products), 9);
    let childPillowProducts = [];
    if (quizState.answers && quizState.answers.audience === 'child') {
        const childPillowHandles = getChildPillowHandles(quizState.answers);
        if (childPillowHandles.length) {
            try {
                childPillowProducts = await fetchProductsByHandles(childPillowHandles);
            } catch (e) {
                console.warn('[Quiz] Child pillow handle fetch failed:', e);
                childPillowProducts = [];
            }
        }
    }
    const generalLog = buildRecommendedLog(generalProducts || []).map(entry => ({ ...entry, section: 'general' }));
    const selfLog = buildRecommendedLog(selfPillowProducts || []).map(entry => ({ ...entry, section: 'self_pillow' }));
    const partnerLog = buildRecommendedLog(partnerPillowProducts || []).map(entry => ({ ...entry, section: 'partner_pillow', owner: 'Partneriniz' }));
    const childPillowLog = buildRecommendedLog(childPillowProducts || []).map(entry => ({ ...entry, section: 'child_pillow' }));
    quizState.recommendedLog = [...generalLog, ...selfLog, ...partnerLog, ...childPillowLog];
    const supaLogger = window.SuiQuizLogger;
    if (supaLogger && typeof supaLogger.recordRecommended === 'function') {
        try { supaLogger.recordRecommended({ recommended: quizState.recommendedLog }); } catch (e) { }
    }
    const heroSection = document.createElement('section');
    heroSection.className = 'results-hero';
    const heroTop = document.createElement('div');
    heroTop.className = 'results-hero-top-grid';
    const heroLeftText = document.createElement('p');
    heroLeftText.className = 'results-hero-top-text';
    heroLeftText.textContent = 'Her uyku, kendi ritmini bulur.';
    const heroCenter = document.createElement('div');
    heroCenter.className = 'results-hero-top-center';
    const heroCenterImage = document.createElement('img');
    heroCenterImage.src = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/Group_1597883645.png?v=1778759013';
    heroCenterImage.alt = '';
    heroCenter.appendChild(heroCenterImage);
    const heroRightText = document.createElement('p');
    heroRightText.className = 'results-hero-top-text';
    heroRightText.textContent = 'Size en uygun uyku ürünleri hazır!';
    heroTop.appendChild(heroLeftText);
    heroTop.appendChild(heroCenter);
    heroTop.appendChild(heroRightText);
    const isMobileViewport = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
    if (isMobileViewport) {
        const quizOuter = container.closest('.sui-quiz');
        const quizContainer = container.closest('.quiz-container');
        if (quizOuter && quizContainer) {
            heroTop.classList.add('results-hero-top-grid-mobile-outside');
            quizOuter.insertBefore(heroTop, quizContainer);
        } else {
            heroSection.appendChild(heroTop);
        }
    } else {
        heroSection.appendChild(heroTop);
    }
    const summarySection = document.createElement('section');
    summarySection.className = 'results-ai-section results-ai-summary';
    const summaryBody = document.createElement('div');
    summaryBody.className = 'results-section-body';
    summaryBody.innerHTML = createAiLoadingMarkup('Kişisel özet hazırlanıyor...');
    summarySection.appendChild(summaryBody);
    heroSection.appendChild(summarySection);
    container.appendChild(heroSection);
    const productsSection = document.createElement('section');
    productsSection.className = 'results-ai-section results-ai-products';
    const productsHeading = document.createElement('h2');
    productsHeading.className = 'results-section-title';
    productsHeading.textContent = 'Önerilen Ürünler';
    productsSection.appendChild(productsHeading);
    const productListEl = document.createElement('div');
    productListEl.className = 'results-product-list';
    productsSection.appendChild(productListEl);
    container.appendChild(productsSection);
    const productEntries = [];
    const seenProducts = new Map();
    const addProductsToEntries = (items, section) => {
        (items || []).forEach((product) => {
            if (!product) return;
            const key = getProductIdentity(product);
            if (!key) return;
            let entry = seenProducts.get(key);
            if (!entry) {
                entry = { key, product, sections: new Set() };
                seenProducts.set(key, entry);
                productEntries.push(entry);
            }
            entry.sections.add(section);
        });
    };
    addProductsToEntries(generalProducts, 'general');
    addProductsToEntries(selfPillowProducts, 'self_pillow');
    addProductsToEntries(partnerPillowProducts, 'partner_pillow');
    addProductsToEntries(childPillowProducts, 'child_pillow');
    if (quizState.answers && quizState.answers.audience === 'child') {
        productEntries.sort((a, b) => {
            const metaA = getProductCategoryMeta(a.product, a, quizState.answers);
            const metaB = getProductCategoryMeta(b.product, b, quizState.answers);
            if (metaA.rank !== metaB.rank) return metaA.rank - metaB.rank;
            const roleA = (a.product && a.product.decision && a.product.decision.recommendationRole) || '';
            const roleB = (b.product && b.product.decision && b.product.decision.recommendationRole) || '';
            if (roleA !== roleB) {
                if (roleA === 'primary') return -1;
                if (roleB === 'primary') return 1;
                if (roleA === 'alternative') return -1;
                if (roleB === 'alternative') return 1;
            }
            return (a.product.title || '').localeCompare((b.product.title || ''), 'tr');
        });
    }
    const productSlots = [];
    if (!productEntries.length) {
        const empty = document.createElement('p');
        empty.className = 'results-empty';
        empty.textContent = 'Şu an uygun ürün bulunamadı. Daha genel terimlerle yeniden dene.';
        productsSection.appendChild(empty);
    } else {
        productEntries.forEach((entry) => {
            const product = entry.product || {};
            const card = document.createElement('div');
            card.className = 'results-product-card';
            if (product.image) {
                const media = document.createElement('div');
                media.className = 'results-product-media';
                const img = document.createElement('img');
                img.src = product.image;
                img.alt = product.title || '';
                media.appendChild(img);
                card.appendChild(media);
            }
            const content = document.createElement('div');
            content.className = 'results-product-content';
            const header = document.createElement('div');
            header.className = 'results-product-header';
            const nameEl = document.createElement('div');
            nameEl.className = 'results-product-title';
            nameEl.textContent = product.title || '';
            header.appendChild(nameEl);
            const categoryMeta = getProductCategoryMeta(product, entry, quizState.answers);
            const typeEl = document.createElement('div');
            typeEl.className = 'results-product-type';
            typeEl.textContent = categoryMeta.label;
            header.appendChild(typeEl);
            const productHandle = (typeof product.handle === 'string' && product.handle)
                || ((product.url || '').match(/\/products\/([^\/?#]+)/) || [])[1]
                || null;
            const productUrl = typeof product.url === 'string'
                ? product.url
                : (productHandle ? `${SHOPIFY_ROUTES_ROOT}products/${productHandle}` : null);
            if (productHandle || productUrl) {
                const openBtn = document.createElement('button');
                openBtn.type = 'button';
                openBtn.className = 'results-product-open';
                openBtn.textContent = 'Ürünü Gör';
                openBtn.onclick = (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    const modalFn = (typeof window.openProductModal === 'function') ? window.openProductModal : null;
                    if (modalFn && productHandle) {
                        modalFn(productHandle, product.title || '', productUrl || null);
                    } else if (productUrl) {
                        window.open(productUrl, '_blank', 'noopener');
                    }
                };
                header.appendChild(openBtn);
            }
            content.appendChild(header);
            const badgeConfigs = [];
            if (entry.sections.has('self_pillow')) {
                badgeConfigs.push({
                    icon: RESULTS_BADGE_SELF_ICON_URL,
                    text: 'Senin için yastık',
                });
            }
            if (entry.sections.has('partner_pillow')) {
                badgeConfigs.push({
                    icon: RESULTS_BADGE_PARTNER_ICON_URL,
                    text: 'Partneriniz için yastık',
                });
            }
            if (entry.sections.has('child_pillow')) {
                badgeConfigs.push({
                    icon: RESULTS_BADGE_SELF_ICON_URL,
                    text: productHandle === MATERNITY_PILLOW_MOM_HANDLE ? 'Hamilelik desteği' : 'Yaşa uygun yastık',
                });
            }
            if (quizState.answers && quizState.answers.audience === 'child') {
                // Child flow: generic "Senin için" badge is intentionally hidden.
            } else if (!entry.sections.has('self_pillow') && !entry.sections.has('partner_pillow') && !entry.sections.has('child_pillow')) {
                const hasPartner = !!quizState.partner;
                const sharedText = hasPartner
                    ? 'Sen & Partneriniz'
                    : 'Senin için';
                badgeConfigs.push({
                    icon: hasPartner ? RESULTS_BADGE_BOTH_ICON_URL : RESULTS_BADGE_SELF_ICON_URL,
                    text: sharedText,
                });
            }
            if (product.decision && (product.decision.recommendationRole === 'primary' || product.decision.recommendationRole === 'alternative')) {
                badgeConfigs.unshift({
                    text: product.decision.recommendationRole === 'primary' ? 'Kesin Öneri' : 'En Yakın Alternatif',
                    variant: product.decision.recommendationRole,
                });
            }
            if (badgeConfigs.length) {
                const badgesWrap = document.createElement('div');
                badgesWrap.className = 'results-product-badges';
                badgeConfigs.forEach((badgeCfg) => {
                    const badge = document.createElement('span');
                    badge.className = 'results-product-badge';
                    if (badgeCfg.variant) {
                        badge.classList.add(`results-product-badge--${badgeCfg.variant}`);
                    }
                    if (badgeCfg.icon) {
                        const badgeIcon = document.createElement('img');
                        badgeIcon.src = badgeCfg.icon;
                        badgeIcon.alt = '';
                        badgeIcon.className = 'results-product-badge-icon';
                        badge.appendChild(badgeIcon);
                    }
                    const badgeText = document.createElement('span');
                    badgeText.className = 'results-product-badge-text';
                    badgeText.textContent = badgeCfg.text;
                    badge.appendChild(badgeText);
                    badgesWrap.appendChild(badge);
                });
                content.appendChild(badgesWrap);
            }
            const aiSlot = document.createElement('div');
            aiSlot.className = 'results-product-ai is-loading';
            aiSlot.innerHTML = createAiLoadingMarkup('Analiz ediliyor...');
            content.appendChild(aiSlot);
            card.appendChild(content);
            productListEl.appendChild(card);
            productSlots.push({
                key: entry.key,
                product,
                aiEl: aiSlot,
                normalizedTitle: normalizeProductNameForMatch(product.title || ''),
                populated: false,
            });
        });
    }
    const finalSection = document.createElement('section');
    finalSection.className = 'results-ai-section results-ai-final';
    const finalHeading = document.createElement('h2');
    finalHeading.className = 'results-section-title';
    finalHeading.textContent = 'Kesin Seçim';
    const finalBody = document.createElement('div');
    finalBody.className = 'results-section-body';
    finalBody.innerHTML = createAiLoadingMarkup('Son öneriler hazırlanıyor...');
    finalSection.appendChild(finalHeading);
    finalSection.appendChild(finalBody);
    container.appendChild(finalSection);
    const productsForAI = await enrichProductsForAI(productEntries.map(entry => entry.product)) || [];
    const enrichedMap = new Map();
    (productsForAI || []).forEach((product) => {
        const key = getProductIdentity(product);
        if (key) enrichedMap.set(key, product);
    });
    productSlots.forEach((slot) => {
        const enriched = enrichedMap.get(slot.key);
        if (enriched) {
            slot.product = enriched;
            slot.normalizedTitle = normalizeProductNameForMatch(enriched.title || slot.product.title || '');
        }
    });
    await renderAIAdvice({
        products: productsForAI,
        summaryEl: summaryBody,
        finalEl: finalBody,
        productSlots,
    });
    // Baştan başla düğmesi (sağ altta)
    const restartBtn = document.createElement('button');
    restartBtn.type = 'button';
    restartBtn.className = 'quiz-button quiz-next';
    restartBtn.textContent = 'Baştan Başla';
    restartBtn.onclick = restartQuiz;
    const footerActions = document.createElement('div');
    footerActions.className = 'results-footer-actions';
    footerActions.appendChild(restartBtn);
    container.appendChild(footerActions);
}
// Gemini entegrasyonu (istemci tarafı - anahtarınızı client'a koymak güvenli değildir; tercihen bir proxy kullanın)
const GEMINI_CFG = {
    endpoint: (window.__GEMINI_ENDPOINT__ || 'https://generativelanguage.googleapis.com/v1beta/models'),
    model: (window.__GEMINI_MODEL__ || 'gemini-flash-latest'),
    generateApi: (window.__GEMINI_GENERATE_API__ || 'generateContent'),
    // Varsayılan olarak proxy route'u kullan; farklı bir proxy belirtmek istiyorsan window.__GEMINI_PROXY__ atayabilirsin.
    proxy: (window.__GEMINI_PROXY__ || '/api/quiz/gemini'),
};
function buildAiPrompt(answers, products) {
    const lines = [];
    const a = answers || {};
    const asText = (value) => {
        if (Array.isArray(value)) {
            return value.filter(Boolean).join(', ');
        }
        return value || '';
    };
    const introName = (typeof a.name === 'string') ? a.name.trim() : '';
    const profileName = (a.self && typeof a.self.name === 'string') ? a.self.name.trim() : '';
    const name = introName || profileName;
    if (name) lines.push(`Isim: ${name}`);
    if (a.audience) lines.push(`Kullanici tipi: ${a.audience === 'child' ? 'cocuk' : 'yetiskin'}`);
    if (a.self) {
        const s = a.self;
        const parts = [];
        if (s.age) parts.push(`${s.age} yas`);
        if (s.weight) parts.push(`${s.weight} kg`);
        if (s.height) parts.push(`${s.height} cm`);
        if (parts.length) lines.push(`Kullanici olculeri: ${parts.join(', ')}`);
    }
    if (a.partner) {
        const p = a.partner;
        const partnerParts = [];
        if (p.age) partnerParts.push(`${p.age} yas`);
        if (p.weight) partnerParts.push(`${p.weight} kg`);
        if (p.height) partnerParts.push(`${p.height} cm`);
        if (partnerParts.length) lines.push(`Partner bilgileri: ${partnerParts.join(', ')}`);
    }
    if (a.partner_weight && !(a.partner && a.partner.weight)) {
        lines.push(`Partner kilosu: ${a.partner_weight} kg`);
    }
    if (a.sleep_position) lines.push(`Uyku pozisyonu: ${a.sleep_position}`);
    if (a.sleep_position_partner) lines.push(`Partner uyku pozisyonu: ${a.sleep_position_partner}`);
    if (a.sleep_hot) lines.push(`Uykuda isinma: ${a.sleep_hot}`);
    if (a.sleep_hot_partner) lines.push(`Partner uykuda isinma: ${a.sleep_hot_partner}`);
    if (a.allergy_sensitivity) lines.push(`Alerji / hassasiyet: ${a.allergy_sensitivity}`);
    if (a.allergy_sensitivity_partner) lines.push(`Partner alerji / hassasiyet: ${a.allergy_sensitivity_partner}`);
    if (a.sleep_env_issues) lines.push(`Uyku ortami rahatsizliklari: ${asText(a.sleep_env_issues)}`);
    if (a.sleep_env_issues_partner) lines.push(`Partner uyku ortami rahatsizliklari: ${asText(a.sleep_env_issues_partner)}`);
    const painSelf = asText(a.pain);
    if (painSelf) lines.push(`Agri: ${painSelf}`);
    const painPartner = asText(a.pain_partner);
    if (painPartner) lines.push(`Partner agri: ${painPartner}`);
    const softnessSelf = a.softness_label || a.softness;
    if (softnessSelf) lines.push(`Yatak sertlik tercihi: ${softnessSelf}`);
    const softnessPartner = a.softness_label_partner || a.softness_partner;
    if (softnessPartner) lines.push(`Partner yatak sertlik tercihi: ${softnessPartner}`);
    const derivedFeelMode = normalizeAdultMattressInputs(a).derivedFeelMode;
    if (a.audience === 'adult' && derivedFeelMode) {
        const derivedFeelLabel = derivedFeelMode === 'non_spring'
            ? 'tok / doğal tarafa yakın'
            : (derivedFeelMode === 'spring_forward' ? 'esnek / dinamik tarafa yakın' : 'nötr');
        lines.push(`Türetilen yatak hissi eğilimi: ${derivedFeelLabel}`);
    }
    if (a.pillow_height || a.pillow_firmness) {
        if (a.pillow_height) lines.push(`Yastik yuksekligi: ${a.pillow_height}`);
        if (a.pillow_firmness) lines.push(`Yastik sertligi: ${a.pillow_firmness}`);
    }
    if (a.pillow_pref) lines.push(`Yastik tercihi: ${a.pillow_pref}`);
    if (a.pillow_height_partner || a.pillow_firmness_partner) {
        if (a.pillow_height_partner) lines.push(`Partneriniz yastik yuksekligi: ${a.pillow_height_partner}`);
        if (a.pillow_firmness_partner) lines.push(`Partneriniz yastik sertligi: ${a.pillow_firmness_partner}`);
    }
    if (a.bed_look_pref) lines.push(`Yatağın dış görünüm beklentisi: ${a.bed_look_pref}`);
    if (a.mattress_size) lines.push(`İstenen yatak ölçüsü: ${a.mattress_size}`);
    if (a.child_name) lines.push(`Çocuk adı: ${a.child_name}`);
    if (a.child_age_display) lines.push(`Çocuk yaşı: ${a.child_age_display}`);
    if (a.child_birth_date) lines.push(`Çocuk doğum tarihi: ${a.child_birth_date}`);
    if (a.audience === 'child' && isChildBirthDateFuture(a)) lines.push('Çocuk henüz doğmamış; hamilelik dönemi desteği önerilebilir.');
    if (a.child_bed_furniture) lines.push(`Çocuk yatağı için mobilya var mı: ${a.child_bed_furniture}`);
    if (a.child_furniture_type) lines.push(`Çocuk mobilya tipi: ${a.child_furniture_type}`);
    if (a.child_allergy) lines.push(`Çocuk hassasiyet / durum: ${a.child_allergy}`);
    if (a.child_bed_size) lines.push(`Çocuk yatak ölçüsü: ${a.child_bed_size}`);
    if (typeof quizState.bedSide === 'string') lines.push(`Yatak tarafi tercihi: ${quizState.bedSide}`);
    const mattressDecision = quizState[MATTRESS_DECISION_STATE_KEY];
    if (mattressDecision && Array.isArray(mattressDecision.selected) && mattressDecision.selected.length) {
        lines.push(`Yatak karar motoru fallback kullandı mı: ${mattressDecision.fallbackUsed ? 'evet' : 'hayır'}`);
        mattressDecision.selected.forEach((item, index) => {
            const positives = (item.positiveReasons || []).join(' | ');
            const penalties = (item.penaltyReasons || []).join(' | ');
            const firmness = item.chosenFirmness ? `; varyant: ${item.chosenFirmness}` : '';
            const roleLabel = item.recommendationRole === 'alternative' ? 'alternatif' : 'ana öneri';
            lines.push(`Karar motoru ${roleLabel}: ${item.modelLabel} (skor ${item.score}${firmness})`);
            if (item.chosenFirmnessByOwner) {
                const byOwnerParts = [];
                if (item.chosenFirmnessByOwner.self) byOwnerParts.push(`siz: ${item.chosenFirmnessByOwner.self}`);
                if (item.chosenFirmnessByOwner.partner) byOwnerParts.push(`partner: ${item.chosenFirmnessByOwner.partner}`);
                if (byOwnerParts.length) lines.push(`${item.modelLabel} kişi bazlı varyant önerisi: ${byOwnerParts.join(', ')}`);
            }
            if (positives) lines.push(`${item.modelLabel} artıları: ${positives}`);
            if (penalties) lines.push(`${item.modelLabel} tradeoffları: ${penalties}`);
        });
    }
    if (mattressDecision && Array.isArray(mattressDecision.eliminated) && mattressDecision.eliminated.length) {
        mattressDecision.eliminated.slice(0, 3).forEach((item) => {
            const blocks = (item.hardBlockReasons || []).join(' | ');
            const penalties = (item.penaltyReasons || []).join(' | ');
            if (blocks) {
                lines.push(`${item.modelLabel} elenme nedeni: ${blocks}`);
            } else if (penalties) {
                lines.push(`${item.modelLabel} neden geride kaldı: ${penalties}`);
            }
        });
    }
    // Ürünler – AI'nin metinde referans vermesi için detaylı bağlam
    function short(t) {
        if (!t) return '';
        return enforceSuiBrandOnlyText(String(t)).replace(/\s+/g, ' ').trim();
    }
    function cleanProductLine(line) {
        if (!line) return '';
        return String(line)
            .replace(/;\s*(etiketler|varyantlar):[^;]*/gi, '')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }
    const productLines = (products || []).map((p, idx) => {
        const price = p.price ? (p.currency ? `${p.price} ${p.currency}` : `${p.price}`) : '';
        const type = p.productType ? `; tür: ${p.productType}` : '';
        const feats = p.features && p.features.length ? `; özellikler: ${p.features.map(f => `${f.key || f.namespace}:${short(f.value)}`).join(', ')}` : '';
        const aiDef = p.aiDefinition ? `; ai_notu: ${short(p.aiDefinition)}` : '';
        const desc = !p.aiDefinition && p.description ? `; açıklama: ${short(p.description)}` : '';
        const decisionMeta = p.decision
            ? `; karar: ${p.decision.recommendationRole === 'alternative' ? 'alternatif' : 'ana öneri'}, skor ${p.decision.score}${p.decision.chosenFirmness ? `, varyant ${p.decision.chosenFirmness}` : ''}${p.decision.chosenFirmnessByOwner ? `, kişi bazlı varyant ${Object.entries(p.decision.chosenFirmnessByOwner).map(([key, value]) => `${key}:${value}`).join(' / ')}` : ''}${p.decision.positiveReasons && p.decision.positiveReasons.length ? `, artılar ${p.decision.positiveReasons.join(' / ')}` : ''}${p.decision.penaltyReasons && p.decision.penaltyReasons.length ? `, tradeoff ${p.decision.penaltyReasons.join(' / ')}` : ''}`
            : '';
        const line = `${idx + 1}. ${p.title}${price ? ' - ' + price : ''}${type}${feats}${aiDef}${desc}${decisionMeta}`;
        return cleanProductLine(line);
    });
    const base = `Aşağıdaki bilgilerle uyku alışkanlıklarımı ve ihtiyaçlarımı özetle ve kişisel bir tavsiye yaz. Çıktıyı yalın HTML ile ver (sadece <p>, <ul>, <li>, <strong>, <br> kullan):\n- ${lines.join('\n- ')}\n\nBiçim talebi:\n- İlk bölüm: 1 kısa paragraf hoş bir giriş ve durumu özetle.\n- İkinci bölüm: 'Önerilen Ürünler' başlığı olmadan, bir <ul> listesinde önerilen ürünlerin özelliklerini kullanıcının teste verdiği cevaplar ile birlikte değerlendirip açıkla; her madde: <strong>Ürün Adı</strong>: bir iki cümle somut gerekçe (ai_notu varsa ona dayan).\n- Son bölüm: 3 maddelik kısa özet, burada önerilen ürün türleri arasında kesin bir seçim yapması durumunda seçmesi gereken ürünü tavsiye et (<ul><li>... formatında).\n- Kullanıcıya ve partnere hitap ederken bey, hanım, beyefendi, hanımefendi gibi ifadeler kullanma; varsa sadece isimle hitap et, yoksa doğrudan hitapsız yaz.\n- Eğer kullanıcı tipi çocuk ise metinde çocuğa doğrudan hitap etme; ebeveyne (varsa ebeveyn ismine) hitap et ve çocuk adını üçüncü kişi olarak kullan.\n- Hiçbir ürün için olumsuz, kötüleyen, caydırıcı veya sert negatif yorum yapma. Bir ürün ana seçenek değilse bunu negatif anlatmak yerine, hangi kullanımda düşünülebileceğini yumuşak ve danışman diliyle açıkla.\n- Doa anlatılırken: kullanıcı kiloluysa veya yüzüstü yatıyorsa, yumuşak istese bile Sert varyantı öncelikli başlangıç önerisi olarak sun; ama bunu dayatma gibi değil, en güvenli başlangıç tercihi olarak anlat ve son kararın kullanıcıya ait olduğunu hissettir.\n- Uygun bir yerde tüm ürünlerde 100 gece deneme süresi olduğunu doğal biçimde hatırlat.\n- Sui Sleep dışındaki hiçbir marka adını asla kullanma. Rakip marka adı geçirme.\n- Ürün adlarını mutlaka <strong> ... </strong> ile kalın yaz. Eğer uniq yatak varsa önerilen yataklar arasında zaten kişiye özel yapılacağından sertliği kişinin vücuduna göre ayarlanarak üretilecektir.\n`;
    const withProducts = productLines.length
        ? `${base}- Yatak varsa mutlaka önce 1 ana yatak önerisi ver, sonra 1 alternatif yatak önerisi ver. Alternatif yatakta, kullanıcının hangi beklentilerinden taviz verirse bu alternatife dönebileceğini açıkça söyle.\n- Ürün kartı altındaki her açıklama bir satış danışmanı gibi yazılsın: neden uygun olduğunu cevaplarla ilişkilendir, ama varsa tradeoffları yumuşak ve pozitif bir dille belirt.\n- Ana yatak önerisinde neden en iyi eşleşme olduğunu söyle. Alternatif yatak önerisinde ise hangi beklentiler tam karşılanmıyor ama hangi avantajlar için yine düşünülebileceğini anlat.\n- Tavsiye edilen ürünleri tek tek ürün tipleri şeklinde gruplayarak(önce yataklar) isim vererek öner; neden uyduğunu ürün özellikleri üzerinden teste verilen cevaplarla düşünüp kişiselleştirerek doğal bir dille açıkla.\n- Eğer bir ürün için 'ai_notu' verilmişse, açıklama yerine onu esas al.\nÜrünler (bağlam):\n${productLines.map(l => '- ' + l).join('\n')}`
        : base;
    try {
    } catch (e) { }
    return withProducts;
}
async function callGemini(prompt) {
    const systemInstruction =
        'Türkçe konuşan uyku ve yatak asistanısın. Kişisel, pozitif ve net öneriler ver. Testten aldığın bilgiler doğrultusunda müşteriye tavsiye edilen ürünler hakkında bilgi de vererek bunlar arasında önermeler yap. Sui Sleep dışındaki hiçbir marka adını kullanma.';
    const payload = {
        contents: [
            {
                role: 'user',
                parts: [{ text: prompt }],
            },
        ],
        generationConfig: {
            thinkingConfig: { thinkingBudget: 0 },
        },
        systemInstruction: {
            parts: [{ text: systemInstruction }],
        },
    };
    try {
        // Öncelik: backend proxy (anahtar sunucu tarafında tutulur)
        if (GEMINI_CFG.proxy) {
            const proxyResponse = await fetch(GEMINI_CFG.proxy, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (proxyResponse.ok) {
                const proxyData = await proxyResponse.json().catch(() => ({}));
                if (proxyData && typeof proxyData.text === 'string') return proxyData.text;
                const candidate =
                    proxyData &&
                    proxyData.candidates &&
                    proxyData.candidates[0] &&
                    proxyData.candidates[0].content &&
                    proxyData.candidates[0].content.parts;
                if (Array.isArray(candidate) && candidate.length) {
                    return candidate.map((part) => part.text || '').join('');
                }
                return (proxyData && (proxyData.content || proxyData.message)) || null;
            }
            const detail = await proxyResponse.text().catch(() => '');
            console.warn('[Quiz][AI] Gemini proxy HTTP', proxyResponse.status, detail);
        }

        // Fallback: yalnızca local geliştirme için, pencereye manuel olarak atanmış bir anahtar varsa kullan
        const localApiKey =
            (typeof window !== 'undefined' && typeof window.__GEMINI_API_KEY__ === 'string')
                ? window.__GEMINI_API_KEY__
                : null;
        if (!localApiKey) {
            console.warn('[Quiz][AI] Proxy başarısız oldu ve Gemini API anahtarı bulunamadı.');
            return null;
        }

        const directRes = await fetch(
            `${GEMINI_CFG.endpoint}/${encodeURIComponent(GEMINI_CFG.model)}:${GEMINI_CFG.generateApi}?key=${encodeURIComponent(localApiKey)}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            });
        if (!directRes.ok) {
            const txt = await directRes.text().catch(() => '');
            console.warn('[Quiz][AI] Gemini HTTP', directRes.status, txt);
            return null;
        }
        const data = await directRes.json().catch(() => ({}));
        const parts =
            data &&
            data.candidates &&
            data.candidates[0] &&
            data.candidates[0].content &&
            data.candidates[0].content.parts;
        if (Array.isArray(parts) && parts.length) {
            return parts.map((part) => part.text || '').join('');
        }
        return null;
    } catch (e) {
        console.warn('[Quiz][AI] Gemini istek hatası:', e);
        return null;
    }
}
function normalizeProductNameForMatch(value) {
    if (!value) return '';
    return simplifyTurkishText(value).replace(/[^a-z0-9]+/g, '');
}
function createAiLoadingMarkup(text) {
    return `
      <div class="ai-loading">
        <span class="ai-spinner" aria-hidden="true">
          <svg viewBox="22 22 44 44">
            <circle cx="44" cy="44" r="20" fill="none" stroke-width="3.6"></circle>
          </svg>
        </span>
        <span class="ai-loading-text">${text}</span>
      </div>
    `;
}
function createEmailShareControl(emailValue) {
    const wrapper = document.createElement('div');
    wrapper.className = 'results-email-share';
    let input = null;
    if (!emailValue) {
        input = document.createElement('input');
        input.type = 'email';
        input.placeholder = 'E-posta adresiniz';
        input.className = 'results-email-share-input';
        wrapper.appendChild(input);
    }
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'quiz-button results-email-share-button';
    button.textContent = 'Sonuçlarımı e-postama gönder';
    wrapper.appendChild(button);
    return { wrapper, button, input };
}
function ensureProductModalStyles() {
    if (document.getElementById(PRODUCT_MODAL_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = PRODUCT_MODAL_STYLE_ID;
    style.type = 'text/css';
    style.textContent = PRODUCT_MODAL_STYLES;
    document.head.appendChild(style);
}
function ensureProductModalMarkup() {
    if (document.getElementById(PRODUCT_MODAL_OVERLAY_ID)) return;
    const markup = `
      <div id="${PRODUCT_MODAL_OVERLAY_ID}" class="results-modal is-hidden" aria-hidden="true">
        <div class="results-modal-dialog" role="dialog" aria-modal="true" aria-labelledby="sui-test-modal-title">
          <button type="button" class="results-modal-close" aria-label="Close">&times;</button>
          <h3 class="results-modal-title" id="sui-test-modal-title"></h3>
          <div class="results-modal-body">
            <div class="results-modal-body-inner"></div>
          </div>
          <div class="results-modal-footer">
            <a href="#" target="_blank" rel="noopener" class="results-modal-link">Ürün sayfasına git</a>
          </div>
        </div>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', markup);
}
function ensureProductModalController() {
    if (window.SuiTestModal && typeof window.SuiTestModal.open === 'function') {
        return window.SuiTestModal;
    }
    ensureProductModalStyles();
    ensureProductModalMarkup();
    const overlay = document.getElementById(PRODUCT_MODAL_OVERLAY_ID);
    if (!overlay) return null;
    const closeBtn = overlay.querySelector('.results-modal-close');
    const titleEl = overlay.querySelector('.results-modal-title');
    const bodyInner = overlay.querySelector('.results-modal-body-inner');
    const footerLink = overlay.querySelector('.results-modal-link');
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'TRY';
    const spinnerHtml = typeof window.createAiLoadingMarkup === 'function'
        ? window.createAiLoadingMarkup('Ürün bilgileri yukleniyor...')
        : '<div class="results-modal-loading">Ürün bilgileri yukleniyor...</div>';
    let keyHandler = null;
    const formatMoney = (value) => {
        if (value === undefined || value === null || value === '') return '';
        const cents = Number(value);
        if (Number.isNaN(cents)) return '';
        const amount = Math.round(cents) / 100;
        const suffix = currency === 'TRY' ? 'TL' : (currency || '').toUpperCase();
        try {
            const formatted = new Intl.NumberFormat('tr-TR', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(amount);
            return suffix ? `${formatted} ${suffix}` : formatted;
        } catch (e) {
            const fallback = `${Math.round(amount)}`;
            return suffix ? `${fallback} ${suffix}` : fallback;
        }
    };
    const setFooterLink = (url) => {
        if (!footerLink) return;
        if (url) {
            footerLink.href = url;
            footerLink.style.visibility = 'visible';
        } else {
            footerLink.href = '#';
            footerLink.style.visibility = 'hidden';
        }
    };
    const closeModal = () => {
        overlay.classList.add('is-hidden');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('results-modal-open');
        if (keyHandler) {
            document.removeEventListener('keydown', keyHandler);
            keyHandler = null;
        }
        if (bodyInner) {
            bodyInner.innerHTML = '';
        }
    };
    const showError = (message, fallbackUrl) => {
        if (!bodyInner) return;
        bodyInner.innerHTML = `
          <div class="results-modal-error">
            <p>${message}</p>
            ${fallbackUrl ? `<p><a href="${fallbackUrl}" target="_blank" rel="noopener">Ürünu yeni sekmede ac</a></p>` : ''}
          </div>
        `;
        setFooterLink(fallbackUrl);
    };
    const createGallery = (product, variants) => {
        const gallery = document.createElement('div');
        gallery.className = 'results-modal-gallery';
        const images = Array.isArray(product.images) && product.images.length
            ? product.images.slice()
            : [];
        if (!images.length && Array.isArray(variants)) {
            const variantWithImage = variants.find((variant) => variant.featured_image && variant.featured_image.src);
            if (variantWithImage) {
                images.push(variantWithImage.featured_image.src);
            }
        }
        const mainWrap = document.createElement('div');
        mainWrap.className = 'results-modal-main-image';
        let mainImg = null;
        if (images.length) {
            mainImg = document.createElement('img');
            mainImg.alt = product.title || '';
            mainImg.src = images[0];
            mainWrap.appendChild(mainImg);
        } else {
            mainWrap.classList.add('is-empty');
            mainWrap.textContent = 'Ürün gorseli mevcut degil';
        }
        gallery.appendChild(mainWrap);
        if (images.length > 1) {
            const thumbsWrap = document.createElement('div');
            thumbsWrap.className = 'results-modal-thumbs';
            images.forEach((url, idx) => {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'results-modal-thumb' + (idx === 0 ? ' is-active' : '');
                const img = document.createElement('img');
                img.src = url;
                img.alt = product.title ? `${product.title} ${idx + 1}` : `Ürün gorseli ${idx + 1}`;
                btn.appendChild(img);
                btn.addEventListener('click', () => {
                    const mainImageEl = mainWrap.querySelector('img');
                    if (mainImageEl) {
                        mainImageEl.src = url;
                    }
                    thumbsWrap.querySelectorAll('.results-modal-thumb').forEach((thumb) => thumb.classList.remove('is-active'));
                    btn.classList.add('is-active');
                });
                thumbsWrap.appendChild(btn);
            });
            gallery.appendChild(thumbsWrap);
        }
        const mainImageEl = mainWrap.querySelector('img') || null;
        return { gallery, mainImageEl };
    };
    const renderProduct = (product, handle, fallbackUrl) => {
        if (!bodyInner) return;
        const variants = Array.isArray(product.variants) ? product.variants : [];
        let optionSummaryLabels = [];
        let selectedVariant = variants.find((variant) => variant.available) || variants[0] || null;
        const productUrlBase = fallbackUrl || `${SHOPIFY_ROUTES_ROOT}products/${product.handle || handle || ''}`;
        const { gallery, mainImageEl } = createGallery(product, variants);
        const info = document.createElement('div');
        info.className = 'results-modal-info';
        const priceBlock = document.createElement('div');
        priceBlock.className = 'results-modal-price';
        const priceCurrent = document.createElement('span');
        priceCurrent.className = 'results-modal-price-current';
        const priceCompare = document.createElement('span');
        priceCompare.className = 'results-modal-price-compare';
        priceCompare.style.display = 'none';
        priceBlock.appendChild(priceCurrent);
        priceBlock.appendChild(priceCompare);
        info.appendChild(priceBlock);
        const updatePriceDisplay = (variant) => {
            const currentVariant = variant || selectedVariant;
            if (currentVariant) {
                priceCurrent.textContent = formatMoney(currentVariant.price) || '';
                if (currentVariant.compare_at_price && Number(currentVariant.compare_at_price) > Number(currentVariant.price)) {
                    priceCompare.textContent = formatMoney(currentVariant.compare_at_price) || '';
                    priceCompare.style.display = '';
                } else {
                    priceCompare.textContent = '';
                    priceCompare.style.display = 'none';
                }
                if (currentVariant.featured_image && currentVariant.featured_image.src && mainImageEl) {
                    mainImageEl.src = currentVariant.featured_image.src;
                }
                setFooterLink(`${productUrlBase}?variant=${currentVariant.id}`);
            } else {
                const fallbackPrice = product.price || product.price_min || product.price_max;
                priceCurrent.textContent = formatMoney(fallbackPrice) || '';
                priceCompare.textContent = '';
                priceCompare.style.display = 'none';
                setFooterLink(productUrlBase);
            }
        };
        if (variants.length) {
            const optionSelectors = [];
            const ADD_TO_CART_LABEL = 'Sepete Ekle';
            const variantsContainer = document.createElement('div');
            variantsContainer.className = 'results-modal-variants';
            const actionsContainer = document.createElement('div');
            actionsContainer.className = 'results-modal-actions';
            let variantStatusEl = null;
            let addToCartButton = null;
            const cartInterface = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            const setVariantStatus = (message, state) => {
                if (!variantStatusEl) return;
                variantStatusEl.textContent = message || '';
                if (state) {
                    variantStatusEl.dataset.state = state;
                } else {
                    delete variantStatusEl.dataset.state;
                }
                variantStatusEl.hidden = !message;
            };
            const setAddToCartState = () => {
                if (!addToCartButton) return;
                if (selectedVariant && selectedVariant.available) {
                    addToCartButton.disabled = false;
                    addToCartButton.textContent = ADD_TO_CART_LABEL;
                } else if (selectedVariant && !selectedVariant.available) {
                    addToCartButton.disabled = true;
                    addToCartButton.textContent = 'Stokta yok';
                } else {
                    addToCartButton.disabled = true;
                    addToCartButton.textContent = optionSelectors.length ? 'Varyant seciniz' : ADD_TO_CART_LABEL;
                }
            };
            const findVariantBySelections = () => {
                if (!optionSelectors.length) {
                    return selectedVariant;
                }
                return variants.find((variant) =>
                    optionSelectors.every(({ position, select }) => {
                        const key = `option${position}`;
                        const expected = typeof select.getValue === 'function' ? select.getValue() : '';
                        const actual = typeof variant[key] === 'string' ? variant[key] : '';
                        return expected ? actual === expected : true;
                    })
                ) || null;
            };
            const handleOptionChange = () => {
                const match = findVariantBySelections();
                if (match) {
                    selectedVariant = match;
                    updatePriceDisplay(match);
                    if (match.available) {
                        setVariantStatus('');
                    } else {
                        setVariantStatus('Bu varyant su anda stokta yok.', 'error');
                    }
                } else {
                    selectedVariant = null;
                    updatePriceDisplay(null);
                    setVariantStatus('Bu kombinasyon mevcut degil.', 'error');
                }
                setAddToCartState();
            };
            const getOptionValues = (position, providedValues) => {
                const provided = Array.isArray(providedValues) ? providedValues : [];
                const source = provided.length ? provided : variants.map((variant) => {
                    const key = `option${position}`;
                    return typeof variant[key] === 'string' ? variant[key] : '';
                });
                const cleaned = source
                    .map((value) => (typeof value === 'string' ? value.trim() : ''))
                    .filter((value) => value && value.toLowerCase() !== 'default title');
                return Array.from(new Set(cleaned));
            };
            const optionsSource = Array.isArray(product.options) ? product.options : [];
            const normalizedOptions = optionsSource
                .map((opt, idx) => {
                    if (!opt) return null;
                    if (typeof opt === 'string') {
                        const position = idx + 1;
                        const values = getOptionValues(position, []);
                        return values.length ? { name: opt, values, position } : null;
                    }
                    const position = typeof opt.position === 'number' ? opt.position : (idx + 1);
                    const name = typeof opt.name === 'string' ? opt.name : `Seçenek ${position}`;
                    const values = getOptionValues(position, opt.values);
                    return values.length ? { name, values, position } : null;
                })
                .filter((opt) => opt && opt.name && opt.name.toLowerCase() !== 'title' && opt.values.length);
            optionSummaryLabels = normalizedOptions.map((opt) => opt.name);
            normalizedOptions.forEach((opt) => {
                const wrapper = document.createElement('div');
                wrapper.className = 'results-modal-variant-label';
                const title = document.createElement('span');
                title.textContent = opt.name;
                wrapper.appendChild(title);
                const pills = document.createElement('div');
                pills.className = 'results-modal-variant-pills';
                let currentValue = selectedVariant ? String(selectedVariant[`option${opt.position}`] || '').trim() : '';
                if (!currentValue || !opt.values.includes(currentValue)) {
                    currentValue = opt.values.length ? String(opt.values[0]) : '';
                }
                const setActiveValue = (value) => {
                    currentValue = value;
                    pills.querySelectorAll('.results-modal-variant-pill').forEach((buttonEl) => {
                        buttonEl.classList.toggle('is-active', buttonEl.dataset.value === value);
                    });
                };
                opt.values.forEach((value) => {
                    const pill = document.createElement('button');
                    pill.type = 'button';
                    pill.className = 'results-modal-variant-pill';
                    pill.dataset.value = String(value);
                    pill.textContent = String(value);
                    pill.addEventListener('click', () => {
                        setActiveValue(String(value));
                        handleOptionChange();
                    });
                    pills.appendChild(pill);
                });
                setActiveValue(currentValue);
                wrapper.appendChild(pills);
                variantsContainer.appendChild(wrapper);
                optionSelectors.push({
                    position: opt.position,
                    select: {
                        getValue: () => currentValue,
                        setValue: setActiveValue,
                    },
                });
            });
            const fetchCartState = () => {
                const cartUrl = (window.routes && typeof window.routes.cart_url === 'string')
                    ? `${window.routes.cart_url.replace(/\/+$/, '')}.js`
                    : `${SHOPIFY_ROUTES_ROOT}cart.js`;
                return fetch(cartUrl, { credentials: 'same-origin' })
                    .then((res) => (res.ok ? res.json() : null))
                    .catch((err) => {
                        console.warn('[SuiTestModal] Cart fetch failed:', err);
                        return null;
                    });
            };
            const updateCartCountDisplay = (cart) => {
                if (!cart || typeof cart.item_count !== 'number') return;
                const countText = String(cart.item_count);
                const countTargets = document.querySelectorAll('[data-cart-count], [data-cart-count-bubble], .cart-count-bubble__count, .cart-count, .header-cart-count');
                countTargets.forEach((el) => {
                    try {
                        if ('value' in el) {
                            el.value = countText;
                        } else {
                            el.textContent = countText;
                        }
                        if (el.dataset && 'cartCountBubble' in el.dataset) {
                            const bubble = el.closest('[data-cart-count-bubble]');
                            if (bubble && bubble.classList && typeof bubble.classList.toggle === 'function') {
                                bubble.classList.toggle('is-hidden', cart.item_count === 0);
                            }
                        }
                    } catch (err) {
                        console.warn('[SuiTestModal] Failed to update cart count target:', err);
                    }
                });
            };
            const dispatchCartEvents = (cart) => {
                const detail = { cart };
                const targets = [window, document, document.body].filter(Boolean);
                const createCartEvent = (eventName) => {
                    if (typeof window.CustomEvent === 'function') {
                        return new CustomEvent(eventName, { detail });
                    }
                    try {
                        const evt = document.createEvent('CustomEvent');
                        evt.initCustomEvent(eventName, true, true, detail);
                        return evt;
                    } catch (err) {
                        return null;
                    }
                };
                ['cart:refresh', 'cart:updated', 'cart:change', 'sui:cart-updated'].forEach((eventName) => {
                    targets.forEach((target) => {
                        const evt = createCartEvent(eventName);
                        if (!evt) return;
                        try {
                            target.dispatchEvent(evt);
                        } catch (err) {
                            // ignore individual dispatch failures to avoid breaking flow
                        }
                    });
                });
                if (window && typeof window.updateCartDrawer === 'function') {
                    try { window.updateCartDrawer(cart); } catch (err) { console.warn('[SuiTestModal] updateCartDrawer error:', err); }
                }
                if (window && window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
                    try { window.Shopify.onCartUpdate(cart); } catch (err) { console.warn('[SuiTestModal] Shopify.onCartUpdate error:', err); }
                }
            };
            const publishCartUpdate = (cartData) => {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
                    try {
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'sui-quiz-modal',
                            cartData,
                            productVariantId: selectedVariant ? String(selectedVariant.id) : null,
                            variantId: selectedVariant ? selectedVariant.id : null,
                        });
                    } catch (err) {
                        console.warn('[SuiTestModal] publish cartUpdate failed:', err);
                    }
                }
            };
            const ensureCartInterfaceState = () => {
                if (cartInterface && cartInterface.classList && cartInterface.classList.contains('is-empty')) {
                    cartInterface.classList.remove('is-empty');
                }
            };
            const handleCartSuccess = (cart) => {
                if (cart && typeof cart.item_count === 'number') {
                    updateCartCountDisplay(cart);
                    dispatchCartEvents(cart);
                    setVariantStatus('Ürün sepete eklendi.', 'success');
                    return;
                }
                fetchCartState().then((cartState) => {
                    if (cartState) {
                        updateCartCountDisplay(cartState);
                        dispatchCartEvents(cartState);
                    }
                    setVariantStatus('Ürün sepete eklendi.', 'success');
                });
            };
            addToCartButton = document.createElement('button');
            addToCartButton.type = 'button';
            addToCartButton.className = 'results-modal-add-to-cart';
            addToCartButton.textContent = ADD_TO_CART_LABEL;
            addToCartButton.addEventListener('click', () => {
                if (!selectedVariant) {
                    setVariantStatus('Lutfen gecerli bir varyant seciniz.', 'error');
                    setAddToCartState();
                    return;
                }
                if (!selectedVariant.available) {
                    setVariantStatus('Bu varyant su anda stokta yok.', 'error');
                    setAddToCartState();
                    return;
                }
                setVariantStatus('');
                addToCartButton.disabled = true;
                addToCartButton.textContent = 'Ekleniyor...';
                const cartEndpoint = (window.routes && typeof window.routes.cart_add_url === 'string')
                    ? window.routes.cart_add_url
                    : `${SHOPIFY_ROUTES_ROOT}cart/add.js`;
                const config = typeof fetchConfig === 'function'
                    ? fetchConfig('javascript')
                    : {
                        method: 'POST',
                        headers: {},
                        credentials: 'same-origin',
                    };
                if (!config.headers) config.headers = {};
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                if (config.headers['Content-Type']) {
                    delete config.headers['Content-Type'];
                }
                if (!config.credentials) {
                    config.credentials = 'same-origin';
                }
                const formData = new FormData();
                formData.append('id', selectedVariant.id);
                formData.append('quantity', 1);
                if (cartInterface && typeof cartInterface.getSectionsToRender === 'function') {
                    try {
                        const sections = cartInterface
                            .getSectionsToRender()
                            .map((section) => section && section.id)
                            .filter(Boolean);
                        if (sections.length) {
                            formData.append('sections', sections.join(','));
                            formData.append('sections_url', window.location.pathname);
                        }
                        if (typeof cartInterface.setActiveElement === 'function') {
                            cartInterface.setActiveElement(document.activeElement || addToCartButton);
                        }
                    } catch (err) {
                        console.warn('[SuiTestModal] Failed to configure cart sections:', err);
                    }
                }
                config.body = formData;
                fetch(cartEndpoint, config)
                    .then((res) => res.json())
                    .then((response) => {
                        if (response && response.status) {
                            const errorMessage =
                                (response.errors && typeof response.errors === 'object'
                                    ? Object.values(response.errors).flat().join(', ')
                                    : null) ||
                                response.description ||
                                response.message ||
                                'Sepete eklenemedi. Lutfen tekrar deneyin.';
                            setVariantStatus(errorMessage, 'error');
                            return;
                        }
                        publishCartUpdate(response);
                        if (cartInterface && typeof cartInterface.renderContents === 'function') {
                            try {
                                cartInterface.renderContents(response);
                                ensureCartInterfaceState();
                                if (response && typeof response.item_count === 'number') {
                                    updateCartCountDisplay(response);
                                    dispatchCartEvents(response);
                                    setVariantStatus('Ürün sepete eklendi.', 'success');
                                } else {
                                    handleCartSuccess(response);
                                }
                            } catch (err) {
                                console.warn('[SuiTestModal] cartInterface.renderContents failed:', err);
                                handleCartSuccess(response);
                            }
                        } else {
                            handleCartSuccess(response);
                        }
                    })
                    .catch((err) => {
                        console.warn('[SuiTestModal] Add to cart failed:', err);
                        setVariantStatus('Sepete eklenirken bir sorun olustu. Lutfen tekrar deneyin.', 'error');
                    })
                    .finally(() => {
                        setAddToCartState();
                    });
            });
            actionsContainer.appendChild(addToCartButton);
            variantStatusEl = document.createElement('p');
            variantStatusEl.className = 'results-modal-variant-status';
            variantStatusEl.hidden = true;
            actionsContainer.appendChild(variantStatusEl);
            variantsContainer.appendChild(actionsContainer);
            if (variantsContainer.childElementCount) {
                info.appendChild(variantsContainer);
            }
            handleOptionChange();
        }
        if (Array.isArray(product.options)) {
            const optionLabels = (optionSummaryLabels.length ? optionSummaryLabels : product.options
                .map((opt) => {
                    if (!opt) return null;
                    if (typeof opt === 'string') return opt;
                    if (typeof opt.name === 'string') return opt.name;
                    return null;
                }))
                .filter((name) => name && name.toLowerCase() !== 'title');
            if (optionLabels.length > 1) {
                const optionsInfo = document.createElement('p');
                optionsInfo.className = 'results-modal-options';
                optionsInfo.textContent = `Seçenekler: ${optionLabels.join(', ')}`;
                info.appendChild(optionsInfo);
            }
        }
        if (product.description) {
            const descHeading = document.createElement('h4');
            descHeading.className = 'results-modal-subtitle';
            descHeading.textContent = 'Ürün Açıklaması';
            info.appendChild(descHeading);
            const description = document.createElement('div');
            description.className = 'results-modal-description';
            description.innerHTML = product.description;
            info.appendChild(description);
        }
        const content = document.createElement('div');
        content.className = 'results-modal-content';
        content.appendChild(gallery);
        content.appendChild(info);
        bodyInner.innerHTML = '';
        bodyInner.appendChild(content);
        updatePriceDisplay(selectedVariant || null);
        if (!variants.length) {
            setFooterLink(productUrlBase);
        }
    };
    const controller = {
        open(handle, title, fallbackUrl) {
            overlay.classList.remove('is-hidden');
            overlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('results-modal-open');
            if (titleEl) titleEl.textContent = title || 'Ürün Detayi';
            setFooterLink(fallbackUrl || (handle ? `${SHOPIFY_ROUTES_ROOT}products/${handle}` : '#'));
            if (bodyInner) {
                bodyInner.innerHTML = spinnerHtml;
            }
            if (closeBtn) {
                closeBtn.focus({ preventScroll: true });
            }
            if (keyHandler) {
                document.removeEventListener('keydown', keyHandler);
            }
            keyHandler = (evt) => {
                if (evt.key === 'Escape') closeModal();
            };
            document.addEventListener('keydown', keyHandler);
            if (!handle) {
                showError('Ürün bilgisi bulunamadi.', fallbackUrl || null);
                return;
            }
            const productUrl = `${SHOPIFY_ROUTES_ROOT}products/${encodeURIComponent(handle)}.js`;
            fetch(productUrl, { credentials: 'same-origin' })
                .then((res) => {
                    if (!res.ok) throw new Error(`HTTP ${res.status}`);
                    return res.json();
                })
                .then((productData) => {
                    renderProduct(productData, handle, fallbackUrl || null);
                })
                .catch((error) => {
                    console.warn('[SuiTestModal] Product data fetch failed:', error);
                    showError(
                        'Ürün detaylari yuklenemedi. Lutfen daha sonra tekrar deneyin.',
                        fallbackUrl || `${SHOPIFY_ROUTES_ROOT}products/${handle}`
                    );
                });
        },
        close: closeModal,
    };
    if (!overlay.dataset.bound) {
        if (closeBtn) {
            closeBtn.addEventListener('click', closeModal);
        }
        overlay.addEventListener('click', (evt) => {
            if (evt.target === overlay) closeModal();
        });
        overlay.dataset.bound = 'true';
    }
    window.SuiTestModal = controller;
    return controller;
}
function openProductModal(handle, title, fallbackUrl) {
    const controller = ensureProductModalController();
    if (controller && typeof controller.open === 'function') {
        controller.open(handle, title, fallbackUrl);
        return;
    }
    const redirectUrl = fallbackUrl || (handle ? `${SHOPIFY_ROUTES_ROOT}products/${encodeURIComponent(handle)}` : null);
    if (redirectUrl) {
        window.open(redirectUrl, '_blank', 'noopener');
    } else {
        console.warn('[Quiz] openProductModal: modal component unavailable and no redirect URL could be determined.');
    }
}
function parseAiAdviceSections(html) {
    const result = { summaryHtml: '', productItems: [], finalHtml: '' };
    try {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const nodes = Array.from(doc.body.childNodes).filter((node) => {
            if (node.nodeType === 1) return true;
            return node.nodeType === 3 && node.textContent.trim();
        });
        const elements = nodes.map((node) => {
            if (node.nodeType === 1) return node;
            const p = doc.createElement('p');
            p.textContent = node.textContent.trim();
            return p;
        });
        const summaryEl = elements.find(el => el.tagName !== 'UL');
        if (summaryEl) {
            result.summaryHtml = summaryEl.outerHTML;
        }
        const lists = elements.filter(el => el.tagName === 'UL');
        if (lists[0]) {
            result.productItems = Array.from(lists[0].querySelectorAll('li')).map((li) => {
                const strong = li.querySelector('strong');
                const name = strong ? strong.textContent.trim() : '';
                return { name, html: li.innerHTML.trim() };
            });
        }
        if (lists[1]) {
            result.finalHtml = lists[1].outerHTML;
        }
    } catch (e) { }
    if (!result.summaryHtml) {
        result.summaryHtml = html;
    }
    return result;
}
function extractProductExplanation(html) {
    if (typeof document === 'undefined') return html;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = `<li>${html}</li>`;
    const li = wrapper.querySelector('li');
    if (!li) return html;
    const strong = li.querySelector('strong');
    if (strong) strong.remove();
    let cleaned = li.innerHTML.trim();
    cleaned = cleaned.replace(/^[:\-–\s]+/, '');
    cleaned = cleaned.replace(/^\(#?[0-9a-fA-F]{6}\):\s*/, '');
    return cleaned || html;
}
function findProductSlot(item, slots) {
    if (!item || !Array.isArray(slots) || !slots.length) return null;
    const candidates = [];
    if (item.name) candidates.push(item.name);
    if (item.html) {
        const plain = item.html.replace(/<[^>]+>/g, ' ');
        if (plain) candidates.push(plain);
    }
    for (const candidate of candidates) {
        const normalized = normalizeProductNameForMatch(candidate);
        if (!normalized) continue;
        let match = slots.find(slot => slot.normalizedTitle === normalized);
        if (match) return match;
        match = slots.find(slot =>
            slot.normalizedTitle &&
            (slot.normalizedTitle.includes(normalized) || normalized.includes(slot.normalizedTitle))
        );
        if (match) return match;
    }
    return null;
}
function buildProductFallbackExplanation(product) {
    if (!product || typeof product !== 'object') return '';
    const aiDef = typeof product.aiDefinition === 'string' ? product.aiDefinition.trim() : '';
    if (aiDef) return enforceSuiBrandOnlyText(aiDef);
    const desc = typeof product.description === 'string' ? product.description.trim() : '';
    if (!desc) return '';
    const plain = enforceSuiBrandOnlyText(desc).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    if (!plain) return '';
    if (plain.length <= 220) return plain;
    return `${plain.slice(0, 217).trim()}...`;
}
async function renderAIAdvice({ products, summaryEl, finalEl, productSlots }) {
    const safeProducts = Array.isArray(products) ? products : [];
    try {
    } catch (e) { }
    const prompt = buildAiPrompt(quizState.answers, safeProducts);
    let t0 = 0;
    try {
        t0 = performance.now();
    } catch (e) { }
    const text = await callGemini(prompt);
    try {
        const t1 = performance.now();
    } catch (e) { }
    const safeText = text ? enforceSuiBrandOnlyText(text) : null;
    quizState.aiResponse = safeText || null;
    const supaLogger = window.SuiQuizLogger;
    if (supaLogger && typeof supaLogger.recordRecommended === 'function') {
        try { supaLogger.recordRecommended({ recommended: quizState.recommendedLog, aiResponse: quizState.aiResponse }); } catch (e) { }
    }
    if (!safeText) {
        if (summaryEl) summaryEl.textContent = 'Şu an kişisel özet oluşturulamadı. Lutfen daha sonra tekrar dene.';
        if (finalEl) finalEl.textContent = 'Son önerileri şu anda getiremiyoruz.';
        (productSlots || []).forEach((slot) => {
            if (!slot || !slot.aiEl) return;
            slot.aiEl.textContent = 'AI açıklaması alınamadı.';
            slot.aiEl.classList.remove('is-loading');
        });
        emitQuizCompletionLog();
        return;
    }
    const hasTags = /<\/?[a-z][\s\S]*>/i.test(safeText);
    let html = safeText;
    if (!hasTags) {
        html = safeText
            .split(/\n{2,}/).map(p => `<p>${p.replace(/\n/g, '<br>')}</p>`).join('');
        try {
            safeProducts.forEach((p) => {
                if (!p || !p.title) return;
                const re = new RegExp(p.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
                html = html.replace(re, m => `<strong>${m}</strong>`);
            });
        } catch (e) { }
    }
    const sections = parseAiAdviceSections(html);
    if (summaryEl) {
        summaryEl.innerHTML = sections.summaryHtml || html;
    }
    const unmatched = [];
    (sections.productItems || []).forEach((item) => {
        const slot = findProductSlot(item, productSlots || []);
        if (slot && slot.aiEl) {
            const explanation = extractProductExplanation(item.html);
            slot.aiEl.innerHTML = explanation;
            slot.aiEl.classList.remove('is-loading');
            slot.populated = true;
        } else {
            unmatched.push(item);
        }
    });
    (productSlots || []).forEach((slot) => {
        if (!slot || !slot.aiEl) return;
        if (!slot.populated) {
            const fallback = buildProductFallbackExplanation(slot.product);
            slot.aiEl.textContent = fallback || 'Bu ürün için ekstra açıklama bulunamadı.';
        }
        slot.aiEl.classList.remove('is-loading');
    });
    if (finalEl) {
        finalEl.innerHTML = sections.finalHtml || '';
        if (unmatched.length) {
            const extraList = document.createElement('ul');
            extraList.className = 'results-ai-unmatched';
            unmatched.forEach((item) => {
                const li = document.createElement('li');
                li.innerHTML = item.html;
                extraList.appendChild(li);
            });
            finalEl.appendChild(extraList);
        }
    }
    emitQuizCompletionLog();
}
const questions = [
    {
        id: "email",
        title: "İyi Uyudun Mu?",
        description: "",
        inputType: "email",
        inputPlaceholder: "E-posta adresiniz (Opsiyonel)",
        buttonText: "Teste Başla",
        checkboxText: "Sui Sleep kampanyalarından faydalanmak için tarafıma elektronik ileti göndermesi için izin veriyorum.",
    },
    {
        id: 'who_for',
        text: 'Kimin için yatak bakıyorsunuz?',
        description: 'Doğru yönlendirme yapabilmemiz için yatağınızı kimin kullanacağını seçin.',
        type: 'answer_choice',
        // Grup bazlı seçimler: yükseklik ve sertlik
        groupTitle1: 'Yükkseklik',
        heightOptions: ['Yuksek', 'Orta', 'Alcak'],
        groupTitle2: 'Sertlik',
        firmnessOptions: ['Sert', 'Orta', 'Yumuşak'],
        options: [
            { label: 'Kendim için', value: 'adult', next: 'partner' },
            { label: 'Çocuğum için', value: 'child', next: 'child_name' },
        ],
    },
    {
        id: 'child_name',
        text: 'Bebeğinizin / çocuğunuzun adı ne?',
        type: 'child_name',
        next: 'child_age',
    },
    {
        id: 'partner',
        text: 'Bu yatağı kaç kişi kullanacak?',
        description: 'Paylaşımlı kullanım, konfor ve hareket yalıtımı ihtiyacını etkileyebilir.',
        type: 'answer_choice',
        options: [
            { label: 'Sadece ben', value: 'solo', next: 'sleep_env_issues' },
            { label: 'Partnerimle birlikte', value: 'partner', next: 'sleep_env_issues' },
        ],
    },
    {
        id: 'sleep_env_issues',
        text: 'Neden yeni bir yatağa ihtiyaç duyuyorsunuz?',
        description: 'Değişim ihtiyacınızı en iyi anlatan seçeneği işaretleyin; önerilerimizi buna göre şekillendirelim.',
        type: 'answer_choice',
        options: [
            { label: 'Yatağım artık beni taşımıyor, çökmüş', next: 'self_form' },
            { label: 'Sabahları ağrıyla uyanmaya başladım', next: 'self_form' },
            { label: 'Yeterince dinlenip uyuyamıyorum', next: 'self_form' },
            { label: 'Taşındım, yeni bir başlangıç istiyorum', next: 'self_form' },
            { label: 'Partnerimle birlikte uyuyacağız', next: 'partner_both' },
        ],
    },
    {
        id: 'self_form',
        text: 'Sizi tanıyalım',
        type: 'single_form',
        next: 'softness',
    },
    {
        id: 'partner_both',
        text: 'Siz ve partnerinizi tanıyalım',
        type: 'dual_form',
        next: 'bed_side',
    },
    {
        id: 'bed_side',
        text: 'Yatağın hangi tarafında uyuyorsun?',
        description: 'Çift taraflı yataklarda farklı konfor seviyeleri önereceğimiz için yatağın hangi tarafında yattığını bilmemiz gerekiyor',
        type: 'answer_choice',
        options: [
            { label: 'Sol', next: 'softness' },
            { label: 'Sağ', next: 'softness' },
        ],
    },
    {
        id: 'softness',
        text: 'Bir yatağa uzandığınızda nasıl bir his arıyorsunuz?',
        type: 'answer_slider',
        min: 1,
        max: 5,
        step: 1,
        unit: '',
    },
    {
        id: 'spring_preference',
        text: 'Yatağınızı yaylı mı, yaysız mı tercih edersiniz?',
        description: 'Yaylı ya da yaysız yapı tercihinizi seçin; size ve partnerinize en uygun destek, sertlik ve konfor dengesini birlikte belirleyelim.',
        type: 'answer_choice',
        options: [
            { label: 'Yaylı tercih ederim', next: 'sleep_position' },
            { label: 'Yaysız, tok bir his', next: 'sleep_position' },
            { label: 'Fark etmez', next: 'sleep_position' },
        ],
    },
    {
        id: 'sleep_position',
        text: 'Adınız, gece kendini en çok hangi pozisyonda buluyorsun?',
        description: 'Burada en çok hangi pozisyonu tercih ettiğinizi düşünüp seçmeniz yatak ve yastık öneriniz açısından çok önemli.',
        type: 'answer_choice',
        options: [
            { label: 'Yüzüstü', next: 'sleep_hot' },
            { label: 'Yan', next: 'sleep_hot' },
            { label: 'Sırtüstü', next: 'sleep_hot' },
            { label: 'Değişiyor', next: 'sleep_hot' },
        ],
    },
    {
        id: 'sleep_position_partner',
        text: 'Partnerin gece kendini en çok hangi pozisyonda buluyor?',
        description: 'Burada en çok hangi pozisyonu tercih ettiğinizi düşünüp seçmeniz yatak ve yastık öneriniz açısından çok önemli.',
        type: 'answer_choice',
        options: [
            { label: 'Yüzüstü', next: 'sleep_hot' },
            { label: 'Yan', next: 'sleep_hot' },
            { label: 'Sırtüstü', next: 'sleep_hot' },
            { label: 'Değişiyor', next: 'sleep_hot' },
        ],
    },
    {
        id: 'sleep_hot',
        text: 'Geceleri kendinizi nasıl hissedersiniz?',
        type: 'answer_choice',
        options: [
            { label: 'Çok sıcak uyurum, sık terliyorum', next: 'pain' },
            { label: 'Sıcak taraftayım ama çok terlemem', next: 'pain' },
            { label: 'Ne sıcak ne soğuk, dengeli', next: 'pain' },
            { label: 'Üşürüm, soğuk uyurum', next: 'pain' },
        ],
    },
    {
        id: 'pain',
        text: 'Sabah kalktığınızda bedeniniz size ne söylüyor?',
        type: 'answer_choice',
        options: [
            { label: 'Hiçbir şey, gayet iyiyim', next: 'allergy_sensitivity' },
            { label: 'Belim / sırtım ağrıyor', next: 'allergy_sensitivity' },
            { label: 'Omzum / boynum tutulmuş', next: 'allergy_sensitivity' },
            { label: 'Kalçam / dizim rahatsız', next: 'allergy_sensitivity' },
        ],
    },
    {
        id: 'allergy_sensitivity',
        text: 'Aşağıdaki durumlardan biri senin için geçerli mi?',
        type: 'answer_choice',
        options: [
            { label: 'Toz / ev tozu akarına hassasiyetim var', next: 'pillow_pref' },
            { label: 'Alerjik bünyem var (genel)', next: 'pillow_pref' },
            { label: 'Astım / nefes hassasiyeti yaşıyorum', next: 'pillow_pref' },
            { label: 'Hayır, bilinen bir alerjim yok', next: 'pillow_pref' },
        ],
    },
    {
        id: 'pillow_pref',
        text: 'Nasıl bir yastıkta uyumayı seversin?',
        type: 'answer_choice',
        options: [
            { label: 'Yüksek', next: 'bed_look_pref' },
            { label: 'Orta', next: 'bed_look_pref' },
            { label: 'Alçak', next: 'bed_look_pref' },
            { label: 'Sert', next: 'bed_look_pref' },
            { label: 'Yumuşak', next: 'bed_look_pref' },
        ],
    },
    {
        id: 'partner_pillow_pref',
        text: 'Partneriniz nasıl bir yastıkta uyumayı sever?',
        type: 'answer_choice',
        groupTitle1: 'Yükseklik',
        heightOptions: ['Yüksek', 'Orta', 'Alçak'],
        groupTitle2: 'Sertlik',
        firmnessOptions: ['Sert', 'Orta', 'Yumuşak'],
        options: [
            { label: 'Yüksek', next: 'bed_look_pref' },
            { label: 'Orta', next: 'bed_look_pref' },
            { label: 'Alçak', next: 'bed_look_pref' },
            { label: 'Sert', next: 'bed_look_pref' },
            { label: 'Yumuşak', next: 'bed_look_pref' },
        ],
    },
    {
        id: 'bed_look_pref',
        text: 'Peki yeni yatağınızın dış görünümü ile ilgili bir beklentiniz var mı?',
        type: 'answer_choice',
        options: [
            { label: 'Yüksek olmasını istiyoruz. +28cm', next: 'mattress_size' },
            { label: 'Alçak / ince olmasını istiyoruz. 18-20cm', next: 'mattress_size' },
            { label: 'Hiç farketmez.', next: 'mattress_size' },
        ],
    },
    {
        id: 'mattress_size',
        text: 'İstediğiniz yatak ölçüsü:',
        type: 'answer_choice',
        options: [
            { label: '90x190', next: 'end' },
            { label: '90x200', next: 'end' },
            { label: '100x200', next: 'end' },
            { label: '120x200', next: 'end' },
            { label: '140x190', next: 'end' },
            { label: '140x200', next: 'end' },
            { label: '150x200', next: 'end' },
            { label: '160x200', next: 'end' },
            { label: '180x200', next: 'end' },
            { label: '200x200', next: 'end' },
            { label: 'Özel ölçü', next: 'end' },
        ],
    },
    {
        id: 'child_age',
        text: 'Çocuğunun doğum tarihi nedir?',
        description: 'Henüz doğmadıysa beklenen doğum tarihini girebilirsiniz.',
        type: 'child_birth_date',
        next: 'child_bed_furniture',
    },
    {
        id: 'child_bed_furniture',
        text: 'Çocuğunuzun yatağı için bir mobilyanız var mı?',
        type: 'answer_choice',
        listStyleWithContinue: true,
        options: [
            { label: 'Evet', next: 'child_furniture_type' },
            { label: 'Hayır', next: 'child_furniture_type' },
        ],
    },
    {
        id: 'child_furniture_type',
        text: 'Hangi tip mobilyanız var?',
        type: 'answer_choice',
        options: [
            { label: 'Anne yanı / park yatak', next: 'child_allergy' },
            { label: 'Montessori / yer yatağı', next: 'child_allergy' },
            { label: 'Beşik', next: 'child_allergy' },
            { label: 'Karyola / baza', next: 'child_allergy' },
            { label: 'Henüz karar vermedim', next: 'child_allergy' },
        ],
    },
    {
        id: 'child_allergy',
        text: 'Çocuğunuzda özel bir hassasiyet ya da durum var mı?',
        type: 'answer_choice',
        listStyleWithContinue: true,
        options: [
            { label: 'Alerji veya astımı var', next: 'child_bed_size' },
            { label: 'Geceleri çok terliyor', next: 'child_bed_size' },
            { label: '%100 doğal malzeme tercih ediyorum', next: 'child_bed_size' },
            { label: 'Özel bir durum yok', next: 'child_bed_size' },
        ],
    },
    {
        id: 'child_bed_size',
        text: 'Çocuğunuzun yatağının ölçüsünü biliyor musunuz?',
        type: 'child_bed_size',
        next: 'end',
    },
    {
        id: 'end',
        text: 'Test tamamlandı! Teşekkür ederiz.',
        type: 'end',
    },
];
function renderQuestion(id) {
    const root = document.getElementById('quiz-root');
    const question = questions.find((q) => q.id === id);
    if (!question) return (root.innerHTML = '<p>Test tamamlandı. Teşekkürler!</p>');
    scrollQuizToTop();
    root.innerHTML = ''; // Clear old content
    // Responsive outer wrapper and inner container
    const outer = document.createElement('div');
    outer.className = 'sui-quiz';
    const activeAudience = (quizState && quizState.audience) || (quizState.answers && quizState.answers.audience) || null;
    if (activeAudience === 'child') {
        outer.classList.add('sui-quiz-child-flow');
    }
    const container = document.createElement('div');
    container.className = 'quiz-container';
    const topSlot = document.createElement('div');
    topSlot.className = 'quiz-top-slot';
    if (question.type !== 'end') {
        container.appendChild(topSlot);
    }
    const shouldRenderMobileHeader = !(question.id === 'email' || question.inputType || question.type === 'end');
    if (shouldRenderMobileHeader) {
        createMobileQuestionHeader(question, outer);
    }
    // Intro step (email) – render hero + form
    if (question.id === 'email' || question.inputType) {
        const step = document.createElement('div');
        step.className = 'sui-quiz-step intro-step';
        const headingWrap = document.createElement('div');
        headingWrap.className = 'intro-heading';
        const heading = document.createElement('h1');
        heading.textContent = question.title || 'İyi Uyudun Mu?';
        headingWrap.appendChild(heading);
        const subHeading = document.createElement('p');
        subHeading.className = 'intro-heading-subtitle';
        subHeading.textContent = 'Uykunuzu kendi tercihinize göre şekillendirin.';
        headingWrap.appendChild(subHeading);
        step.appendChild(headingWrap);
        const content = document.createElement('div');
        content.className = 'intro-content';
        const text = document.createElement('div');
        text.className = 'sui-quiz-text intro-text';
        if (question.description) {
            const desc = document.createElement('p');
            desc.className = 'intro-description';
            desc.textContent = question.description;
            text.appendChild(desc);
        }
        const form = document.createElement('div');
        form.className = 'intro-form';
        const nameInputWrap = document.createElement('div');
        nameInputWrap.className = 'sui-quiz-input-wrapper';
        const nameInput = document.createElement('input');
        nameInput.type = 'text';
        nameInput.placeholder = 'Adınız';
        nameInput.autocomplete = 'name';
        const nameTooltip = document.createElement('div');
        nameTooltip.className = 'intro-name-tooltip';
        nameTooltip.textContent = 'Size hitap edebilmemiz için lütfen adınızı yazınız.';
        nameTooltip.hidden = true;
        nameInputWrap.appendChild(nameInput);
        nameInputWrap.appendChild(nameTooltip);
        form.appendChild(nameInputWrap);
        const inputWrap = document.createElement('div');
        inputWrap.className = 'sui-quiz-input-wrapper';
        const emailInput = document.createElement('input');
        emailInput.type = question.inputType || 'email';
        emailInput.placeholder = question.inputPlaceholder || '';
        inputWrap.appendChild(emailInput);
        form.appendChild(inputWrap);
        if (question.checkboxText) {
            const consent = document.createElement('label');
            consent.className = 'sui-quiz-checkbox';
            const cb = document.createElement('input');
            cb.type = 'checkbox';
            cb.id = 'sui-quiz-consent';
            const span = document.createElement('span');
            span.textContent = question.checkboxText;
            consent.appendChild(cb);
            consent.appendChild(span);
            form.appendChild(consent);
        }
        const actions = document.createElement('div');
        actions.className = 'sui-quiz-input-wrapper intro-actions';
        const startBtn = document.createElement('button');
        startBtn.textContent = question.buttonText || 'Teste Başla';
        startBtn.onclick = () => {
            const rawName = toTitleCaseTr(nameInput.value || '');
            const rawEmail = (emailInput.value || '').trim();
            if (!rawName) {
                nameTooltip.hidden = false;
                nameInputWrap.classList.add('has-error');
                nameInput.focus();
                return;
            }
            if (emailInput.type === 'email' && rawEmail && !rawEmail.includes('@')) {
                alert('Lutfen geçerli bir e-posta adresi girin');
                return;
            }
            nameTooltip.hidden = true;
            nameInputWrap.classList.remove('has-error');
            const nextSelf = Object.assign({}, quizState.self || {}, { name: rawName });
            quizState.self = nextSelf;
            setAnswer('self', nextSelf);
            setAnswer('name', rawName);
            if (emailInput.type === 'email') {
                setAnswer('email', rawEmail || null);
            }
            if (question.checkboxText) {
                const consentInput = form.querySelector('#sui-quiz-consent');
                setAnswer('marketing_consent', !!(consentInput && consentInput.checked));
            }
            goTo('who_for', question.id);
        };
        nameInput.addEventListener('input', () => {
            const val = toTitleCaseTr(nameInput.value || '');
            if (val) {
                nameTooltip.hidden = true;
                nameInputWrap.classList.remove('has-error');
            }
        });
        actions.appendChild(startBtn);
        if (question.skipText) {
            const skip = document.createElement('a');
            skip.className = 'sui-quiz-skip intro-skip';
            skip.textContent = question.skipText;
            skip.href = '#';
            skip.onclick = (event) => {
                event.preventDefault();
                const rawName = toTitleCaseTr(nameInput.value || '');
                if (rawName) {
                    const nextSelf = Object.assign({}, quizState.self || {}, { name: rawName });
                    quizState.self = nextSelf;
                    setAnswer('self', nextSelf);
                    setAnswer('name', rawName);
                } else {
                    setAnswer('name', null);
                }
                setAnswer('email', null);
                if (question.checkboxText) {
                    setAnswer('marketing_consent', false);
                }
                goTo('who_for', question.id);
            };
            actions.appendChild(skip);
        }
        form.appendChild(actions);
        content.appendChild(text);
        content.appendChild(form);
        if (question.image) {
            const imgWrap = document.createElement('div');
            imgWrap.className = 'sui-quiz-image intro-image';
            const img = document.createElement('img');
            img.src = question.image;
            img.alt = question.title || 'Quiz görseli';
            imgWrap.appendChild(img);
            text.appendChild(imgWrap);
        }
        step.appendChild(content);
        container.appendChild(step);
    }
    // Geri butonu: tüm adımlar için üst bar kullanacağız; alttaki nav'ı devre dışı bırakıyoruz.
    if (false) {
        const nav = document.createElement('div');
        nav.className = 'quiz-nav';
        const backBtn = document.createElement('button');
        backBtn.type = 'button';
        backBtn.className = 'quiz-back';
        backBtn.textContent = 'Geri';
        backBtn.onclick = goBack;
        nav.appendChild(backBtn);
        container.appendChild(nav);
    }
    if (question.type === 'answer_choice') {
        // Split layout: left question, right choices
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        // Top bar + progress
        renderTopbarProgress(rightCol, question.id);
        // Özel: 'pain' sorusu — partner varsa iki kişi için ayrı, yoksa tek grup (4'lü grid)
        if (question.id === 'pain') {
            const noneLabel = NONE_PAIN_LABEL;
            if (quizState.partner) {
                const matrix = document.createElement('div');
                matrix.className = 'pain-matrix';
                const rows = [];
                const createCell = (row, who, optionLabel) => {
                    const cell = document.createElement('button');
                    cell.type = 'button';
                    cell.className = 'pain-matrix-cell';
                    cell.dataset.who = who;
                    cell.dataset.value = optionLabel;
                    const dot = document.createElement('span');
                    dot.className = 'pain-matrix-dot';
                    dot.setAttribute('aria-hidden', 'true');
                    cell.appendChild(dot);
                    cell.onclick = () => {
                        const isNone = optionLabel === noneLabel;
                        const willSelect = !cell.classList.contains('is-selected');
                        if (willSelect) {
                            if (isNone) {
                                rows.forEach((item) => {
                                    if (item.option.label !== noneLabel) {
                                        item[who].classList.remove('is-selected');
                                    }
                                });
                            } else {
                                rows.forEach((item) => {
                                    if (item.option.label === noneLabel) {
                                        item[who].classList.remove('is-selected');
                                    }
                                });
                            }
                            cell.classList.add('is-selected');
                        } else {
                            cell.classList.remove('is-selected');
                        }
                    };
                    return cell;
                };
                const header = document.createElement('div');
                header.className = 'pain-matrix-row pain-matrix-header';
                header.innerHTML = '<div class="pain-matrix-head-spacer"></div><div class="pain-matrix-col-head">Sen</div><div class="pain-matrix-col-head">Partnerin</div>';
                matrix.appendChild(header);
                (question.options || []).forEach((opt) => {
                    const row = document.createElement('div');
                    row.className = 'pain-matrix-row';
                    const label = document.createElement('div');
                    label.className = 'pain-matrix-label';
                    label.textContent = opt.label;
                    const selfCell = createCell(row, 'self', opt.label);
                    const partnerCell = createCell(row, 'partner', opt.label);
                    row.appendChild(label);
                    row.appendChild(selfCell);
                    row.appendChild(partnerCell);
                    matrix.appendChild(row);
                    rows.push({ option: opt, self: selfCell, partner: partnerCell });
                });
                rightCol.appendChild(matrix);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.onclick = () => {
                    const selectedSelf = rows.filter(r => r.self.classList.contains('is-selected')).map(r => r.option.label);
                    const selectedPartner = rows.filter(r => r.partner.classList.contains('is-selected')).map(r => r.option.label);
                    if (!selectedSelf.length || !selectedPartner.length) {
                        alert('Lutfen her iki kişi için en az bir seçenek seçin');
                        return;
                    }
                    const filteredSelf = selectedSelf.includes(noneLabel) ? [noneLabel] : selectedSelf;
                    const filteredPartner = selectedPartner.includes(noneLabel) ? [noneLabel] : selectedPartner;
                    setAnswer('pain_self', filteredSelf);
                    setAnswer('pain_partner', filteredPartner);
                    // Geriye uyumluluk: tek alanı kendi (self) seçimiyle doldur
                    setAnswer('pain', filteredSelf);
                    const nextId = (question.options && question.options[0] && question.options[0].next) || 'softness';
                    return goTo(nextId, question.id);
                };
                rightCol.appendChild(nextBtn);
                // split already appended by createSplit
            } else {
                // Tek kişi için (eski davranış) — 4'lü grid kullan
                const grp = createPainCheckboxes(question.options, noneLabel);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.onclick = () => {
                    const selected = (grp.checkboxes || []).filter(c => c.checked).map(c => c.value);
                    if (!selected.length) {
                        alert('Lutfen en az bir seçenek seçin');
                        return;
                    }
                    // Güvenlik: "Hiçbir şey, gayet iyiyim" seçiliyse tek başına kalsın
                    const filtered = selected.includes(noneLabel) ? [noneLabel] : selected;
                    setAnswer('pain', filtered);
                    const nextId = (question.options[0] && question.options[0].next) || 'softness';
                    return goTo(nextId, question.id);
                };
                rightCol.appendChild(grp.wrapper);
                rightCol.appendChild(nextBtn);
                // split already appended by createSplit
            }
        } else if (question.id === 'sleep_hot') {
            if (quizState.partner) {
                const matrix = document.createElement('div');
                matrix.className = 'pain-matrix';
                const rows = [];
                const selected = { self: null, partner: null };
                const createCell = (who, optionLabel) => {
                    const cell = document.createElement('button');
                    cell.type = 'button';
                    cell.className = 'pain-matrix-cell';
                    cell.dataset.who = who;
                    cell.dataset.value = optionLabel;
                    const dot = document.createElement('span');
                    dot.className = 'pain-matrix-dot';
                    dot.setAttribute('aria-hidden', 'true');
                    cell.appendChild(dot);
                    cell.onclick = () => {
                        rows.forEach((item) => {
                            item[who].classList.remove('is-selected');
                        });
                        cell.classList.add('is-selected');
                        selected[who] = optionLabel;
                        if (nextBtn) nextBtn.disabled = !(selected.self && selected.partner);
                    };
                    return cell;
                };
                const header = document.createElement('div');
                header.className = 'pain-matrix-row pain-matrix-header';
                header.innerHTML = '<div class="pain-matrix-head-spacer"></div><div class="pain-matrix-col-head">Sen</div><div class="pain-matrix-col-head">Partnerin</div>';
                matrix.appendChild(header);
                (question.options || []).forEach((opt) => {
                    const row = document.createElement('div');
                    row.className = 'pain-matrix-row';
                    const label = document.createElement('div');
                    label.className = 'pain-matrix-label';
                    label.textContent = opt.label;
                    const selfCell = createCell('self', opt.label);
                    const partnerCell = createCell('partner', opt.label);
                    row.appendChild(label);
                    row.appendChild(selfCell);
                    row.appendChild(partnerCell);
                    matrix.appendChild(row);
                    rows.push({ option: opt, self: selfCell, partner: partnerCell });
                });
                rightCol.appendChild(matrix);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.disabled = true;
                nextBtn.onclick = () => {
                    const selectedSelf = rows.find(r => r.self.classList.contains('is-selected'));
                    const selectedPartner = rows.find(r => r.partner.classList.contains('is-selected'));
                    if (!selectedSelf || !selectedPartner) return;
                    setAnswer('sleep_hot_self', selectedSelf.option.label);
                    setAnswer('sleep_hot_partner', selectedPartner.option.label);
                    setAnswer('sleep_hot', selectedSelf.option.label);
                    return goTo('pain', question.id);
                };
                rightCol.appendChild(nextBtn);
            } else {
                const wrapper = document.createElement('div');
                wrapper.className = 'choices multi pain-single-list';
                let selectedOption = null;
                const buttons = [];
                (question.options || []).forEach((opt) => {
                    const label = document.createElement('label');
                    label.className = 'choice-checkbox pain-option';
                    const span = document.createElement('span');
                    span.textContent = opt.label;
                    const cb = document.createElement('input');
                    cb.type = 'checkbox';
                    cb.value = opt.label;
                    label.appendChild(span);
                    label.appendChild(cb);
                    label.onclick = (event) => {
                        event.preventDefault();
                        buttons.forEach((item) => {
                            item.checkbox.checked = false;
                            item.label.classList.remove('checked');
                        });
                        cb.checked = true;
                        label.classList.add('checked');
                        selectedOption = opt;
                        if (nextBtn) nextBtn.disabled = false;
                    };
                    buttons.push({ label, checkbox: cb });
                    wrapper.appendChild(label);
                });
                rightCol.appendChild(wrapper);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.disabled = true;
                nextBtn.onclick = () => {
                    if (!selectedOption) return;
                    setAnswer('sleep_hot', selectedOption.label);
                    setAnswer('sleep_hot_self', selectedOption.label);
                    return goTo(selectedOption.next, question.id);
                };
                rightCol.appendChild(nextBtn);
            }
        } else if (question.id === 'allergy_sensitivity') {
            if (quizState.partner) {
                const matrix = document.createElement('div');
                matrix.className = 'pain-matrix';
                const rows = [];
                const selected = { self: null, partner: null };
                const createCell = (who, optionLabel) => {
                    const cell = document.createElement('button');
                    cell.type = 'button';
                    cell.className = 'pain-matrix-cell';
                    cell.dataset.who = who;
                    cell.dataset.value = optionLabel;
                    const dot = document.createElement('span');
                    dot.className = 'pain-matrix-dot';
                    dot.setAttribute('aria-hidden', 'true');
                    cell.appendChild(dot);
                    cell.onclick = () => {
                        rows.forEach((item) => {
                            item[who].classList.remove('is-selected');
                        });
                        cell.classList.add('is-selected');
                        selected[who] = optionLabel;
                        if (nextBtn) nextBtn.disabled = !(selected.self && selected.partner);
                    };
                    return cell;
                };
                const header = document.createElement('div');
                header.className = 'pain-matrix-row pain-matrix-header';
                header.innerHTML = '<div class="pain-matrix-head-spacer"></div><div class="pain-matrix-col-head">Sen</div><div class="pain-matrix-col-head">Partnerin</div>';
                matrix.appendChild(header);
                (question.options || []).forEach((opt) => {
                    const row = document.createElement('div');
                    row.className = 'pain-matrix-row';
                    const label = document.createElement('div');
                    label.className = 'pain-matrix-label';
                    label.textContent = opt.label;
                    const selfCell = createCell('self', opt.label);
                    const partnerCell = createCell('partner', opt.label);
                    row.appendChild(label);
                    row.appendChild(selfCell);
                    row.appendChild(partnerCell);
                    matrix.appendChild(row);
                    rows.push({ option: opt, self: selfCell, partner: partnerCell });
                });
                rightCol.appendChild(matrix);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.disabled = true;
                nextBtn.onclick = () => {
                    const selectedSelf = rows.find(r => r.self.classList.contains('is-selected'));
                    const selectedPartner = rows.find(r => r.partner.classList.contains('is-selected'));
                    if (!selectedSelf || !selectedPartner) return;
                    setAnswer(`${question.id}_self`, selectedSelf.option.label);
                    setAnswer(`${question.id}_partner`, getPartnerDirectedLabel(question.id, selectedPartner.option.label));
                    setAnswer(question.id, selectedSelf.option.label);
                    return goTo((question.options && question.options[0] && question.options[0].next) || 'pillow_pref', question.id);
                };
                rightCol.appendChild(nextBtn);
            } else {
                const wrapper = document.createElement('div');
                wrapper.className = 'choices multi pain-single-list';
                let selectedOption = null;
                const buttons = [];
                (question.options || []).forEach((opt) => {
                    const label = document.createElement('label');
                    label.className = 'choice-checkbox pain-option';
                    const span = document.createElement('span');
                    span.textContent = opt.label;
                    const cb = document.createElement('input');
                    cb.type = 'checkbox';
                    cb.value = opt.label;
                    cb.dataset.next = opt.next || '';
                    label.appendChild(span);
                    label.appendChild(cb);
                    label.onclick = (event) => {
                        event.preventDefault();
                        buttons.forEach((item) => {
                            item.checkbox.checked = false;
                            item.label.classList.remove('checked');
                        });
                        cb.checked = true;
                        label.classList.add('checked');
                        selectedOption = opt;
                        if (nextBtn) nextBtn.disabled = false;
                    };
                    buttons.push({ label, checkbox: cb });
                    wrapper.appendChild(label);
                });
                rightCol.appendChild(wrapper);
                const nextBtn = document.createElement('button');
                nextBtn.textContent = 'Devam';
                nextBtn.className = 'quiz-button quiz-next';
                nextBtn.disabled = true;
                nextBtn.onclick = () => {
                    if (!selectedOption) return;
                    setAnswer(question.id, selectedOption.label);
                    return goTo(selectedOption.next, question.id);
                };
                rightCol.appendChild(nextBtn);
            }
        } else if (question.id === 'pillow_pref') {
            const sel = { height: null, firm: null };
            // Daha kompakt 3 sütun düzeni için sınıf
            rightCol.classList.add('pillow-compact');
            const addGroup = (titleText, opts, key) => {
                const h3 = document.createElement('h3');
                h3.textContent = titleText || '';
                rightCol.appendChild(h3);
                const wrap = document.createElement('div');
                wrap.className = 'choices';
                wrap.classList.add('choices-triple');
                const btns = [];
                (opts || []).forEach((label) => {
                    const btn = document.createElement('button');
                    btn.textContent = label;
                    btn.className = 'quiz-button';
                    btn.onclick = () => {
                        btns.forEach(b => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        if (key === 'height') sel.height = label;
                        if (key === 'firm') sel.firm = label;
                        if (nextBtn) nextBtn.disabled = !(sel.height && sel.firm);
                    };
                    btns.push(btn);
                    wrap.appendChild(btn);
                });
                rightCol.appendChild(wrap);
            };
            const hTitle = question.groupTitle1 || 'Yukseklik';
            const fTitle = question.groupTitle2 || 'Sertlik';
            const hOpts = question.heightOptions || ['Yuksek', 'Orta', 'Alcak'];
            const fOpts = question.firmnessOptions || ['Sert', 'Orta', 'Yumuşak'];
            addGroup(hTitle, hOpts, 'height');
            addGroup(fTitle, fOpts, 'firm');
            const nextBtn = document.createElement('button');
            nextBtn.textContent = 'Devam';
            nextBtn.className = 'quiz-button quiz-next';
            nextBtn.disabled = true;
            nextBtn.onclick = () => {
                if (!(sel.height && sel.firm)) return;
                setAnswer('pillow_height', sel.height);
                setAnswer('pillow_firmness', sel.firm);
                setAnswer('pillow_pref', sel.height);
                const nextId = quizState.partner ? 'partner_pillow_pref' : 'bed_look_pref';
                return goTo(nextId, question.id);
            };
            rightCol.appendChild(nextBtn);
            // split already appended by createSplit
        } else if (question.id === 'partner_pillow_pref') {
            const sel = { height: null, firm: null };
            rightCol.classList.add('pillow-compact');
            const addGroup = (titleText, opts, key) => {
                const h3 = document.createElement('h3');
                h3.textContent = titleText || '';
                rightCol.appendChild(h3);
                const wrap = document.createElement('div');
                wrap.className = 'choices';
                const btns = [];
                (opts || []).forEach((label) => {
                    const btn = document.createElement('button');
                    btn.textContent = label;
                    btn.className = 'quiz-button';
                    btn.onclick = () => {
                        btns.forEach(b => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        if (key === 'height') sel.height = label;
                        if (key === 'firm') sel.firm = label;
                        if (nextBtn) nextBtn.disabled = !(sel.height && sel.firm);
                    };
                    btns.push(btn);
                    wrap.appendChild(btn);
                });
                rightCol.appendChild(wrap);
            };
            const hTitle = question.groupTitle1 || 'Yukseklik';
            const fTitle = question.groupTitle2 || 'Sertlik';
            const hOpts = question.heightOptions || ['Yuksek', 'Orta', 'Alcak'];
            const fOpts = question.firmnessOptions || ['Sert', 'Orta', 'Yumuşak'];
            addGroup(hTitle, hOpts, 'height');
            addGroup(fTitle, fOpts, 'firm');
            const nextBtn = document.createElement('button');
            nextBtn.textContent = 'Devam';
            nextBtn.className = 'quiz-button quiz-next';
            nextBtn.disabled = true;
            nextBtn.onclick = () => {
                if (!(sel.height && sel.firm)) return;
                setAnswer('pillow_height_partner', sel.height);
                setAnswer('pillow_firmness_partner', sel.firm);
                if (sel.height) setAnswer('pillow_pref_partner', sel.height);
                return goTo('bed_look_pref', question.id);
            };
            rightCol.appendChild(nextBtn);
            // split already appended by createSplit
        } else {
            const wrapper = document.createElement('div');
            wrapper.className = 'choices';
            let whoForSelectedOption = null;
            const whoForButtons = [];
            let partnerSelectedOption = null;
            const partnerButtons = [];
            let sleepReasonSelectedOption = null;
            const sleepReasonButtons = [];
            let springPrefSelectedOption = null;
            const springPrefButtons = [];
            let bedLookSelectedOption = null;
            const bedLookButtons = [];
            let bedSideSelectedOption = null;
            const bedSideButtons = [];
            let sleepPositionSelectedOption = null;
            const sleepPositionButtons = [];
            let sleepPositionPartnerSelectedOption = null;
            const sleepPositionPartnerButtons = [];
            let childFurnitureTypeSelectedOption = null;
            const childFurnitureTypeButtons = [];
            if (question.id === 'sleep_position' || question.id === 'sleep_position_partner') {
                wrapper.classList.add('who-for-choices');
                rightCol.classList.add('who-for-step');
            } else if (question.id === 'child_furniture_type') {
                wrapper.classList.add('who-for-choices', 'child-furniture-choices');
                rightCol.classList.add('who-for-step');
            } else if (question.id === 'mattress_size') {
                wrapper.classList.add('choices-pills');
            } else if (question.id === 'who_for') {
                wrapper.classList.add('who-for-choices');
                rightCol.classList.add('who-for-step');
            } else if (question.id === 'bed_side') {
                wrapper.classList.add('who-for-choices');
            } else if (question.id === 'partner') {
                wrapper.classList.add('partner-choice-list');
            } else if (question.id === 'sleep_env_issues') {
                wrapper.classList.add('partner-choice-list');
            } else if (question.id === 'spring_preference') {
                wrapper.classList.add('partner-choice-list');
            } else if (question.id === 'bed_look_pref') {
                wrapper.classList.add('partner-choice-list');
            } else if (question.listStyleWithContinue) {
                wrapper.classList.add('partner-choice-list');
            }
            let renderedOptions = question.options || [];
            if (question.id === 'child_furniture_type') {
                const ageToAllowed = {
                    1: ['anne_yani', 'besik', 'montessori'],
                    2: ['besik', 'montessori'],
                    3: ['montessori', 'karyola'],
                    4: ['montessori', 'karyola'],
                    5: ['montessori', 'karyola'],
                    6: ['montessori', 'karyola'],
                    7: ['montessori', 'karyola'],
                    8: ['montessori', 'karyola'],
                    9: ['montessori', 'karyola'],
                    10: ['montessori', 'karyola'],
                    11: ['karyola'],
                    12: ['karyola'],
                };
                const monthsRaw = parseInt((quizState.answers && quizState.answers.child_age_months) || '', 10);
                const yearsRaw = parseInt((quizState.answers && quizState.answers.child_age) || '', 10);
                const derivedYears = Number.isFinite(monthsRaw) ? Math.floor(monthsRaw / 12) : yearsRaw;
                const clampedAge = Math.max(1, Math.min(12, Number.isFinite(derivedYears) ? derivedYears : 12));
                const allowedKeys = ageToAllowed[clampedAge] || ageToAllowed[12];
                const hasFurniture = (quizState.answers && quizState.answers.child_bed_furniture) === 'Evet';
                const labelToKey = (label) => {
                    const normalized = simplifyTurkishText(label || '');
                    if (normalized.includes('anne') || normalized.includes('park')) return 'anne_yani';
                    if (normalized.includes('besik')) return 'besik';
                    if (normalized.includes('montessori') || normalized.includes('yer yatagi')) return 'montessori';
                    if (normalized.includes('karyola') || normalized.includes('baza')) return 'karyola';
                    return 'other';
                };
                renderedOptions = renderedOptions.filter((opt) => {
                    if (simplifyTurkishText(opt.label || '').includes('karar vermed')) return !hasFurniture;
                    return allowedKeys.includes(labelToKey(opt.label));
                });
            }
            renderedOptions.forEach((opt) => {
                const btn = document.createElement('button');
                btn.className = 'quiz-button';
                let choiceIcon = CHOICE_ICON_URL;
                if (question.id === 'who_for') {
                    if (opt.value === 'adult') {
                        choiceIcon = WHO_FOR_SELF_ICON_URL;
                    } else if (opt.value === 'child') {
                        choiceIcon = WHO_FOR_CHILD_ICON_URL;
                    }
                } else if (question.id === 'partner') {
                    if (opt.value === 'partner') {
                        choiceIcon = PARTNER_WITH_ICON_URL;
                    } else {
                        choiceIcon = PARTNER_SOLO_ICON_URL;
                    }
                } else if (question.id === 'bed_side') {
                    const lower = (opt.label || '').toLowerCase();
                    choiceIcon = lower.includes('sağ') ? BED_SIDE_RIGHT_ICON_URL : BED_SIDE_LEFT_ICON_URL;
                } else if (question.id === 'sleep_position' || question.id === 'sleep_position_partner') {
                    choiceIcon = getSleepPositionIcon(opt.label);
                } else if (question.id === 'child_furniture_type') {
                    choiceIcon = getChildFurnitureIcon(opt.label);
                }
                if (question.id === 'partner' || question.id === 'sleep_env_issues' || question.id === 'spring_preference' || question.id === 'bed_look_pref' || question.listStyleWithContinue) {
                    btn.classList.add('partner-choice-option');
                    const label = document.createElement('span');
                    label.className = 'partner-choice-label';
                    label.textContent = opt.label;
                    const indicator = document.createElement('span');
                    indicator.className = 'partner-choice-indicator';
                    btn.appendChild(label);
                    btn.appendChild(indicator);
                } else if (question.id !== 'mattress_size') {
                    const img = document.createElement('img');
                    img.className = 'choice-img';
                    img.src = choiceIcon;
                    img.alt = '';
                    if (question.id === 'who_for' || question.id === 'bed_side' || question.id === 'sleep_position' || question.id === 'sleep_position_partner' || question.id === 'child_furniture_type') {
                        btn.classList.add('who-for-option');
                        const indicator = document.createElement('span');
                        indicator.className = 'choice-select-indicator';
                        btn.appendChild(indicator);
                        const label = document.createElement('span');
                        label.className = 'choice-label-overlay';
                        label.textContent = opt.label;
                        btn.appendChild(img);
                        btn.appendChild(label);
                    } else {
                        btn.textContent = opt.label;
                        btn.prepend(img);
                    }
                } else {
                    btn.textContent = opt.label;
                }
                btn.onclick = () => {
                    // Özel durumlar
                    if (question.id === 'who_for') {
                        whoForButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        whoForSelectedOption = opt;
                        if (whoForNextBtn) whoForNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'partner') {
                        partnerButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        partnerSelectedOption = opt;
                        if (partnerNextBtn) partnerNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'sleep_env_issues') {
                        sleepReasonButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        sleepReasonSelectedOption = opt;
                        if (sleepReasonNextBtn) sleepReasonNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'spring_preference') {
                        springPrefButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        springPrefSelectedOption = opt;
                        if (springPrefNextBtn) springPrefNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'bed_look_pref') {
                        bedLookButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        bedLookSelectedOption = opt;
                        if (bedLookNextBtn) bedLookNextBtn.disabled = false;
                        return;
                    }
                    if (question.listStyleWithContinue) {
                        bedLookButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        bedLookSelectedOption = opt;
                        if (bedLookNextBtn) bedLookNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'bed_side') {
                        bedSideButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        bedSideSelectedOption = opt;
                        if (bedSideNextBtn) bedSideNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'sleep_position') {
                        sleepPositionButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        sleepPositionSelectedOption = opt;
                        if (sleepPositionNextBtn) sleepPositionNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'sleep_position_partner') {
                        sleepPositionPartnerButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        sleepPositionPartnerSelectedOption = opt;
                        if (sleepPositionPartnerNextBtn) sleepPositionPartnerNextBtn.disabled = false;
                        return;
                    }
                    if (question.id === 'child_furniture_type') {
                        childFurnitureTypeButtons.forEach((b) => b.classList.remove('selected'));
                        btn.classList.add('selected');
                        childFurnitureTypeSelectedOption = opt;
                        if (childFurnitureTypeNextBtn) childFurnitureTypeNextBtn.disabled = false;
                        return;
                    }
                    if (question.id) setAnswer(question.id, opt.label);
                    return goTo(opt.next, question.id);
                };
                if (question.id === 'who_for') {
                    whoForButtons.push(btn);
                }
                if (question.id === 'partner') {
                    partnerButtons.push(btn);
                }
                if (question.id === 'sleep_env_issues') {
                    sleepReasonButtons.push(btn);
                }
                if (question.id === 'spring_preference') {
                    springPrefButtons.push(btn);
                }
                if (question.id === 'bed_look_pref') {
                    bedLookButtons.push(btn);
                }
                if (question.listStyleWithContinue) {
                    bedLookButtons.push(btn);
                }
                if (question.id === 'bed_side') {
                    bedSideButtons.push(btn);
                }
                if (question.id === 'sleep_position') {
                    sleepPositionButtons.push(btn);
                }
                if (question.id === 'sleep_position_partner') {
                    sleepPositionPartnerButtons.push(btn);
                }
                if (question.id === 'child_furniture_type') {
                    childFurnitureTypeButtons.push(btn);
                }
                wrapper.appendChild(btn);
            });
            rightCol.appendChild(wrapper);
            let whoForNextBtn = null;
            let partnerNextBtn = null;
            let sleepReasonNextBtn = null;
            let springPrefNextBtn = null;
            let bedLookNextBtn = null;
            let bedSideNextBtn = null;
            let sleepPositionNextBtn = null;
            let sleepPositionPartnerNextBtn = null;
            let childFurnitureTypeNextBtn = null;
            if (question.id === 'who_for') {
                whoForNextBtn = document.createElement('button');
                whoForNextBtn.type = 'button';
                whoForNextBtn.textContent = 'DEVAM ET >';
                whoForNextBtn.className = 'quiz-button quiz-next who-for-next';
                whoForNextBtn.disabled = true;
                whoForNextBtn.onclick = () => {
                    if (!whoForSelectedOption) return;
                    const selectedValue = whoForSelectedOption.value;
                    if (selectedValue === 'adult' || selectedValue === 'child') {
                        quizState.audience = selectedValue;
                        setAnswer('audience', selectedValue);
                    } else {
                        const lower = (whoForSelectedOption.label || '').toLowerCase();
                        quizState.audience = lower.includes('çocu') ? 'child' : 'adult';
                        setAnswer('audience', quizState.audience);
                    }
                    return goTo(whoForSelectedOption.next, question.id);
                };
                rightCol.appendChild(whoForNextBtn);
            } else if (question.id === 'partner') {
                partnerNextBtn = document.createElement('button');
                partnerNextBtn.type = 'button';
                partnerNextBtn.textContent = 'Devam et';
                partnerNextBtn.className = 'quiz-button quiz-next partner-next';
                partnerNextBtn.disabled = true;
                partnerNextBtn.onclick = () => {
                    if (!partnerSelectedOption) return;
                    const isPartnerFlow = partnerSelectedOption.value === 'partner';
                    if (isPartnerFlow) {
                        if (!quizState.partner) quizState.partner = {};
                        setAnswer('partner', quizState.partner);
                    } else {
                        try { delete quizState.partner; } catch (e) { }
                        try { if (quizState.answers) delete quizState.answers.partner; } catch (e) { }
                    }
                    return goTo('sleep_env_issues', question.id);
                };
                rightCol.appendChild(partnerNextBtn);
            } else if (question.id === 'sleep_env_issues') {
                sleepReasonNextBtn = document.createElement('button');
                sleepReasonNextBtn.type = 'button';
                sleepReasonNextBtn.textContent = 'Devam et';
                sleepReasonNextBtn.className = 'quiz-button quiz-next partner-next';
                sleepReasonNextBtn.disabled = true;
                sleepReasonNextBtn.onclick = () => {
                    if (!sleepReasonSelectedOption) return;
                    setAnswer('sleep_env_issues', sleepReasonSelectedOption.label);
                    const nextId = quizState.partner ? 'partner_both' : 'self_form';
                    return goTo(nextId, question.id);
                };
                rightCol.appendChild(sleepReasonNextBtn);
            } else if (question.id === 'spring_preference') {
                springPrefNextBtn = document.createElement('button');
                springPrefNextBtn.type = 'button';
                springPrefNextBtn.textContent = 'Devam et';
                springPrefNextBtn.className = 'quiz-button quiz-next partner-next';
                springPrefNextBtn.disabled = true;
                springPrefNextBtn.onclick = () => {
                    if (!springPrefSelectedOption) return;
                    setAnswer('spring_preference', springPrefSelectedOption.label);
                    return goTo(springPrefSelectedOption.next, question.id);
                };
                rightCol.appendChild(springPrefNextBtn);
            } else if (question.id === 'bed_look_pref' || question.listStyleWithContinue) {
                bedLookNextBtn = document.createElement('button');
                bedLookNextBtn.type = 'button';
                bedLookNextBtn.textContent = 'Devam et';
                bedLookNextBtn.className = 'quiz-button quiz-next partner-next';
                bedLookNextBtn.disabled = true;
                bedLookNextBtn.onclick = () => {
                    if (!bedLookSelectedOption) return;
                    setAnswer(question.id, bedLookSelectedOption.label);
                    return goTo(bedLookSelectedOption.next, question.id);
                };
                rightCol.appendChild(bedLookNextBtn);
            } else if (question.id === 'bed_side') {
                bedSideNextBtn = document.createElement('button');
                bedSideNextBtn.type = 'button';
                bedSideNextBtn.textContent = 'Devam et';
                bedSideNextBtn.className = 'quiz-button quiz-next who-for-next';
                bedSideNextBtn.disabled = true;
                bedSideNextBtn.onclick = () => {
                    if (!bedSideSelectedOption) return;
                    quizState.bedSide = bedSideSelectedOption.label;
                    setAnswer('bed_side', bedSideSelectedOption.label);
                    return goTo(bedSideSelectedOption.next, question.id);
                };
                rightCol.appendChild(bedSideNextBtn);
            } else if (question.id === 'sleep_position') {
                sleepPositionNextBtn = document.createElement('button');
                sleepPositionNextBtn.type = 'button';
                sleepPositionNextBtn.textContent = 'Devam et';
                sleepPositionNextBtn.className = 'quiz-button quiz-next who-for-next';
                sleepPositionNextBtn.disabled = true;
                sleepPositionNextBtn.onclick = () => {
                    if (!sleepPositionSelectedOption) return;
                    setAnswer('sleep_position_self', sleepPositionSelectedOption.label);
                    setAnswer('sleep_position', sleepPositionSelectedOption.label);
                    const nextId = quizState.partner ? 'sleep_position_partner' : sleepPositionSelectedOption.next;
                    return goTo(nextId, question.id);
                };
                rightCol.appendChild(sleepPositionNextBtn);
            } else if (question.id === 'sleep_position_partner') {
                sleepPositionPartnerNextBtn = document.createElement('button');
                sleepPositionPartnerNextBtn.type = 'button';
                sleepPositionPartnerNextBtn.textContent = 'Devam et';
                sleepPositionPartnerNextBtn.className = 'quiz-button quiz-next who-for-next';
                sleepPositionPartnerNextBtn.disabled = true;
                sleepPositionPartnerNextBtn.onclick = () => {
                    if (!sleepPositionPartnerSelectedOption) return;
                    setAnswer('sleep_position_partner', sleepPositionPartnerSelectedOption.label);
                    return goTo(sleepPositionPartnerSelectedOption.next, question.id);
                };
                rightCol.appendChild(sleepPositionPartnerNextBtn);
            } else if (question.id === 'child_furniture_type') {
                childFurnitureTypeNextBtn = document.createElement('button');
                childFurnitureTypeNextBtn.type = 'button';
                childFurnitureTypeNextBtn.textContent = 'Devam et';
                childFurnitureTypeNextBtn.className = 'quiz-button quiz-next who-for-next';
                childFurnitureTypeNextBtn.disabled = true;
                childFurnitureTypeNextBtn.onclick = () => {
                    if (!childFurnitureTypeSelectedOption) return;
                    setAnswer('child_furniture_type', childFurnitureTypeSelectedOption.label);
                    return goTo(childFurnitureTypeSelectedOption.next, question.id);
                };
                rightCol.appendChild(childFurnitureTypeNextBtn);
            }
            // split already appended by createSplit
        }
    }
    if (question.type === 'child_name') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        renderTopbarProgress(rightCol, question.id);
        rightCol.classList.add('child-name-step');

        const imageWrap = document.createElement('div');
        imageWrap.className = 'child-name-image-wrap';
        const image = document.createElement('img');
        image.className = 'child-name-image';
        image.src = 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/babaay.png?v=1778744694';
        image.alt = '';
        imageWrap.appendChild(image);
        rightCol.appendChild(imageWrap);

        const inputWrap = document.createElement('div');
        inputWrap.className = 'sui-quiz-input-wrapper child-name-input-wrap';
        const input = document.createElement('input');
        input.type = 'text';
        input.placeholder = 'Adı';
        input.autocomplete = 'off';
        input.className = 'child-name-input';
        inputWrap.appendChild(input);
        rightCol.appendChild(inputWrap);

        const checkboxLabel = document.createElement('label');
        checkboxLabel.className = 'sui-quiz-checkbox child-name-checkbox';
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        const checkboxText = document.createElement('span');
        checkboxText.textContent = 'Henüz karar vermedim';
        checkboxLabel.appendChild(checkbox);
        checkboxLabel.appendChild(checkboxText);
        rightCol.appendChild(checkboxLabel);

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.textContent = 'Devam et';
        nextBtn.className = 'quiz-button quiz-next child-name-next';
        nextBtn.disabled = true;
        rightCol.appendChild(nextBtn);

        const syncChildNameStep = () => {
            const hasName = !!(input.value || '').trim();
            const undecided = !!checkbox.checked;
            if (hasName && undecided) {
                checkbox.checked = false;
            }
            input.disabled = !!checkbox.checked;
            if (checkbox.checked) {
                input.value = '';
            }
            nextBtn.disabled = !((input.value || '').trim() || checkbox.checked);
        };

        input.addEventListener('input', syncChildNameStep);
        checkbox.addEventListener('change', syncChildNameStep);
        syncChildNameStep();

        nextBtn.onclick = () => {
            const childName = toTitleCaseTr((input.value || '').trim());
            const undecided = !!checkbox.checked;
            if (!childName && !undecided) return;
            setAnswer('child_name', childName || null);
            setAnswer('child_name_unknown', undecided);
            goTo(question.next, question.id);
        };
    }
    if (question.type === 'child_bed_size') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        renderTopbarProgress(rightCol, question.id);
        rightCol.classList.add('child-bed-size-step');

        const ageRules = [
            { maxAge: 0.5, min: [40, 60] },
            { maxAge: 1.5, min: [60, 120] },
            { maxAge: 3, min: [70, 140] },
            { maxAge: 5, min: [80, 160] },
            { maxAge: 8, min: [80, 180] },
            { maxAge: 12, min: [90, 190] },
            { maxAge: 18, min: [90, 200] },
        ];
        const monthsRaw = parseInt((quizState.answers && quizState.answers.child_age_months) || '', 10);
        const yearsRaw = parseFloat((quizState.answers && quizState.answers.child_age) || '');
        const ageYears = Number.isFinite(monthsRaw)
            ? (monthsRaw / 12)
            : (Number.isFinite(yearsRaw) ? yearsRaw : 0);
        const matchedAgeRule = ageRules.find((rule) => ageYears <= rule.maxAge) || ageRules[ageRules.length - 1];
        const minWidthForAge = matchedAgeRule.min[0];
        const minLengthForAge = matchedAgeRule.min[1];

        const wrap = document.createElement('div');
        wrap.className = 'child-bed-size-fields';

        const widthSelect = document.createElement('select');
        widthSelect.className = 'info-input info-select child-bed-size-select';
        const widthPh = document.createElement('option');
        widthPh.value = '';
        widthPh.textContent = `Yatağın genişliğini seçin (${minWidthForAge} cm altı yaşa uygun değil)`;
        widthSelect.appendChild(widthPh);
        for (let v = 40; v <= 160; v += 1) {
            if (v < minWidthForAge) continue;
            const opt = document.createElement('option');
            opt.value = String(v);
            opt.textContent = `${v} cm`;
            widthSelect.appendChild(opt);
        }

        const lengthSelect = document.createElement('select');
        lengthSelect.className = 'info-input info-select child-bed-size-select';
        const lengthPh = document.createElement('option');
        lengthPh.value = '';
        lengthPh.textContent = `Yatağın boyunu seçin (${minLengthForAge} cm altı yaşa uygun değil)`;
        lengthSelect.appendChild(lengthPh);
        for (let v = 70; v <= 200; v += 1) {
            if (v < minLengthForAge) continue;
            const opt = document.createElement('option');
            opt.value = String(v);
            opt.textContent = `${v} cm`;
            lengthSelect.appendChild(opt);
        }

        wrap.appendChild(widthSelect);
        wrap.appendChild(lengthSelect);
        rightCol.appendChild(wrap);

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.textContent = 'Devam et';
        nextBtn.className = 'quiz-button quiz-next partner-next';
        nextBtn.disabled = true;
        rightCol.appendChild(nextBtn);

        const sync = () => {
            nextBtn.disabled = !(widthSelect.value && lengthSelect.value);
        };
        widthSelect.addEventListener('change', sync);
        lengthSelect.addEventListener('change', sync);
        sync();

        nextBtn.onclick = () => {
            if (!(widthSelect.value && lengthSelect.value)) return;
            const width = widthSelect.value;
            const length = lengthSelect.value;
            setAnswer('child_bed_width', `${width} cm`);
            setAnswer('child_bed_length', `${length} cm`);
            setAnswer('child_bed_size', `${width}x${length}`);
            goTo(question.next, question.id);
        };
    }
    if (question.type === 'child_birth_date') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        renderTopbarProgress(rightCol, question.id);
        rightCol.classList.add('child-birth-step');

        const picker = document.createElement('div');
        picker.className = 'child-birth-picker';

        const header = document.createElement('div');
        header.className = 'child-birth-header';
        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'child-birth-nav';
        prevBtn.textContent = '‹';
        const monthYearWrap = document.createElement('div');
        monthYearWrap.className = 'child-birth-month-year';
        const monthLabel = document.createElement('button');
        monthLabel.type = 'button';
        monthLabel.className = 'child-birth-month';
        const yearLabel = document.createElement('button');
        yearLabel.type = 'button';
        yearLabel.className = 'child-birth-year';
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'child-birth-nav';
        nextBtn.textContent = '›';
        header.appendChild(prevBtn);
        monthYearWrap.appendChild(monthLabel);
        monthYearWrap.appendChild(yearLabel);
        header.appendChild(monthYearWrap);
        header.appendChild(nextBtn);
        picker.appendChild(header);

        const daysRow = document.createElement('div');
        daysRow.className = 'child-birth-days';
        ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'].forEach((d) => {
            const el = document.createElement('span');
            el.textContent = d;
            daysRow.appendChild(el);
        });
        picker.appendChild(daysRow);

        const grid = document.createElement('div');
        grid.className = 'child-birth-grid';
        picker.appendChild(grid);
        rightCol.appendChild(picker);

        const valueText = document.createElement('div');
        valueText.className = 'child-birth-selected';
        valueText.textContent = 'Lütfen bir tarih seçin';
        rightCol.appendChild(valueText);

        const pickerHint = document.createElement('p');
        pickerHint.className = 'child-birth-hint';
        pickerHint.textContent = 'Aktif ay ve seneye tıklayarak seçim yapabilirsiniz.';
        rightCol.appendChild(pickerHint);

        const nextBtnAction = document.createElement('button');
        nextBtnAction.type = 'button';
        nextBtnAction.textContent = 'Devam et';
        nextBtnAction.className = 'quiz-button quiz-next';
        nextBtnAction.disabled = true;
        rightCol.appendChild(nextBtnAction);

        const today = new Date();
        let selectedDate = null;
        let cursorYear = today.getFullYear();
        let cursorMonth = today.getMonth();
        let calendarMode = 'day';
        const trMonths = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

        const formatIsoDate = (d) => {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${y}-${m}-${day}`;
        };

        const formatTrDate = (d) => {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            return `${dd}.${mm}.${d.getFullYear()}`;
        };

        const calcAgeParts = (birthDate) => {
            const now = new Date();
            let totalMonths = (now.getFullYear() - birthDate.getFullYear()) * 12 + (now.getMonth() - birthDate.getMonth());
            if (now.getDate() < birthDate.getDate()) {
                totalMonths -= 1;
            }
            totalMonths = Math.max(0, totalMonths);
            const years = Math.floor(totalMonths / 12);
            const months = totalMonths % 12;
            return { years, months, totalMonths };
        };

        const isSameDate = (a, b) =>
            a && b &&
            a.getFullYear() === b.getFullYear() &&
            a.getMonth() === b.getMonth() &&
            a.getDate() === b.getDate();

        const renderYearGrid = () => {
            grid.innerHTML = '';
            grid.classList.add('child-birth-grid-year');
            const nowYear = (new Date()).getFullYear();
            const minYear = nowYear - 15;
            const maxYear = nowYear + 1;
            for (let y = minYear; y <= maxYear; y += 1) {
                const cell = document.createElement('button');
                cell.type = 'button';
                cell.className = 'child-birth-day';
                cell.textContent = String(y);
                if (y === cursorYear) cell.classList.add('selected');
                cell.onclick = () => {
                    cursorYear = y;
                    calendarMode = 'day';
                    renderCalendar();
                };
                grid.appendChild(cell);
            }
        };

        const renderMonthGrid = () => {
            grid.innerHTML = '';
            grid.classList.add('child-birth-grid-month');
            trMonths.forEach((m, idx) => {
                const cell = document.createElement('button');
                cell.type = 'button';
                cell.className = 'child-birth-day child-birth-month-cell';
                cell.textContent = m.slice(0, 3);
                if (idx === cursorMonth) cell.classList.add('selected');
                cell.onclick = () => {
                    cursorMonth = idx;
                    calendarMode = 'day';
                    renderCalendar();
                };
                grid.appendChild(cell);
            });
        };

        const renderCalendar = () => {
            monthLabel.textContent = trMonths[cursorMonth];
            yearLabel.textContent = String(cursorYear);
            grid.innerHTML = '';
            grid.classList.remove('child-birth-grid-year', 'child-birth-grid-month');
            if (calendarMode === 'year') return renderYearGrid();
            if (calendarMode === 'month') return renderMonthGrid();
            const firstOfMonth = new Date(cursorYear, cursorMonth, 1);
            const startWeekDay = firstOfMonth.getDay();
            const daysInMonth = new Date(cursorYear, cursorMonth + 1, 0).getDate();
            const prevMonthDays = new Date(cursorYear, cursorMonth, 0).getDate();
            const cells = 42;
            for (let i = 0; i < cells; i += 1) {
                const cell = document.createElement('button');
                cell.type = 'button';
                cell.className = 'child-birth-day';
                let dateObj = null;
                if (i < startWeekDay) {
                    const dayNum = prevMonthDays - startWeekDay + i + 1;
                    dateObj = new Date(cursorYear, cursorMonth - 1, dayNum);
                    cell.classList.add('muted');
                    cell.textContent = String(dayNum);
                } else if (i >= startWeekDay + daysInMonth) {
                    const dayNum = i - (startWeekDay + daysInMonth) + 1;
                    dateObj = new Date(cursorYear, cursorMonth + 1, dayNum);
                    cell.classList.add('muted');
                    cell.textContent = String(dayNum);
                } else {
                    const dayNum = i - startWeekDay + 1;
                    dateObj = new Date(cursorYear, cursorMonth, dayNum);
                    cell.textContent = String(dayNum);
                }
                if (isSameDate(dateObj, selectedDate)) {
                    cell.classList.add('selected');
                }
                cell.onclick = () => {
                    selectedDate = dateObj;
                    const age = calcAgeParts(selectedDate);
                    valueText.textContent = `${formatTrDate(selectedDate)} (Hesaplanan yaş: ${age.years} yıl ${age.months} ay)`;
                    nextBtnAction.disabled = false;
                    renderCalendar();
                };
                grid.appendChild(cell);
            }
        };

        prevBtn.onclick = () => {
            if (calendarMode === 'year') {
                return;
            } else if (calendarMode === 'month') {
                cursorYear -= 1;
            } else {
                cursorMonth -= 1;
                if (cursorMonth < 0) {
                    cursorMonth = 11;
                    cursorYear -= 1;
                }
            }
            renderCalendar();
        };
        nextBtn.onclick = () => {
            if (calendarMode === 'year') {
                return;
            } else if (calendarMode === 'month') {
                cursorYear += 1;
            } else {
                cursorMonth += 1;
                if (cursorMonth > 11) {
                    cursorMonth = 0;
                    cursorYear += 1;
                }
            }
            renderCalendar();
        };
        monthLabel.onclick = () => {
            calendarMode = calendarMode === 'month' ? 'day' : 'month';
            renderCalendar();
        };
        yearLabel.onclick = () => {
            calendarMode = calendarMode === 'year' ? 'day' : 'year';
            renderCalendar();
        };

        renderCalendar();

        nextBtnAction.onclick = () => {
            if (!selectedDate) return;
            const age = calcAgeParts(selectedDate);
            setAnswer('child_birth_date', formatIsoDate(selectedDate));
            setAnswer('child_age', String(age.years));
            setAnswer('child_age_months', String(age.totalMonths));
            setAnswer('child_age_display', `${age.years} yıl ${age.months} ay`);
            goTo(question.next, question.id);
        };
    }
    if (question.type === 'answer_slider') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        // Topbar + progress
        renderTopbarProgress(rightCol, question.id);
        const updateSliderProgress = (sliderEl) => {
            if (!sliderEl) return;
            const min = parseFloat(sliderEl.min);
            const max = parseFloat(sliderEl.max);
            const val = parseFloat(sliderEl.value);
            if (Number.isNaN(min) || Number.isNaN(max) || Number.isNaN(val) || max === min) return;
            const percent = ((val - min) / (max - min)) * 100;
            sliderEl.style.setProperty('--softness-progress', `${percent}%`);
        };
        const initializeSliderProgress = (sliderEl) => {
            if (!sliderEl) return;
            const handler = () => updateSliderProgress(sliderEl);
            sliderEl.addEventListener('input', handler);
            updateSliderProgress(sliderEl);
        };
        const createSoftnessVisual = (slider) => {
            const sliderBlock = document.createElement('div');
            sliderBlock.className = 'softness-slider-block';
            const iconConfig = [
                {
                    label: 'Yumuşak',
                    count: 1,
                    icon: 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/sad.png?v=1761030732',
                },
                {
                    label: 'Orta',
                    count: 1,
                    icon: 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/dsad.png?v=1761030732',
                },
                {
                    label: 'Sert',
                    count: 1,
                    icon: 'https://cdn.shopify.com/s/files/1/0044/8718/4457/files/sads.png?v=1761030731',
                },
            ];
            const labelsRow = document.createElement('div');
            labelsRow.className = 'softness-labels';
            iconConfig.forEach((item) => {
                const span = document.createElement('span');
                span.textContent = item.label;
                labelsRow.appendChild(span);
            });
            sliderBlock.appendChild(labelsRow);
            const iconsRow = document.createElement('div');
            iconsRow.className = 'softness-icons';
            iconConfig.forEach((item) => {
                const iconWrap = document.createElement('div');
                iconWrap.className = 'softness-icon';
                for (let i = 0; i < item.count; i += 1) {
                    const img = document.createElement('img');
                    img.src = item.icon || CHOICE_ICON_URL;
                    img.alt = '';
                    iconWrap.appendChild(img);
                }
                iconsRow.appendChild(iconWrap);
            });
            sliderBlock.appendChild(iconsRow);
            const rangeWrap = document.createElement('div');
            rangeWrap.className = 'softness-range';
            rangeWrap.appendChild(slider);
            sliderBlock.appendChild(rangeWrap);
            const expectation = document.createElement('div');
            expectation.className = 'softness-expectation';
            expectation.textContent = getSoftnessExpectationText(slider.value);
            slider.addEventListener('input', () => {
                expectation.textContent = getSoftnessExpectationText(slider.value);
            });
            sliderBlock.appendChild(expectation);
            initializeSliderProgress(slider);
            return sliderBlock;
        };
        // Softness için partner varsa çiftli slider arayüzü
        if (question.id === 'softness' && quizState.partner) {
            rightCol.classList.add('softness-scale');
            const wrap = document.createElement('div');
            wrap.className = 'softness-dual';
            const makeGroup = (titleText) => {
                const grp = document.createElement('div');
                grp.className = 'softness-group softness-single';
                const h3 = document.createElement('h3');
                h3.textContent = titleText;
                grp.appendChild(h3);
                const sld = document.createElement('input');
                sld.type = 'range';
                sld.min = question.min;
                sld.max = question.max;
                sld.step = question.step || 1;
                // Orta değere başlat (3), mümkün değilse min
                sld.value = (parseInt(question.min, 10) <= 3 && parseInt(question.max, 10) >= 3) ? '3' : String(question.min);
                sld.className = 'quiz-slider';
                const sliderBlock = createSoftnessVisual(sld);
                grp.appendChild(sliderBlock);
                return { grp, sld };
            };
            const gSelf = makeGroup('Siz');
            const gPartner = makeGroup('Partneriniz');
            wrap.appendChild(gSelf.grp);
            wrap.appendChild(gPartner.grp);
            rightCol.appendChild(wrap);
            const nextBtn = document.createElement('button');
            nextBtn.textContent = 'Devam';
            nextBtn.className = 'quiz-button quiz-next';
            nextBtn.onclick = () => {
                const mapSoft = (val) => {
                    const n = parseInt(val, 10) || 3;
                    const lbl = numericSoftnessToLabel(n);
                    return { n, lbl };
                };
                const selfMap = mapSoft(gSelf.sld.value);
                const partnerMap = mapSoft(gPartner.sld.value);
                setAnswer('softness_self', String(selfMap.n));
                setAnswer('softness_label_self', selfMap.lbl);
                setAnswer('softness_partner', String(partnerMap.n));
                setAnswer('softness_label_partner', partnerMap.lbl);
                // Geriye uyum için tekil alanları self ile set et
                setAnswer('softness', String(selfMap.n));
                setAnswer('softness_label', selfMap.lbl);
                const isChild = quizState.audience === 'child';
                const nextId = isChild ? 'end' : 'spring_preference';
                return goTo(nextId, question.id);
            };
            rightCol.appendChild(nextBtn);
            // split already appended by createSplit
        } else {
            const slider = document.createElement('input');
            slider.type = 'range';
            slider.min = question.min;
            slider.max = question.max;
            slider.step = question.step || 1;
            const defaultValue = (question.id === 'softness' && parseInt(question.min, 10) <= 3 && parseInt(question.max, 10) >= 3)
                ? '3'
                : String(question.min);
            slider.value = defaultValue;
            slider.className = 'quiz-slider';
            const nextBtn = document.createElement('button');
            nextBtn.textContent = 'Devam';
            nextBtn.className = 'quiz-button quiz-next';
            if (question.id === 'softness') {
                rightCol.classList.add('softness-single');
                const sliderBlock = createSoftnessVisual(slider);
                rightCol.appendChild(sliderBlock);
                nextBtn.onclick = () => {
                    const n = parseInt(slider.value, 10) || 3;
                    const label = numericSoftnessToLabel(n);
                    setAnswer('softness', String(n));
                    setAnswer('softness_label', label);
                    const isChild = quizState.audience === 'child';
                    const nextId = isChild ? 'end' : 'spring_preference';
                    return goTo(nextId, question.id);
                };
            } else {
                const display = document.createElement('div');
                display.className = 'slider-value';
                display.textContent = `${slider.value} ${question.unit || ''}`;
                slider.addEventListener('input', () => {
                    display.textContent = `${slider.value} ${question.unit || ''}`;
                });
                rightCol.appendChild(slider);
                rightCol.appendChild(display);
                nextBtn.onclick = () => {
                    setAnswer(question.id, slider.value);
                    goTo(question.next, question.id);
                };
            }
            rightCol.appendChild(nextBtn);
            // split already appended by createSplit
        }
    }
    if (question.type === 'single_form') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        // Topbar + progress
        renderTopbarProgress(rightCol, question.id);
        rightCol.classList.add('info-form-mode');
        const form = document.createElement('div');
        form.className = 'info-form';
        const group = document.createElement('div');
        group.className = 'info-group';
        const heading = document.createElement('h3');
        heading.className = 'info-group-title';
        heading.textContent = 'Sizin,';
        group.appendChild(heading);
        const grid = document.createElement('div');
        grid.className = 'info-grid info-grid-single';
        const existingSelf = quizState.self || {};
        [
            { type: 'select', placeholder: 'Yaşınız', subject: 'self', field: 'age', min: 16, max: 90, step: 1 },
            { type: 'select', placeholder: 'Kilonuz', subject: 'self', field: 'weight', min: 40, max: 150, step: 1, unit: 'kg' },
            { type: 'select', placeholder: 'Boyunuz', subject: 'self', field: 'height', min: 140, max: 210, step: 1, unit: 'cm' },
        ].forEach((cfg) => {
            const { field, setValue } = createInfoField(cfg);
            const currentVal = Object.prototype.hasOwnProperty.call(existingSelf, cfg.field) ? existingSelf[cfg.field] : '';
            setValue(currentVal);
            grid.appendChild(field);
        });
        group.appendChild(grid);
        form.appendChild(group);
        rightCol.appendChild(form);
        const nextBtn = document.createElement('button');
        nextBtn.textContent = 'Devam';
        nextBtn.className = 'quiz-button quiz-next';
        nextBtn.onclick = () => {
            const collected = { self: {} };
            rightCol.querySelectorAll('.info-input').forEach((el) => {
                const subject = el.dataset.subject || 'self';
                const fieldName = el.dataset.field;
                if (!fieldName) return;
                if (!collected[subject]) collected[subject] = {};
                const value = el.tagName === 'SELECT' ? el.value : el.value.trim();
                collected[subject][fieldName] = value;
            });
            quizState.self = Object.assign({}, quizState.self || {}, collected.self || {});
            setAnswer('self', quizState.self);
            goTo(question.next, question.id);
        };
        rightCol.appendChild(nextBtn);
        // split already appended by createSplit
    }
    if (question.type === 'dual_form') {
        const { split, leftCol, rightCol } = createSplit(container, question);
        renderLeft(question, leftCol);
        // Topbar + progress
        renderTopbarProgress(rightCol, question.id);
        rightCol.classList.add('info-form-mode');
        const form = document.createElement('div');
        form.className = 'info-form info-form-dual';
        const groups = [
            {
                title: 'Sizin,',
                subject: 'self',
                data: quizState.self || {},
                placeholders: { age: 'Yaşınız', weight: 'Kilonuz', height: 'Boyunuz' },
            },
            {
                title: 'Partnerinizin,',
                subject: 'partner',
                data: quizState.partner || {},
                placeholders: { age: 'Yaşı', weight: 'Kilosu', height: 'Boyu' },
            },
        ];
        groups.forEach((groupCfg, idx) => {
            const groupEl = document.createElement('div');
            groupEl.className = 'info-group';
            const heading = document.createElement('h3');
            heading.className = 'info-group-title';
            heading.textContent = groupCfg.title;
            groupEl.appendChild(heading);
            const grid = document.createElement('div');
            grid.className = 'info-grid info-grid-single';
            const baseFields = [
                { type: 'select', placeholder: groupCfg.placeholders.age, field: 'age', min: 16, max: 90, step: 1 },
                { type: 'select', placeholder: groupCfg.placeholders.weight, field: 'weight', min: 40, max: 150, step: 1, unit: 'kg' },
                { type: 'select', placeholder: groupCfg.placeholders.height, field: 'height', min: 140, max: 210, step: 1, unit: 'cm' },
            ];
            baseFields.forEach((cfg) => {
                const fieldConfig = Object.assign({}, cfg, { subject: groupCfg.subject });
                const { field, setValue } = createInfoField(fieldConfig);
                const currentVal = Object.prototype.hasOwnProperty.call(groupCfg.data, cfg.field) ? groupCfg.data[cfg.field] : '';
                setValue(currentVal);
                grid.appendChild(field);
            });
            groupEl.appendChild(grid);
            form.appendChild(groupEl);
        });
        rightCol.appendChild(form);
        const nextBtn = document.createElement('button');
        nextBtn.textContent = 'Devam';
        nextBtn.className = 'quiz-button quiz-next';
        nextBtn.onclick = () => {
            const collected = { self: {}, partner: {} };
            rightCol.querySelectorAll('.info-input').forEach((el) => {
                const subject = el.dataset.subject || 'self';
                const fieldName = el.dataset.field;
                if (!fieldName) return;
                if (!collected[subject]) collected[subject] = {};
                const value = el.tagName === 'SELECT' ? el.value : el.value.trim();
                collected[subject][fieldName] = value;
            });
            quizState.self = Object.assign({}, quizState.self || {}, collected.self || {});
            quizState.partner = Object.assign({}, quizState.partner || {}, collected.partner || {});
            setAnswer('self', quizState.self);
            setAnswer('partner', quizState.partner);
            goTo(question.next, question.id);
        };
        rightCol.appendChild(nextBtn);
        // split already appended by createSplit
    }
    if (question.type === 'answer_text' || question.type === 'answer_email') {
        const split = document.createElement('div');
        split.className = 'quiz-split';
        const leftCol = document.createElement('div');
        leftCol.className = 'split-left';
        const rightCol = document.createElement('div');
        rightCol.className = 'split-right';
        const title = document.createElement('h2');
        title.textContent = question.text || '';
        leftCol.appendChild(title);
        const pdesc = document.createElement('p');
        pdesc.className = 'quiz-description';
        pdesc.textContent = question.description || DEFAULT_QUIZ_DESC;
        leftCol.appendChild(pdesc);
        split.appendChild(leftCol);
        // Topbar + progress
        renderTopbarProgress(rightCol, question.id);
        const input = document.createElement('input');
        input.type = question.type === 'answer_email' ? 'email' : 'text';
        input.placeholder = 'Yanıtınızı yazın';
        input.className = 'quiz-input';
        const nextBtn = document.createElement('button');
        nextBtn.textContent = 'Devam';
        nextBtn.className = 'quiz-button quiz-next';
        nextBtn.onclick = () => {
            if (question.type === 'answer_email' && !input.value.includes('@')) {
                alert('Lutfen geçerli bir e-posta adresi girin');
                return;
            }
            goTo(question.next, question.id);
        };
        rightCol.appendChild(input);
        rightCol.appendChild(nextBtn);
        split.appendChild(rightCol);
        container.appendChild(split);
    }
    if (question.type === 'end') {
        const loading = document.createElement('div');
        loading.className = 'results-loading';
        const heading = document.createElement('h1');
        heading.textContent = 'Derin Uykuya Hazır Ol!';
        loading.appendChild(heading);
        const subheading = document.createElement('p');
        subheading.className = 'results-loading-subtitle';
        subheading.textContent = 'Cevaplarınıza göre size en uygun uyku ürünlerini buluyoruz.';
        loading.appendChild(subheading);
        const progressTrack = document.createElement('div');
        progressTrack.className = 'results-loading-progress';
        const progressFill = document.createElement('span');
        progressFill.className = 'results-loading-progress-fill';
        progressTrack.appendChild(progressFill);
        loading.appendChild(progressTrack);
        container.appendChild(loading);
        const resultsBody = document.createElement('div');
        resultsBody.className = 'results-content';
        resultsBody.hidden = true;
        container.appendChild(resultsBody);
        const MIN_LOADING_DURATION = 5000;
        const revealResults = () => {
            if (!loading.isConnected) return;
            if (loading.parentElement) {
                loading.remove();
            }
            resultsBody.hidden = false;
            scrollQuizToTop();
            syncShopifyCustomer().catch((error) => {
                console.warn('[Quiz] Shopify customer sync error:', error);
            });
        };
        setTimeout(revealResults, MIN_LOADING_DURATION);
        renderResults(resultsBody).catch((e) => {
            console.warn('[Quiz] Results rendering failed:', e);
            resultsBody.innerHTML = '';
            const error = document.createElement('p');
            error.className = 'results-loading-error';
            error.textContent = 'Sonuçlar yüklenirken bir sorun oluştu. Lutfen tekrar deneyin.';
            resultsBody.appendChild(error);
        });
    }
    // Mount container into the page
    hoistContinueButtons(container);
    normalizeContinueButtons(container);
    moveMobileBackButtonToTopSlot(container);
    outer.appendChild(container);
    root.appendChild(outer);
}
document.addEventListener('DOMContentLoaded', () => {
    ensureSessionId();
    renderQuestion('email');
});
